import { store } from '../index'
import _Config from './Config'
import _LoginInfo from './LoginInfo'
import _JsCall from '../view/JsCall'
import _SVG from './SVG'
import axios from 'axios'
import Cookies from 'universal-cookie'
import { Buffer } from 'buffer'
import { toast } from 'react-toastify'
import io from 'socket.io-client'
import * as CryptoJS from 'crypto-js'
import { EncryptStorage } from 'encrypt-storage'
import notificationSuccess from '../assets/images/toastify-success.svg'
import notificationWarning from '../assets/images/toastify-warning.svg'
import notificationError from '../assets/images/toastify-error.svg'
import { AuthenticationDetails, CognitoUser, CognitoUserPool, CognitoRefreshToken } from 'amazon-cognito-identity-js'
import * as AWS from 'aws-sdk'
import jwt_decode from "jwt-decode"
// import cloneDeep from 'lodash/cloneDeep' ( temp comment)
import TooltipRsuite from '../view/Components/TooltipRsuite'
import { findAliasJson } from '../view/CustomeHooks/useBizConfig'
// JATIN 11/2/25 For Convert PDF To PNG
import * as pdfjsLib from "pdfjs-dist";
import { saveAs } from "file-saver";
import JSZip from "jszip";
pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.js";


window.Buffer = Buffer

export var Config = new _Config()
export var LoginInfo = new _LoginInfo()
export var JsCall = new _JsCall()
// JATIN 12/09/2024 3:13 PM
export var SVG = new _SVG()

export var socket = io.connect(Config.getSocketserver(), {
    transports: ["websocket"],
    reconnection: false,
})
export var apisocket = io.connect(Config.getAPISocketserver(), {
    transports: ["websocket"],
    reconnection: false,
})



//do not remove priyanshi --> 3/5/2025
// let socketconnected

// export const getSocket = () => {
//     if (!socketconnected) {
//         socketconnected = io.connect(Config.getSocketserver(), {
//             reconnection: true
//         })
//     }
//     return socketconnected
// };

// to check connection of socket
// return true / false
export function checkConnect() {
    return socket.connected
}

// export var url
// export var reqHeaders
// export var reqBody
// export var resHeaders
// export var resBody
export var s3sessoin
export var AWSService = AWS
export const pagelimit = [
    {
        "label": 20,
        "value": 20,
    },
    {
        "label": 50,
        "value": 50,
    },
    {
        "label": 100,
        "value": 100,
    },
    {
        "label": 500,
        "value": 500,
    },
    {
        "label": 1000,
        "value": 1000,
    }
]

// date formate
export const dateformate = [
    {
        "label": '09/01/2022 (DD/MM/YYYY)',
        "value": 7,
    },
    {
        "label": '2022-09-01 (YYYY-MM-DD)',
        "value": 1,
    },
    {
        "label": '9/1/2022 (MM/DD/YYYY)',
        "value": 2,
    },
    {
        "label": '9/1/22 (MM/DD/YY)',
        "value": 3,
    },
    {
        "label": '01-sep-22',
        "value": 4,
    },
    {
        "label": '22/09/01 (YY/MM/DD)',
        "value": 5,
    },
    {
        "label": '09/01/22 (MM/DD/YY)',
        "value": 6,
    },
]

// time formate
export const timeformat = [
    {
        "label": '1:01 AM - 11:59 PM',
        "value": 1,
    },
    {
        "label": '1:01-23:59',
        "value": 2,
    }
]

export const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export const allowdedFiles = [".doc", ".docx", ".pdf", ".xlsx", ".pptx", ".png", ".jpg"]

export const allowdedAudio = [".mp3", ".flac", '.alac', '.pcm', '.wav', '.wma', '.aac', '.aiff', '.mpeg', '.ogg', '.m4a'] //  | Om Z  🌝🌝🌝 ~ 2024-10-16 ~ 11:56 AM

// 9/12/2022 hemang
export const allowdedImage = {
    'png': '.png',
    'jpg': '.jpg',
    'jpeg': '.jpeg',
    'gif': '.gif',
    'svg': '.svg',
}

export const wordExtensions = [".doc", ".docx"]

export const pptExtensions = [".ppt", ".pptm", ".pptx"]

export const exexlExtensions = [".xlsx", ".xls"]

export const textExtensions = [".txt"]

export const allowdedVideoFiles = [".mov", ".MOV", ".wmv", ".avi", ".mp4", ".avchd", ".flv", ".f4v", ".swf", ".mkv", ".webm"]

export const allowdedDocuments = {
    'pdf': '.pdf',
    'word': wordExtensions,
    'exel': exexlExtensions,
    'ppt': pptExtensions,
    'video': allowdedVideoFiles,
    'text': textExtensions
}
// 9/12/2022 hemang

export const allowdedCodeFiles = {
    'php': '.php',
}

// [".png" , ".jpg", ".jpeg", ".gif" , ".svg" ]

export async function setS3Session(s3_Sessoin) {
    s3sessoin = s3_Sessoin
}

// export async function setReqParams(URL, reqbody) {

//     const tempurl = URL
//     const includesUrl = Config.reqUrlArr?.some(path => tempurl?.includes(path))
//     //for replace weburl with pmsweburl in some api
//     if (includesUrl) {
//         url = tempurl.replace(Config.weburl, Config.pmsweburl)
//     }
//     else {
//         url = URL
//     }
//     reqBody = reqbody
// }




// java script class
class _IISMethods {

    constructor() {
    }

    getCurrentState() {
        return store.getState()
    }

    /******************************************************************  Hard Refresh Start      *******************************************************************/
    HardRefresh() {

        // cache busting: Reliable but modifies URL
        var queryParams = new URLSearchParams(window.location.search);
        queryParams.set(`${this.generateRandomIv(2)}`, new Date().getTime());
        var query = queryParams.toString();
        // query logic not working every time
        // window.location.search = query;  // navigates
        if (IISMethods.getpagename() == Config.homealias) {
            window.location.href = '/masters'
        }
        else {
            window.location.href = Config.homealias
        }
    }

    /******************************************************************  Hard Refresh End      *******************************************************************/

    // get OS Details
    // to get user device os
    getOSDetail() {
        let userAgent = window.navigator.userAgent
        let macosPlatforms = /(Macintosh|MacIntel|MacPPC|Mac68K)/i
        let windowsPlatforms = /(Win32|Win64|Windows|WinCE)/i
        let iosPlatforms = /(iPhone|iPad|iPod)/i
        let os = null

        if (macosPlatforms.test(userAgent)) {
            os = 'Mac OS'
        }
        else if (iosPlatforms.test(userAgent)) {
            os = 'iOS'
        }
        else if (windowsPlatforms.test(userAgent)) {
            os = 'Windows'
        }
        else if (/Android/i.test(userAgent)) {
            os = 'Android'
        }
        else if (!os && /Linux/i.test(userAgent)) {
            os = 'Linux'
        }

        return os
    }

    /********************************************************************** Cookie & Local Storage Methods Start***********************************************************************/

    // ********************************************************************** COOCKIE METHODS START **********************************************************************

    /**
     * set Cookie data 
     * @param {String} key 
     * @param {Any} value 
     * @param {String} path do not change
     */
    //  setCookiesData(key, value, path = '/') {
    //     try {
    //         const cookies = new Cookies()
    //         // cookie max age 24 hr
    //         // , maxAge: 12 * 60 * 60
    //         // remove max age for log in all time
    //         cookies.set(key, value, { path: path , maxAge: 12 * 60 * 60})
    //     } catch (err) {
    //         console.log(err)
    //     }
    // }
    setCookiesData(key, value, path = '/') {
        try {
            const cookies = new Cookies()
            const loginData = this.getLocalData("loginCredentials")
            // cookie max age 24 hr
            // , maxAge: 12 * 60 * 60
            // remove max age for log in all time

            if (loginData?.rememberme) {
                //731 days cookie expire time
                cookies.set(key, value, { path: path, maxAge: 1735707600 })
            } else {
                cookies.set(key, value, { path: path, maxAge: 12 * 60 * 60 })
            }
        } catch (err) {
            console.error(err)
        }
    }

    /**
     * get Cookie data
     * @param {String} key 
     * @returns 
     */
    getCookiesData(key) {
        const cookies = new Cookies()
        return cookies.get(key)
    }

    /**
     * clear cookie used in logout method
     * @param {String} key 
     * @param {String} path do not change
     */
    clearCookiesData(key, path = '/') {
        const cookies = new Cookies()
        cookies.remove(key, { path: path })
    }

    // ********************************************************************** COOCKIE METHODS END *******************************************************************

    // ********************************************************************** Session Storage METHODS START *******************************************************************
    /**
     * set Session Storage 
     * @param {String} key 
     * @param {Any} value 
     */
    setSessionData(key, value) {
        if (Config.encryptStorage) {
            //priyanshi changed prefix of session data
            let encryptStorage1 = new EncryptStorage('secret-key-value', {
                prefix: '@bizcompass',
                storageType: 'sessionStorage',
            });
            encryptStorage1.setItem(key, JSON.stringify(value))
        }
        else {
            try {
                sessionStorage.setItem(key, JSON.stringify(value))
            } catch (err) {
            }
        }

    }

    /**
     * get Session Storage
     * @param {String} key 
     * @returns 
     */
    getSessionData(key) {
        if (Config.encryptStorage) {
            //priyanshi changed prefix of session data
            let encryptStorage1 = new EncryptStorage('secret-key-value', {
                prefix: '@bizcompass',
                storageType: 'sessionStorage',
            });
            let storage = encryptStorage1.getItem(key)
            return storage ? storage : {}
        }
        else {
            return sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : {}
        }
    }

    /**
     * clear Session used in logout method
     * @param {String} key 
     * clearing session data on prod changes | Aman -（︶^︶） ~  2025-06-26 ~ 10:31 AM
     */
    clearSessionData(key) {
        if (Config.encryptStorage) { // For clearing session data with prefix | Aman - （︶^︶） ~  2025-06-26 ~ 10:39 AM 
            //priyanshi changed prefix of session data
            let encryptStorage1 = new EncryptStorage('secret-key-value', {
                prefix: '@bizcompass',
                storageType: 'sessionStorage',
            })
            encryptStorage1.removeItem(key)
        }
        else {
            try {
                sessionStorage.removeItem(key)
            } catch (error) {
                console.log(error)
            }
        }
    }

    // ********************************************************************** Session Storage METHODS END *******************************************************************

    // ********************************************************************** LOCALSTORAGE METHODS START ***************************************************************

    /**
     * set LocalStorage
     * @param {String} key 
     * @param {Any} value 
     */
    setLocalData(key, value) {
        // if(this.getpagename() == '' || this.getpagename() == 'home' || this.getpagename() == 'login'){
        //     try{
        //         // encrypt local storage
        //         localStorage.setItem(key, JSON.stringify(value))
        //         let encrypteddata = this.encryptData(value)
        //         localStorage.setItem(key,encrypteddata)
        //     }
        //     catch(e){
        //         localStorage.setItem(key, JSON.stringify(value))
        //     }
        // }
        // else{

        if (Config.encryptStorage && key == 'loginCredentials') {
            //priyanshi changed prefix of session data
            let encryptStorage1 = new EncryptStorage('secret-key-value', {
                prefix: '@bizcompass',
            });

            encryptStorage1.setItem(key, JSON.stringify(value))
        }
        else {
            localStorage.setItem(key, JSON.stringify(value))
        }
        // }
    }

    /**
     * get LocalStorage
     * @param {String} key 
     * @returns 
     */
    getLocalData(key) {

        // if(this.getpagename() == '' || this.getpagename() == 'home' || this.getpagename() == 'login' || this.getpagename() == 'recruitmentdashboard'){
        //     try{
        //         // 
        //         let decrypteddata = this.decryptData(localStorage.getItem(key) || '')
        //         return JSON.parse(decrypteddata)
        //     }
        //     catch(e){
        //         return JSON.parse(localStorage.getItem(key))
        //     }
        // }
        // else{
        if (Config.encryptStorage && key == 'loginCredentials') {
            //priyanshi changed prefix of session data
            let encryptStorage1 = new EncryptStorage('secret-key-value', {
                prefix: '@bizcompass',
            });
            let storage = encryptStorage1.getItem(key)
            return storage ? storage : null
        }
        else {
            const value = localStorage.getItem(key)
            // Check for key existence but undefined value
            if (localStorage.hasOwnProperty(key) && value === undefined) {
                localStorage.removeItem(key)
                return null
            }
            // Return raw value if undefined or null, avoid JSON.parse on undefined
            if (value === null || value === undefined) {
                return null
            }
            try {
                return JSON.parse(value)
            } catch (e) {
                console.error(`Failed to parse localStorage key "${key}":`, e)
                return value // Return raw string as fallback
            }
            // return JSON.parse(localStorage.getItem(key))
        }
        // }

        // try{
        //     // let decrypteddata = this.decryptDat
        //     // return JSON.parse(JSON.parse(decrypteddata)[key])
        //     return JSON.parse(localStorage.getItem(key))
        // }
        // catch(e){}
        // // return JSON.parse(localStorage.getItem(key))
    }

    /**
     * clear LocalStorage Use in Logout method
     * @param {String} key 
     */
    clearLocalData(key) {
        if (Config.encryptStorage && key == 'loginCredentials') {
            //priyanshi changed prefix of session data
            key = '@bizcompass:' + key
            localStorage.removeItem(key)
        }
        else {
            localStorage.removeItem(key)
        }
    }

    //********************************************************************** LOCALSTORAGE METHODS END **********************************************************************

    /********************************************************************** Cookie & Local Storage Methods End***********************************************************************/


    /**
     * to get alias / pagename from web url
     * @returns last '/' value from url 
     * http://192.168.2.2:3000/userrolemaster returns userrolemaster
     * http://192.168.2.2:3000/tasks/plainview returns plainview
     */
    // do not use this funciton in new development - hemang jani
    // need to remove this function
    // do not use for geeting alias of menu
    getpagename() {
        var urlpath = window.location.pathname
        var pagename = urlpath.split("/")
        var pagename = pagename[pagename?.length - 1]
        return pagename
    }

    // hemang 18/1/23
    /**
     * to get all pathnames from web url
     * @returns Array of pathname from web url
     * http://192.168.2.2:3000/userrolemaster returns ['userrolemaster']
     * http://192.168.2.2:3000/tasks/plainview returns ['tasks','plainview']
     */
    getPageUrlParams() {
        var urlpath = window.location.pathname
        var pagename = urlpath.split("/")
        return pagename
    }

    /**
     * To get the pathname from the web URL without a leading slash.
     * @returns {string} Pathname from the web URL.
     * 
     * Examples:
     * http://192.168.2.2:3000/crm/campaign → "crm/campaign"
     * http://192.168.2.2:3000/ → ""
     */
    getPagePath() {
        let urlpath = window.location.pathname
        return urlpath?.startsWith("/")
            ? urlpath.substring(1)
            : urlpath;
    }

    /**
     * to get subdomain name form web url
     * @returns subdomain name from web url 
     * in dev mode http://192.168.2.2:3000/login?q=iis returns 'iis'
     * in prod mode https://instanceit.bizcompass.app returns 'instanceit'
     * if no subdomain found then returns undefined
     */
    getSubdomainName() {
        let subdomain
        const urlparams = Config.getServermode() == 'prod' ? window.location : new URLSearchParams(window.location.search)
        if (Config.getServermode() == 'prod') {
            try {
                // indexOf('.bizcompass.app')
                let domainnameindex = urlparams.hostname?.indexOf('.bizcompass.app')
                if (domainnameindex > 0) {
                    subdomain = urlparams.hostname?.slice(0, domainnameindex)
                }
                else {
                    subdomain = undefined
                }
            }
            catch {
                subdomain = undefined
            }
        }
        else {
            try {
                subdomain = urlparams.get('q')
            }
            catch {
                subdomain = undefined
            }
        }

        return subdomain
    }

    /**
     * get user rights for page
     * @param {String} pagename 
     * @returns Object containing rights or undefined if no rights found
     */
    getPageRights(pagename = this.getpagename()) {
        return this.getobjectfromarray(this.getCurrentState()["userRights"], 'alias', pagename) || {}
    }

    /**
     * used for making all axios requests
     * @param {String} method 
     * @param {String} url 
     * @param {JSON Object} reqBody 
     * @param {JSON Object} reqHeaders 
     */
    async axiosrequest(method, url, reqBody, reqHeaders, successCallback, errorCallback, cancelToken) {


        let tempurl = url
        const includesUrl = Config.reqUrlArr?.some(path => tempurl?.includes(path))
        let newURL

        if (includesUrl) {
            newURL = tempurl.replace(Config.weburl, Config.pmsweburl)
        }
        else {
            newURL = url
        }

        await axios({
            method: method,
            url: newURL,
            data: reqBody,
            headers: reqHeaders,
            cancelToken: cancelToken?.token || undefined
        })
            .then(response => successCallback(response))
            .catch(error => {
                let reqwithStatusCode
                if (axios.isCancel(error)) {
                    return
                }
                if (error.response) {
                    // The request was made and the server responded with a status code
                    console.group(
                        `%c🛑🚫❌ Response error:\n %cRequest URL: ${url}\n %cTime: ${this.getTimeFormat(new Date().toISOString(), 1)}\n %cStatus Code: ${error.response.status}\n %cMessage: ${error.response.data.message}`,
                        'color: red; font-weight: bold;', // Style for "Response error:"
                        'color: blue; font-weight: bold;', // Style for Request URL:"
                        'color: purple; font-weight: bold;', // Style for Time:"
                        'color: orange; font-weight: bold', // Style for "Status Code:"
                        'color: green;font-weight: bold' // Style for "Message:"
                    )
                    reqwithStatusCode = true
                } else if (error.code === 'ECONNABORTED') {
                    // Connection timeout error
                    console.group(
                        `%c🛑🚫❌ Connection timeout error:\n %cRequest URL: ${url}\n %cTime: ${this.getTimeFormat(new Date().toISOString(), 1)}\n %cMessage: ${error.message}`,
                        'color: red; font-weight: bold;',
                        'color: blue; font-weight: bold;',
                        'color: purple;font-weight: bold',
                        'color: green;font-weight: bold'
                    )
                    reqwithStatusCode = false
                    // IISMethods.localnotify(Config.errmsg.reqtimeout, 2)
                } else if (error.message === 'Network Error') {
                    // CORS error or Network error
                    console.group(
                        `%c🛑🚫❌ CORS error or Network error\n %cRequest URL: ${url}\n %cTime: ${this.getTimeFormat(new Date().toISOString(), 1)}`,
                        'color: red; font-weight: bold;',
                        'color: blue; font-weight: bold;',
                        'color: purple;font-weight: bold',
                    )
                    reqwithStatusCode = false
                    // IISMethods.localnotify(Config.errmsg.networkerror, 2)
                }
                else if (error.request) {
                    // The request was made but no response was received
                    console.group(
                        `%c🛑🚫❌ Request error:\n %cRequest URL: ${url}\n %cTime: ${this.getTimeFormat(new Date().toISOString(), 1)}\n %cMessage: ${error.request}`,
                        'color: red; font-weight: bold;',
                        'color: blue; font-weight: bold;',
                        'color: purple;font-weight: bold',
                        'color: green;font-weight: bold'
                    )
                    reqwithStatusCode = false
                    // IISMethods.localnotify(Config.errmsg.noresreceived, 2)

                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.group(
                        `%c🛑🚫❌ Request error:\n %cRequest URL: ${url}\n %cTime: ${this.getTimeFormat(new Date().toISOString(), 1)}\n %cMessage: ${error.message}`,
                        'color: red; font-weight: bold;',
                        'color: blue; font-weight: bold;',
                        'color: purple;font-weight: bold',
                        'color: green;font-weight: bold'
                    )
                    reqwithStatusCode = false
                    // IISMethods.localnotify(Config.errmsg.reqsetiperror, 2)
                }
                errorCallback(error, reqwithStatusCode)
            })
    }


    /**
     * use for making dynamic endpoint for socket 
     * @param {String} url 
     * @param {String} endpointverson 
     * @returns 
     */
    async getSocketEndPoint(url, endpointverson) {

        const regex = new RegExp(`(${endpointverson}.*)`);
        const match = url.match(regex)
        // Generate endpoint
        const uniqueSuffix = `${Date.now()}-${Math.random()}`

        return match ? `${match[1]}-${uniqueSuffix}` : null
    }

    //PRIYANSHI --> SOCKET
    /**
     * used for making all socket requests
     * @param {String} method 
     * @param {String} url 
     * @param {JSON Object} reqBody 
     * @param {JSON Object} reqHeaders 
     */
    async socketRequest(method, url, reqBody, reqHeaders, successCallback, errorCallback) {
        try {
            let endpointstring = await this.getSocketEndPoint(url, Config.endpointverson)
            let socketData = { method, url, body: reqBody, headers: reqHeaders, endpoint: endpointstring }

            if (Config.encryptSocketData) {
                socketData = this.encryptData({ method, url, body: reqBody, headers: reqHeaders, endpoint: endpointstring })
            }


            // Emit the socket event with necessary data
            //Priyanshi Socket Change 
            apisocket.emit('apicall', socketData)


            // Return a promise that resolves with the response
            return new Promise((resolve, reject) => {
                apisocket.once(endpointstring, (response) => {

                    let decryptedData = JSON.parse(response)
                    // if (response.data.status === 200) {
                    if (Config.encryptSocketData) {
                        decryptedData = JSON.parse(this.decryptData(response))
                    }

                    if (successCallback) {
                        successCallback(decryptedData, endpointstring) // Call the success callback with response data
                    }

                    resolve(decryptedData) // Resolve with the response data
                    // } else {
                    //     reject(new Error('Failed to get valid response')); // Reject if response is not valid
                    // }
                })

                // Handle errors
                apisocket.on('error', (error) => {
                    console.error('Socket Request Error:', error);
                    if (errorCallback) {
                        errorCallback(error, false); // Call the error callback with the error
                    }
                    reject(error); // Reject the promise in case of error
                })
            })

        } catch (error) {
            console.error('Socket Request Error:', error);
            if (errorCallback) {
                errorCallback(error, false); // Call the error callback with the error
            }
            return Promise.reject(error) // Return a rejected promise in case of error
        }
    }


    /**
     * used for calling axios or socket conditionally
     * @param {String} method 
     * @param {String} url 
     * @param {JSON Object} reqBody 
     * @param {JSON Object} reqHeaders 
     */
    async callApiFrom(method, url, reqBody, reqHeaders, successCallback, errorCallback, cancelToken) {
        if (Config.callSocketApi) {
            await this.socketRequest(method, url, reqBody, reqHeaders, successCallback, errorCallback, cancelToken)
        }
        else {
            await this.axiosrequest(method, url, reqBody, reqHeaders, successCallback, errorCallback, cancelToken)
        }

    }


    // /**
    //  * to call multiple requests at once 
    //  * @param {String} method 
    //  * @param {String} url 
    //  * @param {JSON Object} reqBody 
    //  * @param {JSON Object} reqHeaders 
    //  */
    // // call multiple req at once
    // async AllAxiosRequest(method, url, reqBody, reqHeaders, successCallback, errorCallback){
    //     await axios.all({
    //         method: method,
    //         url: url,
    //         data: reqBody,
    //         headers: reqHeaders
    //     })
    //     .then(axios.spread((response)=>{
    //         successCallback(response)
    //     }))
    //     .catch(error => errorCallback(error))
    // }
    // // call multiple req at once

    /**
     * to get random number
     * @param {Number} number 
     * @returns random number 
     */
    getRandom(number) {
        return Math.floor((Math.random() * number) + 1)
    }

    /**
     * to get random color from config color array
     * @returns randomly generated color code in hex format
     */

    // get next color for color picker 

    getRandomColor(colorarr) {
        const colors = colorarr || Config.bgColorsArray;
        return colors[Math.floor(Math.random() * colors.length)];
    }


    /**
     * to get name initials of person name
     * @param {String} name 
     * @returns initial letter of name
     */
    // harsh 20-1-2023
    getDefaulImageIconForName(name) {
        return name?.split(' ')?.map(item => item.toUpperCase().substring(0, 1)).join('')?.slice(0, 2)
    }

    /*******************************************************************************replace Base64 to S3URL START************************************************************************************************* */
    //replace Base64 to S3URL
    replaceBase64WithS3URL = async (content, isRawBase64 = false) => {
        // If it's a raw base64 image (from camera)
        if (isRawBase64) {
            if (!content.startsWith("data:image")) {
                console.error("Invalid base64 format");
                return content;
            }

            const BufferObj = await IISMethods.base64ToBuffer(content);
            const buffer = Buffer.from(BufferObj.bufferData, 'binary');

            const s3ImageUrl = await IISMethods.UploadTOS3(
                buffer,
                `.${BufferObj.filetype}`,
                BufferObj.ContentType
            );

            return s3ImageUrl;
        }

        // Regular expression to match base64 strings
        const base64Regex = /src="data:image\/[^;]+;base64,([^"]+)"/g
        let updatedContent = content
        let match
        // Iterate through matches and replace base64 strings with S3 URLs
        while ((match = base64Regex.exec(content)) !== null) {
            var BufferObj = await IISMethods.base64ToBuffer(match[0])
            const buffer = Buffer.from(BufferObj.bufferData, 'binary')

            let s3ImageUrl = await IISMethods.UploadTOS3(buffer, `.${BufferObj['filetype']}`, BufferObj['ContentType'])

            updatedContent = updatedContent.replace(match[0], `src="${s3ImageUrl}"`)
            updatedContent = updatedContent.replace(/data-file-name="[^"]*"/g, '')  // Replace data-file-name  attribute with an empty string
        }

        // Replace class attribute with an empty string
        updatedContent = updatedContent?.replace(/<img\b[^>]*\bclass\s*=\s*['"][^'"]*['"][^>]*>/gi, (match) => {
            return match.replace(/\bclass\s*=\s*['"][^'"]*['"]/gi, '')
        })

        return updatedContent
    }
    /*******************************************************************************replace Base64 to S3URL END************************************************************************************************* */
    /************************************************************* DATE AND TIME METHODS START ************************************************************************************ */

    // convert milisecond to time
    /**
     * convert mili sec to diff time strinfg formate
     * @param {Number} time milliseconds only
     * @param {String} format 
     * @returns returns mili sec to time formates for ex:- 1 day(s) 2hr 3min or +10:05:00
     */
    ConvertTime(time, format = '') {
        var s = Math.floor((time / 1000) % 60)
        var m = Math.floor((time / (1000 * 60)) % 60)
        var h = Math.floor((time / (1000 * 60 * 60)) % 24)
        // var h = (time / (1000 * 60 * 60)) < 24 ? Math.floor((time / (1000 * 60 * 60)) % 24) : Math.floor((time / (1000 * 60 * 60)))
        // var h = Math.floor((time / (1000 * 60 * 60)))
        // var d = Math.floor((time / (1000 * 60 * 60)) / 24)
        var flag = 0
        if (s < 0) {
            flag = 1
            s = -s
        }
        if (m < 0) {
            flag = 1
            m = -m
        }
        if (h < 0) {
            flag = 1
            h = -h
        }

        if (s <= 9)
            s = '0' + s
        if (m <= 9)
            m = '0' + m
        if (h <= 9)
            h = '0' + h

        if (time == 86400000) {
            h = 24
        }

        if (format == 'hh:mm') {
            const ConvertedTime = ` ${h}:${m}`
            return ConvertedTime
        }
        if (format === 'hr-min') {
            // return with full hours and minutes only - aman
            return `${parseInt(time / (1000 * 60 * 60))}hr ${parseInt((time / (1000 * 60)) % 60)}min`
        }
        if (format === 'decimal') {
            const totalHours = time / (1000 * 60 * 60)
            return totalHours.toFixed(2) + ' hrs'
        }
        const ConvertedTime = (format == 'hh-mm-ss' ? `${parseInt((parseInt(time / (1000 * 60 * 60))) / 24) > 0 ? `${parseInt((parseInt(time / (1000 * 60 * 60))) / 24)}day(s)` : ''} ${h % 24}hr ${m}min ` : flag ? `-${h}:${m}:${s}` : `+${h}:${m}:${s}`)
        return ConvertedTime
    }

    /**
     * get date in dd/mm/yy or dd Jan , yyyy formate
     * @param {Date Object or String} date iso formate
     * @param {String} format pass 'dd/mm/yy'
     * @returns formated date in string according to formate passed
     * mostaly used in project module
     */
    dateToFormat(date, format) {
        try {
            date = date.toString()
            const dateobject = new Date(date)
            if (format === "dd/mm/yyyy") {
                const dd = String(dateobject.getDate()).padStart(2, '0')
                const mm = String(dateobject.getMonth() + 1).padStart(2, '0')
                const yyyy = dateobject.getFullYear()
                if (isNaN(dd) || isNaN(mm) || isNaN(yyyy)) {
                    date = '-'
                }
                else {
                    date = dd + '/' + mm + '/' + yyyy
                }
            }
            else {
                const dd = String(dateobject.getDate()).padStart(2, '0')
                const mm = dateobject.getMonth()
                const yyyy = dateobject.getFullYear()
                if (isNaN(dd) || isNaN(mm) || isNaN(yyyy)) {
                    date = '-'
                }
                else {
                    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
                    date = dd + ' ' + months[mm] + ', ' + yyyy
                }
            }
        }
        catch {
            date = '-'
        }

        return date
    }

    // starts | Om Z  🌝🌝🌝 ~ 2024-10-10 ~ 06:08 PM
    hexToRGBA(hex, opacity) {
        let rgba = (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex?.length / 3 + '})', 'g'))?.map(function (l) { return parseInt(hex?.length % 2 ? l + l : l, 16) }).concat(isFinite(opacity) ? opacity : 1);
        return { r: rgba[0], g: rgba[1], b: rgba[2], a: rgba[3] }
    }

    RGBATohex(rgba) {
        rgba = rgba.match(
            /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
        )
        return rgba && rgba?.length === 4
            ? "#" +
            ("0" + parseInt(rgba[1], 10).toString(16))?.slice(-2) +
            ("0" + parseInt(rgba[2], 10).toString(16))?.slice(-2) +
            ("0" + parseInt(rgba[3], 10).toString(16))?.slice(-2)
            : ""
    }

    /**
     * Generates a simple hash checksum from a string input.
     * This is a variant of the djb2 hash algorithm.
     * 
     * @param {string} str - The input string to generate a checksum for.
     *                       Typically a combination of key identifiers 
     *                       (e.g., fileId + fileName) to verify data integrity.
     * 
     * @returns {number} A 32-bit integer hash value representing the checksum of the input string.
     *                   The hash is useful for detecting corruption or tampering in the token data.
     *
     * @example
     * // Generate a checksum for validation
     * const checksum = createChecksum("123456documentname.pdf");
     * // Result: A unique numeric hash corresponding to the input string
     */
    createChecksum(str) {
        let hash = 0  // Initialize hash value

        // Iterate through each character in the string
        for (let i = 0; i < str.length; i++) {
            // Left-shift the current hash by 5 bits (multiply by 32),
            // subtract the original hash value, and add the character code
            hash = ((hash << 5) - hash) + str.charCodeAt(i)

            // Force conversion to a 32-bit signed integer with bitwise OR
            // This ensures consistency across different JavaScript environments
            hash |= 0
        }

        return hash
    }

    GetTZdatetime(date = null) {
        try {
            let tzDate = this.GetDateTimefromISOString(this.GetDateTime(date).toISOString())
            return tzDate
        }
        catch {
            return ''
        }
    }

    GetDateTime(date = null, offset = null) {
        if (!date) { date = new Date() }
        offset = !offset ? this.getPropertyOffset(date) : offset// only date
        let sysdate = new Date()

        let decimaloffset = offset[0] + (Number(offset[1] + offset[2]) + (Number(offset[3] + offset[4])) / 60).toString()

        let utc = date.getTime() + date.getTimezoneOffset() * 60000;
        let additionaldiff = ((60 * decimaloffset) + sysdate.getTimezoneOffset()) * 2
        let nd = new Date(utc + (3600000 * decimaloffset) - (additionaldiff * 60000))
        return nd
    }

    generateUUID() {
        // var d = this.GetDT().getTime();
        var d = this.stringToDate(new Date()).getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;//random number between 0 and 16
            if (d > 0) {//Use timestamp until depleted
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {//Use microseconds since page-load if supported
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    getPropertyOffset(date, data) {
        let propertydata = data || this.getCurrentState().propertylocation || {}

        let offset = propertydata['offset']
        let offsetdata = propertydata['offsetdata'] || []
        let offsetindex = offsetdata?.findIndex(poffset => {
            let getdate = date
            if ((new Date(poffset.fromdate) <= new Date(getdate)) && (new Date(poffset.todate) >= new Date(getdate))) return true
            else return false
        })
        if (offsetindex !== -1) {
            offset = offsetdata[offsetindex]['offsets']
        }
        return offset || '+0000'
    }

    GetDateTimefromISOString(isostring) {
        let offset = this.getPropertyOffset(isostring) // only date
        let decimaloffset = offset[0] + (Number(offset[1] + offset[2]) + (Number(offset[3] + offset[4])) / 60).toString()

        let date = new Date(isostring)
        let utc = date.getTime() + date.getTimezoneOffset() * 60000;
        let additionaldiff = ((60 * decimaloffset) + date.getTimezoneOffset())
        let nd = new Date(utc - (date.getTimezoneOffset() * 60000) + (additionaldiff * 60000))
        return nd
    }

    // ends | Om Z  🌝🌝🌝 ~ 2024-10-10 ~ 06:08 PM

    getDateFormats(originaldate, dateformat = this.getCookiesData("loginInfo").dateformat) {
        let date = originaldate
        let format = dateformat ?? 1
        try {
            // Added for firefox getting date issue Aniket Bhesaniya 🛠️  ~ 2025-09-04 ~ 09:47 AM
            if (typeof date === "string") {
                date = date.trim();

                // fix "2025-05-" case
                if (/^\d{4}-\d{2}-$/.test(date)) {
                    date = date.slice(0, 7) + "-01";
                }
                // fix "2025-05" case
                else if (/^\d{4}-\d{2}$/.test(date)) {
                    date = date + "-01";
                }
            }
            date = date.toString()
            const dateobj = new Date(date)

            if (isNaN(dateobj)) {
                throw new Error("Invalid Date");
            }

            const year = dateobj.getFullYear()  // 2022
            const month = dateobj.getMonth() + 1  // 9
            const day = dateobj.getDate()      // 1
            const yy = year.toString()?.slice(-2) || ''; // 22
            const mm = month.toString()?.padStart(2, '0') || ''; // 09
            const dd = day.toString()?.padStart(2, '0') || '';   // 01
            const shortmonth = dateobj?.toLocaleString('default', { month: 'short' }) || ''; // Sep

            // if(year == 'NaN'){
            //     alert('NaN')
            // }

            if (format === 1) {
                date = (year || '') + "-" + (mm || '') + "-" + (dd || '') //  2022-09-01
            }
            else if (format === 2) {
                date = month + "/" + day + "/" + year  //  9/1/2022
            }
            else if (format === 3) {
                date = month + "/" + day + "/" + yy
            }
            else if (format === 4) {
                date = dd + "-" + shortmonth + "-" + yy
            }
            else if (format === 5) {
                date = yy + "/" + mm + "/" + dd
            }
            else if (format === 6) {
                date = mm + "/" + dd + "/" + yy
            }
            else if (format === 7) {
                date = dd + "/" + mm + "/" + year
            }
            else if (format === 8) {
                date = shortmonth + "-" + year
            }
            else if (format === 9) {
                date = dd + " " + shortmonth + "," + " " + year
            }
            else if (format === 10) {
                date = year + "-" + shortmonth
            }
        }
        catch {
            date = "Invalid Date"
        }
        return date
    }

    /**
     * @param {String} dateString iso formate date
     * @returns returns day of the week
     */

    getDayName(dateString) {

        const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const date = new Date(dateString);

        // Get the day of the week (0-6)
        const dayIndex = date.getDay();

        // Return the corresponding day name
        return daysOfWeek[dayIndex];
    }

    /**
     * convert mili sec to diff time strinfg formate
     * @param {String} startDate iso formate
     * @param {String} endDate iso formate
     * @param {Number} includeDate 1: for include strat date 2 : include end date
     * @returns returns all dates[] between two dates
     * getDatesInRange('2023-06-22T00:00:00.000Z', '2023-06-30T00:00:00.000Z')
     */
    //get all dates [] between two dates
    getDatesInRange(startDate, endDate, includeDate) {
        startDate = new Date(startDate)
        endDate = new Date(endDate)
        const date = new Date(startDate.getTime());
        const dates = []

        if (includeDate == 2 || includeDate == 3) {
            date.setDate(date.getDate() + 1);
        }

        //  include start date
        if (includeDate == 1) {
            while (date < endDate) {
                dates.push({ date: new Date(date) });
                date.setDate(date.getDate() + 1);
            }
        }
        // include end date
        else if (includeDate == 2) {
            while (date <= endDate) {
                dates.push({ date: new Date(date) });
                date.setDate(date.getDate() + 1);
            }
        }
        // exclude start date &  end date
        else if (includeDate == 3) {
            while (date < endDate) {
                dates.push({ date: new Date(date) });
                date.setDate(date.getDate() + 1);
            }
        }
        // include start date and date
        else {
            while (date <= endDate) {
                dates.push({ date: new Date(date) });
                date.setDate(date.getDate() + 1);
            }
        }
        return dates
    }

    getDatesInRangeISODtring(fromDate, toDate) {
        const startDate = new Date(fromDate);
        const endDate = new Date(toDate);
        const dates = [];

        while (startDate <= endDate) {
            // Push the current date in the original format
            dates.push(new Date(startDate).toISOString());
            // Increment the date by 1 day
            startDate.setDate(startDate.getDate() + 1);
        }

        return dates;
    }

    // NOT IN USE
    getMonthFormat(month) {
        month = month.toString()
        const dateobj = new Date(month)
        const year = dateobj.getFullYear()  // 2022
        const mm = dateobj.getMonth() + 1
        const shortmonth = dateobj.toLocaleString('default', { mm: 'short' });

        month = shortmonth + "-" + year
        return month
    }


    getTimeFormat(time, format = this.getCookiesData("loginInfo").timeformat) {
        try {
            time = time.toString()
            const timeobj = new Date(time)
            let hour = timeobj.getHours()
            const minute = timeobj.getMinutes().toString().padStart(2, '0')

            if (format === 1) {
                time = hour + ":" + minute
                const ampm = hour >= 12 ? 'PM' : 'AM'
                hour = hour % 12
                hour = hour ? hour : 12
                time = hour + ":" + minute + " " + ampm
            }
            else if (format === 2) {
                time = hour + ":" + minute
            }
        }
        catch {
            time = "Invalid Time"
        }
        return time
    }


    /**
     * get time in hh : mm AM / PM format
     * @param {Date Object or String} time 
     * @param {*} format not in use
     * @returns string in hh : mm AM / PM format
     */
    timeToFormat(time, format) {
        try {
            time = time.toString()
            const timeobject = new Date(time)
            var hh = timeobject.getHours()
            const am_pm = (hh > 12 ? 'PM' : 'AM')
            hh = (hh > 12 ? hh - 12 : hh)
            hh = String(hh).padStart(2, '0')
            const mm = String(timeobject.getMinutes()).padStart(2, '0')
            const ss = String(timeobject.getSeconds()).padStart(2, '0')
            if (isNaN(hh) || isNaN(mm) || isNaN(ss)) {
                time = '-'
            }
            else {
                time = hh + ":" + mm + " " + am_pm
            }
        }
        catch {
            time = '-'
        }

        return time
    }

    // NOT IN USE
    // harsh 8-2-2023
    differenceTwoTime(startTime, endTime) {
        const start = new Date(startTime)
        const end = new Date(endTime)
        // const h = Math.floor(((end-start) / (1000 * 60 * 60)) % 24)
        const h = (((end - start) / (1000 * 60 * 60)) % 24).toFixed(2)
        return h ? h : ''
    }

    // harsh 9-1-2023 start
    /**
     * convert string to hh : mm : ss time format
     * @param {String} LogDate in yyyy-mm-dd hh:mm:ss format
     * @param {Number} method 1 for hh : mm : ss , 2 for hh : mm AM/PM
     * @returns string in hh : mm : ss formats
     */
    convertToIsoTime = (LogDate, method = 1) => {
        var timeZoneDifference = (new Date().getTimezoneOffset()) * (-1)
        var logdate = LogDate
        var y = logdate?.substring(0, 4);
        var m = logdate?.substring(5, 7);
        var d = logdate?.substring(8, 10);
        var h = parseInt(logdate?.substring(11, 13));
        var totalmin = parseInt(logdate?.substring(14, 16)) + (h * 60) + timeZoneDifference;
        var s = logdate?.substring(17, 19)
        var min1 = (totalmin / 60).toFixed(2)

        if (parseInt(min1) < 10) {
            min1 = "0" + min1
        }
        var leftmin = totalmin - min1?.slice(0, 2) * 60
        var logDate = new Date(y, m, d, totalmin / 60, leftmin, s)

        let hour = new Date(logDate).getHours()
        let minutes = new Date(logDate).getMinutes()
        let second = new Date(logDate).getSeconds()
        let ampm

        if (minutes < 10) {
            minutes = "0" + minutes
        }
        if (second < 10) {
            second = "0" + second
        }

        if (method === 1) {
            if (hour < 10) {
                hour = "0" + hour
            }
            return `${hour} : ${minutes} : ${second}`
        }
        else if (method === 2) {
            if (hour > 12) {
                hour -= 12
                ampm = "PM"
            } else if (hour === 12) {
                hour = 12
                ampm = "PM"
            }
            else {
                hour = hour
                ampm = "AM"
            }
            return `${hour} : ${minutes} ${ampm}`
        }
    }
    // harsh 9-1-2023 end

    //do not use at any other grid or module this is specially for leave confrim before using
    getLeaveDateFormats(date, format = this.getCookiesData("loginInfo").dateformat) {
        try {
            date = date.toString()
            const dateobj = new Date(date)
            // Extract UTC components
            const year = dateobj.getUTCFullYear()
            const month = dateobj.getUTCMonth() + 1
            const day = dateobj.getUTCDate()
            const yy = year.toString()?.slice(-2) || ''; // 22
            const mm = month.toString().padStart(2, '0') || ''; // 09
            const dd = day.toString().padStart(2, '0') || ''; // 01
            const shortmonth = dateobj.toLocaleString('default', { month: 'short' }) || '';
            // if(year == 'NaN'){
            //     alert('NaN')
            // }

            if (format === 1) {
                date = (year || '') + "-" + (mm || '') + "-" + (dd || '') //  2022-09-01
            }
            else if (format === 2) {
                date = month + "/" + day + "/" + year  //  9/1/2022
            }
            else if (format === 3) {
                date = month + "/" + day + "/" + yy
            }
            else if (format === 4) {
                date = dd + "-" + shortmonth + "-" + yy
            }
            else if (format === 5) {
                date = yy + "/" + mm + "/" + dd
            }
            else if (format === 6) {
                date = mm + "/" + dd + "/" + yy
            }
            else if (format === 7) {
                date = dd + "/" + mm + "/" + year
            }
            else if (format === 8) {
                date = shortmonth + "-" + year
            }
            else if (format === 9) {
                date = `${year}-${month}-${day}T00:00:00.000Z`
            }
        }
        catch {
            date = "Invalid Date"
        }
        return date
    }


    /**
     * convert string to date object
     * @param {String} string in 'yyyy-mm-dd' format
     * @returns Date Object
     */
    stringToDate(string) {
        var date
        try {
            date = new Date(string)
            if (date.toString() === 'Invalid Date')
                date = undefined
        }
        catch (e) {
            console.error(e)
            date = undefined
        }
        return date
    }

    // harsh 21-2-2021 
    // get past or future date from today
    /**
     * 
     * @param {Date Object , String 'yyyy-mm-dd'} date new Date() only
     * @param {number} days 
     * @returns 
     */
    getPastFutureDate(date, days) {
        var cdate = new Date(date)
        cdate.setDate(cdate.getDate() + (days))
        return cdate
    }

    /**
     * compare dates ignoring time 
     * @param {Date Object , String 'yyyy-mm-dd'} startDate 
     * @param {Date Object , String 'yyyy-mm-dd'} endDate 
     * @returns if start date is less then end date then returns true else false
     */
    compareDates(startDate, endDate) {
        let startdate = new Date(startDate)
        let enddate = new Date(endDate)

        if (startdate.getFullYear() < enddate.getFullYear()) {
            return true
        }
        else if (startdate.getFullYear() == enddate.getFullYear()) {
            if (startdate.getMonth() < enddate.getMonth()) {
                return true
            }
            else if (startdate.getMonth() === enddate.getMonth()) {
                if (startdate.getDate() <= enddate.getDate())
                    return true
                else
                    return false
            }
            else {
                return false
            }
        } return false
    }

    compareExpiryDates(startDate, endDate) {
        let startdate = new Date(startDate)
        let enddate = new Date(endDate)

        if (!endDate) {
            return true
        }

        if (startdate.getFullYear() < enddate.getFullYear()) {
            return true
        }
        else if (startdate.getFullYear() == enddate.getFullYear()) {
            if (startdate.getMonth() < enddate.getMonth()) {
                return true
            }
            else if (startdate.getMonth() === enddate.getMonth()) {
                if (startdate.getDate() < enddate.getDate())
                    return true
                else
                    return false
            }
            else {
                return false
            }
        } return false
    }

    /**
     * compare time ignoring date
     * @param {Date Object , String 'yyyy-mm-dd'} startDate 
     * @param {Date Object , String 'yyyy-mm-dd'} endDate 
     * @returns if start time is less then end time then returns true else false
     */
    compareTimes(startDate, endDate) {
        let startdate = new Date(startDate)
        let enddate = new Date(endDate)

        if (startdate.getHours() < enddate.getHours()) {
            return true
        } else if (startdate.getHours() > enddate.getHours()) {
            return false
        }
        else if (startdate.getHours() == enddate.getHours()) {
            if (startdate.getMinutes() < enddate.getMinutes()) {
                return true
            }
            else {
                return false
            }
        } return false
    }

    // NOT IN USE
    ConvertDateTimeToDate(datetime) {
        return new Date(datetime).getFullYear() + '-' + (((new Date(datetime) + 1) < 10) ? '0' : '') + (new Date(datetime).getMonth() + 1) + '-' + ((new Date(datetime).getDate() < 10) ? '0' : '') + new Date(datetime).getDate()
    }

    // NOT IN USE
    // juhil - 5-11-22
    ConvertDateTimeToTime(datetime) {
        return ((new Date(datetime).getHours() < 10) ? '0' : '') + new Date(datetime).getHours() + ":" + ((new Date(datetime).getMinutes() < 10) ? '0' : '') + new Date(datetime).getMinutes() + ":" + ((new Date(datetime).getSeconds() < 10) ? '0' : '') + new Date(datetime).getSeconds()
    }
    // end

    // harsh 24-1-2023
    /**
     * convert minutes and hours to miliseconds
     * @param {String  , Number} minute 
     * @param {String  , Number} hour 
     * @returns miliseconds
     */
    ConvertTimeToMill = (minute, hour) => {
        const m = minute ? (parseInt(minute)) * 60000 : 0
        const h = hour ? (parseInt(hour)) * 3600000 : 0
        const milliseconds = m + h
        return milliseconds
    }

    // convert millisecond into time ~ Nirzar Gabani
    /**
     * convert minutes and hours to miliseconds
     * @param {Number} milliseconds
     * @returns total time
     */
    convertMillisecondsToTime = (milliseconds) => {
        const hours = Math.floor(milliseconds / (1000 * 60 * 60));
        const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);

        // Ensure two digits for minutes and seconds
        const formattedTime =
            `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        return formattedTime;
    };

    /**
     * get total number of days in month or last date of month
     * @param {Date Object , ISO String , String 'yyyy-mm-dd' } date 
     * @returns total number of days in month or last date of month
     */
    getDaysInMonth(date) { //ISO Date
        let year = new Date(date).getFullYear()
        let month = new Date(date).getMonth() + 1

        return new Date(year, month, 0).getDate()
    }

    /**
     * get first day of month 
     * @param {Date Object , ISO String , String 'yyyy-mm-dd'} date 
     * @returns first day of month in Date Object
     */
    getFirstDayOfMonth(date) { // ISO Date
        let year = new Date(date).getFullYear()
        let month = new Date(date).getMonth()
        let day = 1
        return new Date(year, month, day).toISOString()
    }

    /**
     * get last day of month
     * @param {Date Object , ISO String , String 'yyyy-mm-dd'} date 
     * @returns last day of month in Date Object
     */
    getLastDayOfMonth(date) { //ISO Date
        let year = new Date(date).getFullYear()
        let month = new Date(date).getMonth()
        let day = parseInt(this.getDaysInMonth(date))

        return new Date(year, month, day, 23, 59, 59).toISOString()
    }

    /**
     * add minutes to time 
     * @param {Date Object , ISO String , String 'yyyy-mm-dd'} date 
     * @param {Number} minute 
     * @returns updated Date Object
     */
    addMinuteToTime(date, minute) { //ISO date
        const time = new Date(date)
        const temp = new Date(time.getTime() + minute * 60000)
        return new Date(temp.toString()).toISOString()
    }

    // JATIN 12/08/2024 For set Start and End Time In Date 
    // pass date object and set time to 00:00:00
    setStartTimeOfDay(date) {
        let year = new Date(date).getFullYear()
        let month = new Date(date).getMonth()
        let day = new Date(date).getDate()
        return new Date(year, month, day, 0, 0, 0, 0)
    }
    // pass date object and set time to 00:00:00


    //priyanshi --> for date issue
    /**
     * 
     * @param {date} date 
     * @returns 
     */
    setUTCStartTimeOfDay(date) {
        let year = new Date(date).getUTCFullYear()
        let month = new Date(date).getUTCMonth()
        let day = new Date(date).getUTCDate()
        return new Date(year, month, day, 0, 0, 0, 0)
    }

    // pass date object and set time to 23:59:59
    setEndTimeOfDay(date) {
        let year = new Date(date).getFullYear()
        let month = new Date(date).getMonth()
        let day = new Date(date).getDate()
        return new Date(year, month, day, 23, 59, 59)
    }

    // JATIN  18-01-2025 12:17 PM For get days diff from 2 Date Obj
    GetDiffInDay(d1, d2) {
        let days = (d2 - d1) / (1000 * 60 * 60 * 24)
        return Math.floor(days) + 1
    }


    // JATIN 26/10/2024 10:02 AM For Covert Date Object In ISOString Formate 
    ConvertDateObjTOISOString = (date) => {
        let year = date.getFullYear()
        let month = date.getMonth()
        month = (month + 1).toString()?.length > 1 ? (month + 1) : `0${(month + 1)}`
        let day = date.getDate()
        day = (day).toString()?.length > 1 ? (day) : `0${(day)}`
        let hr = date.getHours()
        hr = (hr).toString()?.length > 1 ? (hr) : `0${(hr)}`
        let min = date.getMinutes()
        min = (min).toString()?.length > 1 ? (min) : `0${(min)}`
        let sec = date.getSeconds()
        sec = (sec).toString()?.length > 1 ? (sec) : `0${(sec)}`
        return `${year}-${month}-${day}T${hr}:${min}:${sec}.000Z`
    }

    /**
     * 
     * @param {ISO String} isoString 
     * @returns 
     */
    getDateOnly(isoString) {
        const date = new Date(isoString)
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
    }


    /**
         * get Time from Decimal number
         * @param {Number} decimalTimeString 
         * @returns //1.5 => 1 hr 30 min (1:30)
    */
    getTimeFromDesimal(decimalTimeString) {
        var decimalTime = parseFloat(decimalTimeString);
        decimalTime = decimalTime * 60 * 60;
        var hours = Math.floor((decimalTime / (60 * 60)));
        decimalTime = decimalTime - (hours * 60 * 60);
        var minutes = Math.floor((decimalTime / 60));
        decimalTime = decimalTime - (minutes * 60);
        var seconds = Math.round(decimalTime);
        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }

        return (hours + ":" + minutes);
    }

    /************************************************************* DATE AND TIME METHODS END ************************************************************************************ */


    /**
     * convert string to int number
     * @param {String} value 
     * @returns number
     */
    stringToInt(value) {
        value = Number(value)
        //     value = parseInt(value)
        return isNaN(value) ? 0 : value
    }


    /**
     * convert string to Float number
     * @param {String} value 
     * @returns number
     */
    stringToFloat(value) {
        value = parseFloat(value)
        return isNaN(value) ? 0 : value
    }

    /************************************************************* ARRAY AND OBJECT METHODS START ************************************************************************************ */
    /**
     * to get random elemets from array
     * @param {Array} arr 
     * @param {Number} n number to get n elements
     * @returns new randomly generated n length array
     */
    getUniqueElementsFromArray(arr, n = 1) {
        arr = arr.sort(() => 0.5 - Math.random())
        // let m = arr?.length
        // while (m) {
        //     const i = Math.floor(Math.random() * m--);
        //     [arr[m], arr[i]] = [arr[i], arr[m]]
        // }
        return arr?.slice(0, n)
    }

    /**
     * get Object from array of object
     * pass array of object  , key to match from object and value
     * @param {Array} arr Array of Object
     * @param {Strig} key 
     * @param {Any} value 
     * @returns Object if found or undefined
     */
    getobjectfromarray(arr, key, value) {
        try {
            return arr?.find(o => o[key] == value)
        }
        catch (e) {
            console.log(e)
            return undefined
        }
    }

    /**
     * get Object from array of object from multiple keys and value
     * @param {Array} arr Array of Object 
     * @param {String} key1 
     * @param {String} key2 
     * @param {Any} value1 
     * @param {Any} value2 
     * @returns Object if found or undefined
     */
    getobjectfromarraydoublekey(arr, key1, key2, value1, value2) {
        try {
            return arr?.find(o => o[key1] === value1 && o[key2] === value2)
        }
        catch {
            return undefined
        }
    }

    /**
     * get index from array of object
     * @param {Array} arr Array of Object 
     * @param {String} key 
     * @param {Any} value 
     * @returns return index from array of object or -1 if not found
     */
    getindexfromarray(arr, key, value) {
        try {
            return arr?.findIndex(o => o[key] === value)
        }
        catch {
            return -1
        }
    }

    /**
     * get multiple indexes from array of object
     * @param {Array} arr Array of Object 
     * @param {String} key 
     * @param {Any} value 
     * @returns return array of indexes from array of object or [] if not found
     */
    getmultipleindexfromarray(arr, key, value) {
        try {
            let indexes = arr?.reduce(function (ind, obj, i) {
                if (obj[key] == value)
                    ind.push(i)
                return ind
            }, [])

            return indexes
        }
        catch {
            return []
        }
    }


    /**
     * get index from array of object multiple key and value
     * @param {Array} arr Array of Object
     * @param {String} key1 
     * @param {String} key2 
     * @param {Any} value1 
     * @param {Any} value2 
     * @returns index from array of object or -1 if not found
     */
    getindexfromarraydoublekey(arr, key1, key2, value1, value2) {
        try {
            return arr?.findIndex(o => o[key1] === value1 && o[key2] === value2)
        }
        catch {
            return -1
        }
    }

    // hemang jani changed 19/01/23
    /**
     * move item in array
     * @param {Array} arr 
     * @param {*} index 
     * @param {*} newItem 
     * @returns updated arry
     */
    replaceItemInArry(arr, index, newItem) {
        arr?.splice(index, 1, newItem)
        return arr
    }

    /**
     * get multiple objects in new array from array of object
     * @param {Array} arr Array of Object
     * @param {String} key 
     * @param {Any} value 
     * @returns new array 
     */
    getmultipleobjectsfromarray(arr, key, value) {
        return arr?.filter(o => o[key] === value)
    }

    // hemang 11/1/23
    /**
     * get multiple objects in new array from array of object using multiple key and vaue
     * @param {Array} arr Arrya of Object 
     * @param {String} key1 
     * @param {String} key2 
     * @param {Any} value1 
     * @param {Any} value2 
     * @returns new array 
     */
    getmultipleobjectsfromarraydoublekey(arr, key1, key2, value1, value2) {
        return arr?.filter(o => o[key1] === value1 && o[key2] === value2)
    }

    // NOT IN USE
    removeDuplicateObjectsFromArray(arr) {
        return arr?.filter((value, index, self) =>
            index === self?.findIndex((t) => (
                t.place === value.place && t.name === value.name
            ))
        )
    }

    /**
     * 
     * @param {Array} arr required
     * @param {String} key1 required
     * @param {String} key2 for remove duplicates by considering depth key
     * @returns array with unique values
     */
    removeDuplicateFromArray(arr, key1, key2) {
        try {
            let uniqueArr
            if (key2) {
                uniqueArr = [...new Map(arr?.map((item) => [item[key1][key2], item])).values(),]
            }
            else {
                uniqueArr = [...new Map(arr?.map((item) => [item[key1], item])).values(),]
            }
            return uniqueArr
        }
        catch {
            return arr
        }
    }
    /**
     * 
     * @param {Array} data required
     * @param {Object} sorting required
     * @returns array with sorting
     */
    //Aniket Bhesaniya for sorting update
    sortTableData(data, sorting) {
        return data.sort((a, b) => {
            for (const key in sorting) {
                const sortOrder = sorting[key] // Directly get sorting order (-1, 0, 1)

                if (sortOrder !== 0) {
                    let valA = a[key] ?? ""
                    let valB = b[key] ?? ""

                    // Convert ISO date strings to timestamps
                    const isDateA = typeof valA === "string" && valA?.includes("T")
                    const isDateB = typeof valB === "string" && valB?.includes("T")

                    if (isDateA) valA = new Date(valA).getTime()
                    if (isDateB) valB = new Date(valB).getTime()

                    // If both values are strings, use localeCompare, otherwise use subtraction
                    const isString = typeof valA === "string" && typeof valB === "string"
                    const result = isString
                        ? sortOrder * valA.localeCompare(valB) // String comparison
                        : sortOrder * (valA - valB) // Numeric comparison

                    if (result !== 0) return result // Return first non-zero sort result
                }
            }
            return 0 // If all sorting conditions are neutral, maintain order
        })
    }

    /**
     * 
     * @param {Array} rightSidebarFormData required
     */
    initializeSorting(rightSidebarFormData) {

        let sorting = {}

        rightSidebarFormData?.forEach((tab) => {
            if (tab.formfields) {
                tab.formfields?.forEach((field) => {
                    if (field.type === "table" && field.tablesortfield) {
                        const key = field.field // e.g., "salarydetails", "attendancedetails"
                        sorting[key] = {}

                        // Set initial values for all table fields
                        field.tablesortfield?.forEach((subField) => {
                            sorting[key][subField] = 0
                        })

                        // Apply `initialsorting` if available
                        if (field.initialsorting) {
                            Object.entries(field.initialsorting)?.forEach(([sortField, sortOrder]) => {
                                if (sorting[key].hasOwnProperty(sortField)) {
                                    sorting[key][sortField] = sortOrder
                                }
                            })
                        }
                    }
                })
            }
        })

        return sorting
    }

    // Aniket Bhesaniya -- For sorting array of objects by date
    // dateKey is the key in the object that contains the date string
    parseDate(dateStr) {
        if (!dateStr) return new Date(0) // Handle empty dates by setting them to the oldest possible date

        let parts = dateStr.split('-')
        let year = parseInt(parts[0], 10)
        let month = parts[1] ? parseInt(parts[1], 10) - 1 : 0
        let day = parts[2] ? parseInt(parts[2], 10) : 1

        return new Date(year, month, day)
    }
    sortByDate(arr, dateKey, descending = false) {
        return arr.sort((a, b) => {
            let dateA = this.parseDate(a[dateKey])
            let dateB = this.parseDate(b[dateKey])
            return descending ? dateB - dateA : dateA - dateB
        })
    }
    /************************************************************* ARRAY AND OBJECT METHODS END ************************************************************************************ */
    // works for frist depth only
    // for multiple depth use json.parse & json.stringify
    // new changes done for previous copy going creating issue there is not perfect deep copy ~ Aniket Bhesaniya 08/09/2025
    getCopy(element) {
        try {
            return element?.map(o => Object.assign({}, o))
        }
        catch {
            return Object.assign({}, element)
        }
    }

    /************************************************************* react-toastify METHODS START ************************************************************************************ */
    /**
     * used for create toast for notificaiton only
     * @param {Any} message 
     * @param {Any} status 
     * @param {Function} onClick 
     */
    notificationnotify(message, status, onClick, resBody) {
        //Display notifications only when the document is focused
        if (document.hasFocus()) {
            if (!status && resBody.status === 200) {
                toast.success(
                    <>
                        <h6 className='notification-description'>{message}</h6>
                    </>,
                    {
                        theme: "light",
                        // icon: "🟢",
                        icon: <img src={notificationSuccess} alt="Success Icon" />,
                        autoClose: 3000,
                        onClick: onClick,
                        bodyClassName: 'timetracking-tostify p-0',
                    })
            }
            else if (status === 1) {
                toast.warn(
                    <>
                        <h1 className='notification-title notification-warning-title text-warning'>Warning</h1>
                        <h6 className='notification-description'>{message}</h6>
                    </>,
                    {
                        theme: "light",
                        // icon: "🟡",
                        icon: <img src={notificationWarning} alt="Warning Icon" />,
                        autoClose: 3000,
                        bodyClassName: 'warning-notification-body p-0',
                        onClick: onClick
                    })
            }
            else {
                toast.error(
                    <>
                        <h1 className='notification-title notification-error-title text-danger-common'>Error</h1>
                        <h6 className='notification-description'>{message}</h6>
                    </>,
                    {
                        theme: "light",
                        // icon: "🔴",
                        icon: <img src={notificationError} alt="Error Icon" />,
                        autoClose: 3000,
                        bodyClassName: 'error-notification-body p-0',
                        onClick: onClick
                    })
            }
        }
    }

    /**
     * used for create toast in CRUD API requests
     * @param {Any} message 
     * @param {Number} status 
     */
    notify(message, status, resBody) {
        //Display notifications only when the document is focused
        if (document.hasFocus()) {
            if (!status && (resBody && resBody.status === 200)) {
                toast.success(
                    <>
                        <h1 className='notification-success-title notification-title'>Success</h1>
                        <h6 className='notification-description'>{message}</h6>
                    </>,
                    {
                        // transition: 'zoom',
                        theme: "light",
                        // position: "top-right",
                        // pauseOnHover: true,
                        // hideProgressBar: false,
                        // icon: "🟢",
                        autoClose: 3000,
                        // progress: undefined, 
                        icon: <img src={notificationSuccess} alt="Success Icon" />,
                        bodyClassName: 'success-tostify p-0',
                    })
            }
            else if (status === 1) {
                toast.warn(
                    <>
                        <h1 className='notification-title notification-warning-title text-warning'>Warning</h1>
                        <h6 className='notification-description'>{message}</h6>
                    </>,
                    {
                        theme: "light",
                        // icon: "🟡",
                        // autoClose: false,
                        icon: <img src={notificationWarning} alt="Warning Icon" />,
                        bodyClassName: 'warning-notification-body p-0',
                        containerId: "gautam"
                    })
            }
            else {
                toast.error(
                    <>
                        <h1 className='notification-title notification-error-title text-danger-common'>Error</h1>
                        <h6 className='notification-description'>{message}</h6>
                    </>,
                    {
                        theme: "light",
                        // icon: "🔴" ,
                        // autoClose: false,
                        // toastStyle : {"backgroundImage" : `url('https://images.unsplash.com/photo-1575936123452-b67c3203c357?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')`},
                        icon: <img src={notificationError} alt="Error Icon" />,
                        bodyClassName: 'error-notification-body p-0',
                    })
            }
        }
    }

    /**
     * for create local toast  without req , res 
     * use for validaiton and other toast generated from frontend 
     * @param {*} message 
     * @param {*} status // 1 - success, 2 - error else warning
     */
    localnotify(message, status) {
        //Display notifications only when the document is focused
        if (document.hasFocus()) {
            if (status == 1) {
                toast.success(
                    <>
                        <h1 className='notification-success-title notification-title'>Success</h1>
                        <h6 className='notification-description'>{message}</h6>
                    </>,
                    {
                        theme: "light",
                        // icon: "🟢",
                        // autoClose: false,
                        icon: <img src={notificationSuccess} alt="Success Icon" />,
                        bodyClassName: 'p-0',
                    })
            }
            else if (status == 2) {
                toast.error(
                    <>
                        <h1 className='notification-title notification-error-title text-danger-common'>Error</h1>
                        <h6 className='notification-description'>{message}</h6>
                    </>,
                    {
                        theme: "light",
                        // icon: "🔴",
                        // autoClose: false,
                        bodyClassName: 'error-notification-body p-0',
                        icon: <img src={notificationError} alt="Error Icon" />,
                    })
            }
            else {
                toast.warn(
                    <>
                        <h1 className='notification-title notification-warning-title text-warning'>Warning</h1>
                        <h6 className='notification-description'>{message}</h6>
                    </>,
                    {
                        theme: "light",
                        // icon: "🟡",
                        // autoClose: false,
                        icon: <img src={notificationWarning} alt="Warning Icon" />,
                        bodyClassName: 'warning-notification-body p-0',
                    })
            }
        }
    }

    /************************************************************* react-toastify METHODS END ************************************************************************************ */


    /**
    *  @param {bool}  asString //send true to retuen string instead of html 
    * @returns 
    */
    showCurrency(asString = false, style = {}, currencytoshow = "", currencydisplayname = "") {
        let loginInfo = IISMethods.getCookiesData("loginInfo")

        if (asString) {
            return currencytoshow ? currencytoshow : loginInfo?.currencytoshow || ''
        }

        return (
            <TooltipRsuite tooltipcontent={currencydisplayname ? currencydisplayname : loginInfo?.currencydisplayname || ''} >
                <span className='cursor-default print-text-8 bg-transparent' style={style ? style : {}}>{currencytoshow ? currencytoshow : loginInfo?.currencytoshow || ''}</span>
                {/* <>{loginInfo?.currencytoshow || ''}</> */}
            </TooltipRsuite>
        )
    }


    /************************************************************* log out , token expiry and session expiry START ************************************************************************************ */
    async logout() {
        var subdomainname
        try {
            subdomainname = this.getCookiesData("loginInfo")?.subdomainname
        }
        catch {
            subdomainname = 'IIS'
        }

        let reqData = {
            macaddress: this.getCookiesData("loginInfo")?.fbtoken ? this.getCookiesData("loginInfo")?.fbtoken : "",
            os: this.getOSDetail()
        }

        const url = Config.weburl + 'logout'
        const useraction = 'list' + 'logout' + 'data'

        let { resBody } = await this.socketListData(url, reqData, useraction)
        if (resBody.status === 200) {
            // Save 'isClose' value before clearing localStorage | Deep Dungarani
            const isCloseValue = this.getLocalData("isClose")

            // unsubscribe from socket 
            socket.emit("unsubscribe", this.getCookiesData("loginInfo")?.uid)
            // clear cookie and localstorage
            this.clearLocalData("userRights")
            this.clearLocalData("menuData")
            this.clearLocalData('projectsData')
            this.clearLocalData('iconExtension')
            this.clearLocalData('s3jwttokens')
            this.clearLocalData('msallogin')
            this.clearLocalData('googlelogin')
            this.clearCookiesData("loginInfo")
            // window.location.href = `/login?q=${subdomainname}&targeturl=${window.location.pathname.replace('/', '')}`

            // clear session storage
            this.clearSessionData("sessionData")
            localStorage.clear()//clear all ,localdata for ms logout

            this.setLocalData("isClose", (isCloseValue ?? true))
            // hemnag jani 30/01/23
            if (Config.getServermode() == 'prod') {
                // window.location.href = `/login?targeturl=${window.location.pathname.replace('/', '')}`
                window.location.href = `/${window.location.pathname.replace('/', '')}${window.location.search?.length ? window.location.search : ``}`
            }
            else {
                // window.location.href = `/login?q=${subdomainname}&targeturl=${window.location.pathname.replace('/', '')}`
                window.location.href = `/${window.location.pathname.replace('/', '')}${window.location.search?.length ? window.location.search : `?q=${subdomainname}`}`
            }

        }
        else {

        }

    }

    // tokenExpiry(info) {
    async tokenExpiry(resHeaders) {
        if (resHeaders.key && resHeaders.unqkey) {
            // var loginInfo = info ? info :this.getCookiesData("loginInfo")
            var loginInfo = this.getCookiesData("loginInfo")

            loginInfo.token = resHeaders.key
            loginInfo.unqkey = resHeaders.unqkey
            // if(info){
            //     return loginInfo
            // }
            // else{
            this.setCookiesData("loginInfo", loginInfo)
            // }

            if (loginInfo.fbtoken) {
                //temp comment ruchir loop
                // await this.addDeviceToken(resHeaders.key)
            }
        }
    }

    // add device token (for firebase notification)
    async addDeviceToken() {
        let loginInfo = this.getCookiesData("loginInfo")
        let url = Config.weburl + 'device/add'
        const useraction = 'adddevicedata'

        let reqData = {}
        reqData['appversion'] = "0.1.0"
        reqData['deviceid'] = loginInfo.fbtoken
        reqData['os'] = this.getOSDetail()
        reqData['osversion'] = window.navigator.appVersion
        reqData['macaddress'] = loginInfo.fbtoken //macaddress same as device id JENIL 29/5/2023 11:42 AM
        reqData['devicemodelname'] = 'Windows'

        let { resBody } = await this.socketAddData(url, reqData, useraction, false)

        if (resBody.status === 200) { }
    }

    sessionExpiry(resBody) {
        if (resBody.status === 401 && resBody.message === Config.getErrmsg()['invalidtoken']) {
            this.logout()
        }
    }


    //getting browser name - aman
    /**
     * Returns the current browser name
     * @returns {string} Browser name
     */
    async getBrowserName() {
        const userAgent = navigator.userAgent;

        // Check for Chrome (must be before Safari since Chrome also contains Safari)
        if (userAgent.indexOf("Chrome") !== -1 && userAgent.indexOf("Edg") === -1) {
            return "Chrome";
        }
        // Check for Firefox
        else if (userAgent.indexOf("Firefox") !== -1) {
            return "Firefox";
        }
        // Check for Edge (new Chromium-based Edge)
        else if (userAgent.indexOf("Edg") !== -1) {
            return "Edge";
        }
        // Check for Internet Explorer
        else if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1) {
            return "Internet Explorer";
        }
        // Check for Safari (must be after Chrome check)
        else if (userAgent.indexOf("Safari") !== -1) {
            return "Safari";
        }
        // Check for Opera
        else if (userAgent.indexOf("Opera") !== -1 || userAgent.indexOf("OPR") !== -1) {
            return "Opera";
        }
        // Check for Yandex Browser
        else if (userAgent.indexOf("YaBrowser") !== -1) {
            return "Yandex Browser";
        }
        // Others
        else {
            return "Unknown";
        }
    };

    // add device token (for firebase notification) when logindata calls - aman
    /**
     * 
     * @param {fromLoginData} bool for checking where the api is being called from - aman
     */
    async addDeviceTokenWhenLogin() {
        let loginInfo = this.getCookiesData("loginInfo")
        let url = Config.weburl + 'device/add'
        const useraction = 'adddevicedata'

        const locationObj = await this.getCurrentLocationData();
        let reqData = {}

        // reqData['appversion'] = "0.1.0"
        reqData['uid'] = loginInfo.uid
        reqData['os'] = this.getOSDetail()
        reqData['osversion'] = window.navigator.appVersion
        reqData['ipaddress'] = loginInfo.clientpublicip
        reqData['macaddress'] = loginInfo.fbtoken
        reqData['devicemodelname'] = 'Windows'
        // reqData['platform'] = IISMethods.getCurrentState()['REACT_APP_PLATFORM']
        reqData['computername'] = await this.getBrowserName()

        reqData['location'] = locationObj?.location || '';
        reqData['longitude'] = locationObj?.lng || ''
        reqData['latitude'] = locationObj?.lat || ''
        reqData['addsession'] = true

        let { resBody } = await this.socketAddData(url, reqData, useraction, false)

        if (resBody.status === 200) { }
    }
    /************************************************************* log out , token expiry and session expiry END ************************************************************************************ */

    //Priyanshi Userrole 
    isSuperAdmin = (pagename) => {
        const loginInfo = IISMethods.getCookiesData("loginInfo")
        if (pagename) {
            const pageRights = IISMethods.getPageRights(pagename)
            return loginInfo?.userroles?.some(role => role.userroleid === Config.adminutype) || pageRights.requestright
        }
        else {
            return loginInfo?.userroles?.some(role => role.userroleid === Config.adminutype)
        }
        // return loginInfo?.userroles?.some(role => role.userroleid === Config.adminutype) || pageRights.requestright
        // return loginInfo?.userroles?.some(role => role.userroleid === Config.adminutype) 
        // return IISMethods.getCookiesData("loginInfo")?.userroleid === Config.adminutype
    }



    // 17-03-2023 Shruti
    isCustomer = () => {
        return IISMethods.getCookiesData("loginInfo")?.iscustomer === 1
    }
    // 7/11/2022 Hemang Jani


    /************************************************************* FILE UPLOAD , FILE TYPES VALIDATIONS METHODS START ************************************************************************************ */

    // Convert Blob to base64
    /**
     * 
     * @param {Blob} blob pass in blob
     * @returns base64 in string 
     */

    async blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = function () {
                resolve(reader.result.split(',')[1])
            }
            reader.onerror = reject
            reader.readAsDataURL(blob)
        })
    }

    /**
     * convert file binary data (e.target.file) to base64 srting
     * @param {File} file e.target.file
     * @returns base64 string
     */
    async fileToBase64(file) {
        const getBase64 = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        }

        var base64File

        await getBase64(file)
            .then(data => base64File = data)
            .catch(error => base64File = '')

        return base64File
    }

    // used in apimanagercontroller
    /**
     * convert string base64
     * @param {String} value 
     * @returns 
     */
    stringToBase64(value) {
        return Buffer.from(value).toString('base64')
    }

    //get timestamp string
    GetTimestamp() {
        return Date.now()
    }

    // 9/12/2022 hemang
    /**
     * check file types from file binary data (e.target.file)
     * @param {File} file e.target.file
     * @param {Array} allowedFiles array of allowded file extentions
     * @returns true or false
     */
    checkFiletype(file, allowedFiles) {
        try {
            let fileName = this.getFileName(file)
            let fileExtension = this.getFileExtention(fileName)
            var regex = new RegExp("([a-zA-Z0-9\s_\\.\-:])+(" + allowedFiles.join('|') + ")$")
            return regex.test(" iis" + fileExtension.toLowerCase())
        }
        catch (e) {
            return false
        }
    }

    /**
     * get file extention from file name
     * @param {String} fileName file name with extension
     * @returns extension from file name
     * for example abc.pdf returns pdf
     */
    getFileExtention(fileName) {
        try {
            return fileName.match(Config.fileExtensionPattern)[0].toLowerCase()
        }
        catch { }
    }

    /**
     * get file name form file binary data (e.target.file) or s3 bucket url
     * @param {File} file e.target.file
     * @returns file name 
     */
    getFileName(file) {
        let filename = ''
        try {
            if (typeof (file) == 'string') {
                filename = file.substring(file?.lastIndexOf('/'), file?.length)
            }
            else
                filename = file.name
        }
        catch { }

        return filename
    }

    /**
     * get url form S3 accroding to file extension form local storage
     * used in UI to show icon in html according to file extension
     * @param {File} file e.target.file
     * @returns img url for respective file extension
     */
    getFileExtentionIcon(file) {
        let fileName, fileExtension
        try {
            if (!this.isBase64(file)) {
                fileName = this.getFileName(file)
            }

            if (this.isBase64(file)) {
                fileExtension = file.substring(file?.indexOf('/') + 1, file?.indexOf(';base64')) || ''
                fileExtension = "." + fileExtension
            }
            else
                fileExtension = this.getFileExtention(fileName)

            // let listOfIconExtensions = this.getLocalData("iconExtension")
            let listOfIconExtensions = Config.iconExtension
            let icon = {}
            icon = listOfIconExtensions?.find(o => o['extensionname']?.includes(fileExtension) && fileExtension?.length)

            return icon.extensionicon
        }
        catch (e) {
            return Config.getDefaulImageUploadUrl()
        }
    }

    /**
     * check if file data is in base 64
     * @param {File} file e.target.file
     * @returns true or false
     */
    isBase64(file) {
        try {
            return file.startsWith("data:") && (typeof file === 'string')
        }
        catch { return true }
    }

    // array of all extions available
    getAllFiles() {
        return [...this.getAllowdedDocuments('*'), ...this.getAllowdedImage('*'), ...this.getAllowdedCodeFiles('*')]
    }

    // get code file extensions .php , .js etc
    getAllowdedCodeFiles(extensions) {
        if (extensions == '*') {
            return Object.values(allowdedCodeFiles)
        }
        else {
            let arry = []
            extensions?.map(extension => {
                try {
                    arry.push(allowdedCodeFiles[extension])
                }
                catch { }
            })
            return arry
        }
    }

    // array of allowded documents (pdf, word , ppt , excel) extensions
    getAllowdedDocuments(documents) {
        let arry = []
        if (documents == '*') {
            Object.values(allowdedDocuments)?.map(document => {
                try {
                    if (Array.isArray(document)) {
                        arry = [...arry, ...document]
                    }
                    else {
                        arry.push(document)
                    }
                }
                catch (e) { }
            })
            return arry
        }
        else {
            documents?.map(document => {
                try {
                    if (Array.isArray(allowdedDocuments[document])) {
                        arry = [...arry, ...allowdedDocuments[document]]
                    }
                    else {
                        arry.push(allowdedDocuments[document])
                    }
                }
                catch { }
            })
            return arry
        }
    }

    // array of allowded img extensions
    getAllowdedImage(extensions) {
        if (extensions == '*') {
            return Object.values(allowdedImage)
        }
        else {
            let arry = []
            extensions?.map(extension => {
                try {
                    arry.push(allowdedImage[extension])
                }
                catch { }
            })
            return arry
        }
    }

    /**
     * 
     * @param {Number} value value of file size 
     * @param {String} unit Kb or Mb --> value you entered
     * @returns bytes
     */

    //convert KB or MB into bytes
    convertToBytes(value, unit) {
        const kilobyte = 1024
        const megabyte = kilobyte * 1024

        if (unit.toUpperCase() === 'KB') {
            return value * kilobyte
        } else if (unit.toUpperCase() === 'MB') {
            return value * megabyte
        }
    }

    /**
     * Converts a file size from bytes to kilobytes (KB).
     * @param {number} sizeInBytes - The file size in bytes.
     * @returns {string} - The file size in KB, rounded to 2 decimal places.
     */

    formatFileSize(sizeInBytes) {

        if (typeof sizeInBytes !== 'number' || isNaN(sizeInBytes) || sizeInBytes <= 0) {
            return '0 KB';  // If invalid input, return '0 KB'
        }

        const sizeInKB = sizeInBytes / 1024; // Convert bytes to KB
        return `${(sizeInKB).toFixed(2)} KB`; // Format to 2 decimal places and return as string
    };


    /**
     * 
     * @param {Number} bytes 
     * @param {Number} decimals 
     * @param {Number} converto  //["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
     * @returns 
     */

    formatBytes(bytes, decimals = 2, converto) {
        if (!+bytes) return 0;
        // converto 0 - Bytes, kb = 1 ....

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = converto

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm))
    }

    // generate file name with timestamp and extension
    generateFileName(extension = "jpg") {
        const timestamp = Date.now();
        return `${Config.cameraimagesprefix}-${timestamp}${extension}`;
    };

    // 9/12/2022 hemang

    /************************************************************* FILE UPLOAD , FILE TYPES VALIDATIONS METHODS END ************************************************************************************ */

    /**
     * convert file binary data (e.target.file) to formData 
     * @param {File} file e.target.file
     * @returns binary data into formData
     * used in uploading images . files, video , audio
     */
    fileToFormData(file) {
        let bodyFormData = new FormData()
        bodyFormData.append('files', file)
        return bodyFormData
    }
    // convert to formdata

    getAxiosToken() {
        let cancelToken
        cancelToken = axios.CancelToken.source()
        return cancelToken
    }

    async authenticate(Email, Password) {
        return new Promise((resolve, reject) => {
            const user = new CognitoUser({
                Username: Email,
                Pool: this.userpool()
            })

            const authDetails = new AuthenticationDetails({
                Username: Email,
                Password: Password,
            })

            user.authenticateUser(authDetails, {
                onSuccess: (result) => {
                    resolve(result)
                    let user = this.userpool().getCurrentUser()
                    if (user) {
                        user.getSession((err, session) => {
                            if (err) {
                                console.error(err)
                            }
                            else {
                                s3sessoin = session
                                IISMethods.setLocalData("s3jwttokens", session)
                            }
                        })
                    }
                    else {
                        console.error("User Not Found ----> Congnito User")
                    }
                },
                onFailure: (err) => {
                    console.error("login failed", err)
                    reject(err)
                }
            });
        });
    }

    // not in use ---> hemang jani
    logoutCognito() {
        let user = this.userpool().getCurrentUser()
        s3sessoin = {}
        user.signOut()
    }

    userpool() {
        const poolData = {
            UserPoolId: this.getCurrentState().USER_POOL_ID,
            ClientId: this.getCurrentState().POOL_CLIENT_ID,
            IdentityPollId: this.getCurrentState().IDENTITY_POOL_ID,
        }

        return new CognitoUserPool(poolData)
    }

    /**
    * delete file from s3
    *  @param {String} fileKey 
    * // path url --> https://uat-bizcompass.s3.ap-south-1.amazonaws.com/Bizcompass/temp/1741684239956.pdf
      // fileKey --> Bizcompass/temp/1741684239956.pdf
    *  returns true if file deleted / false it not
    */

    // DO NOT PASS WHOLE FOLDER

    async deleteFileFromS3(fileKey) {
        let decodedToken
        // decode jwt token
        try {
            decodedToken = jwt_decode(s3sessoin?.idToken?.jwtToken || '')
        }
        // if token undefined
        catch (e) {
            await this.authenticate(this.getCurrentState().POOL_NAME, this.getCurrentState().POOL_PASS)
            return await IISMethods.deleteFileFromS3(fileKey)

        }
        let currentDate = new Date()

        // check session expiry
        if (decodedToken?.exp * 1000 < currentDate.getTime()) {
            // access token expires
            let promise
            try {
                promise = await this.refreshTOken(decodedToken)
            }
            catch (e) { }
            return await this.FileDelete(fileKey)

        }
        else {
            return await this.FileDelete(fileKey)
        }
    }

    // DO NOT PASS WHOLE FOLDER
    // path url --> https://uat-bizcompass.s3.ap-south-1.amazonaws.com/Bizcompass/temp/1741684239956.pdf
    // fileKey --> Bizcompass/temp/1741684239956.pdf
    async FileDelete(fileKey) {
        const cognito_login_url = `cognito-idp.${Config.cognito_user_pool_region}.amazonaws.com/${this.getCurrentState().USER_POOL_ID}`;

        // Set credentials before deleting
        AWSService.config.credentials = new AWSService.CognitoIdentityCredentials({
            IdentityPoolId: this.getCurrentState().IDENTITY_POOL_ID,
            Logins: {
                [cognito_login_url]: s3sessoin.idToken.jwtToken
            }
        }, {
            region: Config.cognito_user_pool_region,
        });

        const s3 = new AWSService.S3();

        try {
            await s3.deleteObject({
                Bucket: this.getCurrentState().S3_BUCKET_NAME,
                Key: fileKey
            }).promise();

            // console.log(`File deleted successfully: ${fileKey}`);
            return true;
        } catch (error) {
            console.error(`Error deleting file: ${fileKey}`, error);
            return false;
        }
    }


    /**
     * to refresh cognito tokrn on expiry
     * @param {Cognito Token} decodedToken 
     * @returns updated token
     */
    async refreshTOken(decodedToken) {
        let currentDate = new Date()
        if (decodedToken?.exp * 1000 < currentDate.getTime()) {
            // access token expires
            let token = new CognitoRefreshToken({ RefreshToken: s3sessoin.refreshToken.token })

            const user = new CognitoUser({
                Username: this.getCurrentState().POOL_NAME,
                Pool: this.userpool()
            })

            let promise = new Promise(
                function (resolve, reject) {
                    user.refreshSession(token, async (err, session) => {
                        if (err) {
                            console.error(err)
                            // error for token re-fresh
                            // when refresh token expires then re-login and update s3sessoin
                            // refresh token expiry ---> 30day(s)
                            await IISMethods.authenticate(IISMethods.getCurrentState().POOL_NAME, IISMethods.getCurrentState().POOL_PASS)
                            reject(err)
                        }
                        else {
                            IISMethods.setLocalData("s3jwttokens", session)
                            s3sessoin = session
                            resolve(s3sessoin)
                        }
                    })
                }
            )
            return promise
        }
    }

    /**
     * conver base64 to buffer
     * @param {base64} base64Data 
     * @returns Buffer datas object
     */

    async base64ToBuffer(base64Data) {
        var base64 = base64Data.split(',')
        var bufferData = Buffer.from(base64[1], 'base64')

        var ContentType = base64[0].split(':')
        ContentType = ContentType[1].split(';')
        ContentType = ContentType[0]

        var filetype = base64[0].split('/')

        filetype = filetype[1].split(';')
        filetype = filetype[0]

        var BufferObj = {
            bufferData: bufferData,
            filetype: filetype,
            ContentType: ContentType
        }
        return BufferObj
    }

    /**
     * upload file to s3
     *  @param {File Binary } reqBody 
     *  returns temp url if file uploads else null
     */

    async UploadTOS3(file, extension, contenttype, onProgress, s3Path = '', abortSignal, uploadPrivateS3 = false) {
        // Check and refresh authentication token if needed
        let decodedToken
        try {
            decodedToken = jwt_decode(s3sessoin?.idToken?.jwtToken || '')
        } catch (e) {
            // If token is invalid, re-authenticate and use simple upload
            await this.authenticate(this.getCurrentState().POOL_NAME, this.getCurrentState().POOL_PASS)
            return await IISMethods.UploadTOS3(file, extension, contenttype)
        }

        // Check token expiration and refresh if needed
        let currentDate = new Date()
        if (decodedToken?.exp * 1000 < currentDate.getTime()) {
            try {
                await this.refreshTOken(decodedToken)
            } catch (e) { }
        }

        // Determine upload method based on file size
        const maxSingleUploadSize = 50 * 1024 * 1024 // 50MB threshold

        if (file.size > maxSingleUploadSize) {
            // Use multipart upload for large files
            if (onProgress) {
                return await this.MultipartFileUpload(file, extension, contenttype, onProgress, s3Path, abortSignal, uploadPrivateS3)
            }
            else {
                return await this.MultipartFileUpload(file, extension, contenttype, null, s3Path, abortSignal, uploadPrivateS3)
            }
        } else {
            // Use simple upload for small files
            if (onProgress) {
                return await this.FileUpload(file, extension, contenttype, onProgress, s3Path, abortSignal, uploadPrivateS3)
            }
            else {
                return await this.FileUpload(file, extension, contenttype, null, s3Path, abortSignal, uploadPrivateS3)
            }
        }
    }

    async FileUpload(file, extension, contentType, onProgress, s3Path, abortSignal, uploadPrivateS3 = false) {
        const fileName = extension ? "" : this.getFileName(file);
        const fileExtension = extension ? extension : this.getFileExtention(fileName);
        const timestamp = IISMethods.GetTimestamp();
        const key = s3Path ? s3Path + timestamp + fileExtension : 'Bizcompass/temp/' + timestamp + fileExtension;

        // Generate unique ID outside the if block so it's available in the whole function
        const uploadId = `single-upload-${timestamp}-${Math.random().toString(36).substr(2, 9)}`;

        // Store upload for cancellation
        this.activeSingleUploads = this.activeSingleUploads || new Map();
        const uploadTracker = {
            upload: null,
            key: key,
            s3: null,
            canceled: false
        };

        if (abortSignal) {
            this.activeSingleUploads.set(uploadId, uploadTracker);

            // Set up abort listener
            abortSignal.addEventListener('abort', () => {
                uploadTracker.canceled = true;
                if (uploadTracker.upload) {
                    uploadTracker.upload.abort();
                }
            });
        }

        try {
            // Configure AWS
            const cognito_login_url = `cognito-idp.${Config.cognito_user_pool_region}.amazonaws.com/${this.getCurrentState().USER_POOL_ID}`
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: this.getCurrentState().IDENTITY_POOL_ID,
                Logins: {
                    [cognito_login_url]: s3sessoin.idToken.jwtToken
                }
            }, {
                region: Config.cognito_user_pool_region
            });

            const s3 = new AWS.S3({
                region: Config.cognito_user_pool_region,
                params: { Bucket: this.getCurrentState().S3_BUCKET_NAME }
            });

            uploadTracker.s3 = s3;

            // Check if already canceled
            if (uploadTracker.canceled) {
                throw new Error('Upload canceled');
            }
            const acl = uploadPrivateS3 ? 'private' : 'public-read'

            // Create upload
            const upload = s3.upload({
                Bucket: this.getCurrentState().S3_BUCKET_NAME,
                Key: key,
                Body: file,
                ACL: acl,
                ContentType: contentType || file.type
            });

            uploadTracker.upload = upload;

            if (onProgress) {
                upload.on('httpUploadProgress', function (progress) {
                    // Skip progress updates if canceled
                    if (uploadTracker.canceled) return;

                    let progressPercentage = Math.round((progress.loaded / progress.total) * 100);
                    onProgress(progressPercentage);
                });
            }

            const data = await upload.promise();

            // Clean up tracker
            if (abortSignal) {
                this.activeSingleUploads.delete(uploadId);
            }

            return data.Location;
        } catch (err) {
            // Only log error if not canceled
            if (!uploadTracker.canceled) {
                console.error("Upload failed: ", err);
            }

            // Clean up tracker
            if (abortSignal) {
                this.activeSingleUploads.delete(uploadId);
            }

            throw err;
        }
    }



    async MultipartFileUpload(file, extension, contentType, onProgress, s3Path, abortSignal, uploadPrivateS3 = false) {
        const MAX_CHUNK_SIZE = 50 * 1024 * 1024; // 50MB chunks
        const fileName = extension ? "" : this.getFileName(file);
        const fileExtension = extension ? extension : this.getFileExtention(fileName);
        const timestamp = IISMethods.GetTimestamp();
        const key = s3Path ? s3Path + timestamp + fileExtension : 'Bizcompass/temp/' + timestamp + fileExtension;

        // Progress tracking setup
        const partProgress = Array(Math.ceil(file.size / MAX_CHUNK_SIZE)).fill(0);
        let lastReportedProgress = 0;

        // Generate a unique ID for this upload that we can use throughout the function
        const uniqueUploadId = `upload-${timestamp}-${Math.random().toString(36).substr(2, 9)}`;

        // Store uploadId to allow for cancellation
        this.activeUploads = this.activeUploads || new Map();
        const uploadTracker = {
            uploadId: null,  // S3 multipart upload ID (will be set later)
            key: key,
            s3: null,
            canceled: false
        };

        if (abortSignal) {
            this.activeUploads.set(uniqueUploadId, uploadTracker);

            // Set up abort listener
            abortSignal.addEventListener('abort', async () => {
                uploadTracker.canceled = true;

                // Abort any active workers
                if (this.activeWorkers) {
                    for (const worker of this.activeWorkers.values()) {
                        worker.postMessage({ type: 'abort' });
                        worker.terminate();
                    }
                    this.activeWorkers.clear();
                }

                // Abort multipart upload if it was initiated
                if (uploadTracker.uploadId && uploadTracker.s3) {
                    try {
                        await uploadTracker.s3.abortMultipartUpload({
                            Bucket: this.getCurrentState().S3_BUCKET_NAME,
                            Key: uploadTracker.key,
                            UploadId: uploadTracker.uploadId
                        }).promise();
                        console.log("Multipart upload aborted successfully");
                    } catch (abortErr) {
                        console.error("Failed to abort multipart upload:", abortErr);
                    }
                }
            });
        }

        // Progress update handler
        const updateProgress = () => {
            // Skip progress updates if canceled
            if (uploadTracker.canceled) return;

            const totalUploaded = partProgress.reduce((sum, progress) => sum + progress, 0);
            const currentProgress = Math.min(90, (totalUploaded / partProgress.length) * 90);

            if (currentProgress > lastReportedProgress) {
                lastReportedProgress = currentProgress;
                if (onProgress) {
                    onProgress(Math.round(currentProgress));
                }
            }
        };

        // Configure AWS credentials using Cognito
        const cognito_login_url = `cognito-idp.${Config.cognito_user_pool_region}.amazonaws.com/${this.getCurrentState().USER_POOL_ID}`
        AWSService.config.credentials = new AWSService.CognitoIdentityCredentials({
            IdentityPoolId: this.getCurrentState().IDENTITY_POOL_ID,
            Logins: {
                [cognito_login_url]: s3sessoin.idToken.jwtToken
            }
        }, {
            region: Config.cognito_user_pool_region
        })

        const s3 = new AWSService.S3({
            region: Config.cognito_user_pool_region,
            params: { Bucket: this.getCurrentState().S3_BUCKET_NAME }
        });

        // Store s3 reference for abort operations
        if (uploadTracker) {
            uploadTracker.s3 = s3;
        }

        try {
            // Check if canceled before starting
            if (uploadTracker.canceled) {
                throw new Error('Upload canceled');
            }
            const acl = uploadPrivateS3 ? 'private' : 'public-read'
            // Initiate multipart upload
            const multipart = await s3.createMultipartUpload({
                Bucket: this.getCurrentState().S3_BUCKET_NAME,
                Key: key,
                ACL: acl,
                ContentType: contentType || file.type
            }).promise();

            // Store the S3 multipart upload ID in our tracker
            uploadTracker.uploadId = multipart.UploadId;

            // Check if canceled after initiation
            if (uploadTracker.canceled) {
                throw new Error('Upload canceled');
            }

            // Prepare parts for upload
            const partMap = [];
            const partPromises = [];
            const totalParts = partProgress.length;

            // Process each part in parallel using workers
            for (let partNum = 1; partNum <= totalParts; partNum++) {
                // Check if canceled before starting each part
                if (uploadTracker.canceled) {
                    throw new Error('Upload canceled');
                }

                const start = (partNum - 1) * MAX_CHUNK_SIZE;
                const end = Math.min(start + MAX_CHUNK_SIZE, file.size);
                const chunk = file.slice(start, end);

                const partParams = {
                    Body: chunk,
                    Bucket: this.getCurrentState().S3_BUCKET_NAME,
                    Key: key,
                    PartNumber: partNum,
                    UploadId: uploadTracker.uploadId
                };

                partPromises.push(
                    this.uploadPartWithWorker(
                        partParams,
                        {
                            IdentityPoolId: this.getCurrentState().IDENTITY_POOL_ID,
                            Logins: { [cognito_login_url]: s3sessoin.idToken.jwtToken },
                            accessKeyId: AWS.config.credentials.accessKeyId,
                            secretAccessKey: AWS.config.credentials.secretAccessKey,
                            sessionToken: AWS.config.credentials.sessionToken
                        },
                        (bytesUploaded, totalBytes) => {
                            partProgress[partNum - 1] = bytesUploaded / totalBytes;
                            updateProgress();
                        },
                        abortSignal // Pass abort signal to worker
                    )
                );
            }

            // Wait for all parts to complete
            const uploadedParts = await Promise.all(partPromises);

            // Check if canceled after parts complete
            if (uploadTracker.canceled) {
                throw new Error('Upload canceled');
            }

            uploadedParts.forEach(({ ETag, PartNumber }) => {
                partMap.push({
                    ETag,
                    PartNumber
                });
            });

            // Simulate finalization progress (90-100%)
            for (let progress = 90; progress <= 100; progress += 5) {
                if (uploadTracker.canceled) {
                    throw new Error('Upload canceled');
                }
                await new Promise(resolve => setTimeout(resolve, 100));
                if (onProgress) onProgress(progress);
            }

            // Complete the multipart upload
            const completeParams = {
                Bucket: this.getCurrentState().S3_BUCKET_NAME,
                Key: key,
                UploadId: uploadTracker.uploadId,
                MultipartUpload: {
                    Parts: partMap.sort((a, b) => a.PartNumber - b.PartNumber)
                }
            };

            const completedUpload = await s3.completeMultipartUpload(completeParams).promise();
            if (onProgress) onProgress(100);

            // Clean up upload tracker
            if (abortSignal) {
                this.activeUploads.delete(uniqueUploadId);
            }

            return completedUpload.Location;

        } catch (err) {
            console.error("Upload failed: ", err);

            // Only attempt to abort if not already canceled and we have an uploadId
            if (!uploadTracker.canceled && uploadTracker.uploadId) {
                try {
                    await s3.abortMultipartUpload({
                        Bucket: this.getCurrentState().S3_BUCKET_NAME,
                        Key: key,
                        UploadId: uploadTracker.uploadId
                    }).promise();
                } catch (abortErr) {
                    console.error("Failed to abort multipart upload:", abortErr);
                }
            }

            // Clean up upload tracker
            if (abortSignal) {
                this.activeUploads.delete(uniqueUploadId);
            }

            throw err;
        }
    }

    async uploadPartWithWorker(partParams, creds, onProgress, abortSignal) {
        return new Promise((resolve, reject) => {
            const worker = new Worker('/upload.worker.js');

            // Store worker reference to allow cancellation
            if (abortSignal) {
                // Add worker to a map of active workers
                this.activeWorkers = this.activeWorkers || new Map();
                this.activeWorkers.set(partParams.PartNumber, worker);

                // Clean up when aborted
                abortSignal.addEventListener('abort', () => {
                    worker.postMessage({ type: 'abort' });
                    worker.terminate();
                    this.activeWorkers.delete(partParams.PartNumber);
                    reject(new Error('Upload canceled'));
                });
            }

            // Handle worker messages (progress, completion, errors)
            worker.onmessage = (e) => {
                const data = e.data;
                switch (data.type) {
                    case 'progress':
                        if (onProgress) {
                            onProgress(data.bytesUploaded, data.totalBytes);
                        }
                        break;
                    case 'complete':
                        resolve({
                            ETag: data.ETag,
                            PartNumber: data.PartNumber,
                            bytesUploaded: data.bytesUploaded
                        });
                        if (abortSignal) {
                            this.activeWorkers.delete(partParams.PartNumber);
                        }
                        worker.terminate();
                        break;
                    case 'error':
                        reject(new Error(data.error));
                        if (abortSignal) {
                            this.activeWorkers.delete(partParams.PartNumber);
                        }
                        worker.terminate();
                        break;
                }
            };

            worker.onerror = (err) => {
                reject(err);
                if (abortSignal) {
                    this.activeWorkers.delete(partParams.PartNumber);
                }
                worker.terminate();
            };

            // Send upload task to worker
            worker.postMessage({
                partParams,
                creds,
            });
        });
    }

    /**
    * Asynchronously generates a presigned S3 URL to access a file.
    * 
    * @param {string} file - The full S3 file URL (with or without region). Used to extract the S3 object key.
    * @returns {Promise<string>} - A presigned URL that allows temporary access to the specified S3 object.
    */
    async getPresignedS3URL(file) {
        try {
            // Step 1: Decode JWT token from the current session to check its expiry
            let decodedToken;
            try {
                decodedToken = jwt_decode(s3sessoin?.idToken?.jwtToken || '');
            } catch (e) {
                // If token can't be decoded, it may be invalid or missing
            }

            // Step 2: If token is expired, try to refresh it
            let currentDate = new Date();
            if (decodedToken?.exp * 1000 < currentDate.getTime()) {
                try {
                    await this.refreshTOken(decodedToken); // Typo in function name? Should be refreshToken
                } catch (e) {
                    // Handle token refresh failure silently
                }
            }

            // Step 3: Configure AWS Cognito credentials
            const cognito_login_url = `cognito-idp.${Config.cognito_user_pool_region}.amazonaws.com/${this.getCurrentState().USER_POOL_ID}`;

            // Set credentials using Cognito Identity Pool
            AWSService.config.credentials = new AWSService.CognitoIdentityCredentials({
                IdentityPoolId: this.getCurrentState().IDENTITY_POOL_ID,
                Logins: {
                    [cognito_login_url]: s3sessoin.idToken.jwtToken
                }
            }, {
                region: Config.cognito_user_pool_region
            });

            // Step 4: Resolve the credentials to get temporary AWS credentials
            await new Promise((resolve, reject) => {
                AWSService.config.credentials.get((err) => {
                    if (err) return reject(err);
                    resolve();
                });
            });

            // Step 5: Update the AWS config with the retrieved credentials
            AWSService.config.update({
                credentials: new AWS.Credentials(
                    AWSService.config.credentials.accessKeyId,
                    AWSService.config.credentials.secretAccessKey,
                    AWSService.config.credentials.sessionToken
                )
            });

            // Step 6: Instantiate S3 service object
            const s3 = new AWSService.S3();

            // Step 7: Validate and extract S3 key from the file URL
            if (file) {
                let s3Key;

                // Check which base URL pattern is present and extract the key
                if (file.includes(Config.s3UrlWithRegion)) {
                    s3Key = decodeURIComponent(file.split(Config.s3UrlWithRegion)[1]);
                } else if (file.includes(Config.s3UrlWithoutRegion)) {
                    s3Key = decodeURIComponent(file.split(Config.s3UrlWithoutRegion)[1]);
                } else {
                    console.error("URL format not recognized:", file);
                    return "";
                }

                // Ensure extracted key is valid
                if (!s3Key || s3Key === 'undefined') {
                    console.error("Invalid s3Key extracted:", s3Key);
                    return "";
                }

                // Step 8: Prepare parameters for S3 getSignedUrl
                const params = {
                    Bucket: this.getCurrentState().S3_BUCKET_NAME,
                    Key: s3Key,
                    Expires: Config.presignedurlexpiration, // e.g., 60 seconds
                };

                // Step 9: Generate presigned URL and return
                const presignedURL = await s3.getSignedUrlPromise("getObject", params);
                return presignedURL;
            }

            // If no file was provided, return an empty string
            return "";

        } catch (err) {
            // Catch all errors during the process and return an empty string
            console.error("getPresignedS3URL error:", err);
            return "";
        }
    }


    /**
     * upload file to s3 
     * @param {FormData} reqBody 
     * @param {Boolean} showResponseMessage 
     * used in uploading images . files, video , audio
     */
    // async UploadTOS3(reqBody,showResponseMessage = true, showMessageOnError = false , cancelToken = null){
    //     const loginInfo = this.getCookiesData("loginInfo")
    //     const url = Config.weburl + 'uploadfile'
    //     let reqheader = {
    //         token: loginInfo.token,
    //         issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
    //         unqkey: loginInfo.unqkey,
    //         uid: loginInfo.uid,
    //         platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
    //         // useraction: useraction,
    //         pagename: this.getpagename(),
    //         subdomainname: loginInfo?.subdomainname,
    //         username: loginInfo.firstname + ' ' + loginInfo.lastname,
    //         companyid: loginInfo.companyid,
    //         branchid: loginInfo.branchid,
    //         userroleid: loginInfo.userroleid,
    //         version : Config.version
    //         // for public ip
    //         // publicip : loginInfo.clientpublicip
    //     }

    //     // hemang jani 30/01/23
    //     // encrypt req header
    //     if( Config.encryptdata ){
    //         reqHeaders = {reqheader : this.encryptData(reqheader) } 
    //     }
    //     else{
    //         reqHeaders = {...reqheader}
    //     }

    //     // if(Config.encryptdata ){
    //     //     this.Log('requestname',this.getpagename())
    //     //     this.Log('decryptData')

    //     //     reqBody = {reqbody : this.encryptData(reqBody)}

    //     // }
    //     await this.axiosrequest(IISMethods.getCurrentState()['REACT_APP_METHOD_POST'], url, reqBody, reqHeaders, uploadtos3SuccessCallback.bind(this), uploadtos3ErrorCallback.bind(this),cancelToken)

    //     function uploadtos3SuccessCallback(res) {
    //         if(Config.encryptdata){
    //             try{
    //                 resBody =  JSON.parse(JSON.parse(this.decryptData(res.data)))
    //             }
    //             catch(e){
    //                 resBody = res.data
    //             }

    //             // decrypt res header
    //             // hemang jani 30/01/23
    //             if(res.headers.reqheader){
    //                 resHeaders = JSON.parse(JSON.parse(this.decryptData( res.headers ))) 
    //             }
    //             else{
    //                 resHeaders = res.headers
    //             }
    //         }
    //         else{
    //             resBody = res.data
    //             // hemang jani 30/01/23
    //             resHeaders = res.headers
    //         }
    //     }

    //     function uploadtos3ErrorCallback(error) {
    //         if( Config.encryptdata){
    //             try{
    //                 resBody =  JSON.parse(JSON.parse(this.decryptData( error.response.data)))
    //             }
    //             catch(e){
    //                 resBody = error.response.data
    //             }

    //             if(resBody.updateversion){
    //                 IISMethods.HardRefresh()
    //             }

    //             // decrypt res header
    //             // hemang jani 30/01/23
    //             if(error.response.headers.reqheader){
    //                 resHeaders = JSON.parse(JSON.parse(this.decryptData( error.response.headers )))
    //             }
    //             else{
    //                 resHeaders = error.response.headers
    //             }
    //         }
    //         else{
    //             resBody = error.response.data
    //             if(resBody.updateversion){
    //                 IISMethods.HardRefresh()
    //             }
    //             // hemang jani 30/01/23
    //             resHeaders = error.response.headers
    //         }
    //     }

    //     this.sessionExpiry(resBody)
    //     this.tokenExpiry(resHeaders)
    //     if (showResponseMessage || (showMessageOnError && resBody.status !== 200)){
    //         this.notify(resBody.message,0,resBody)
    //     }

    //     return resBody
    // }
    //upload file to s3 

    // for get data by id
    // used in update data logic
    async getDataById(id, url = '', useraction = '', pagename = undefined, filter = undefined, key) {

        let filterData
        if (filter) {
            filterData = { ...filter, '_id': id }
        } else {
            if (key === "leaveapproval") {
                filterData = { 'subleaveid': id }
            } else {
                filterData = { '_id': id }
            }
        }
        const reqBody = {
            searchtext: '',
            paginationinfo: {
                pageno: 1,
                pagelimit: 20,
                filter: filterData,
                sort: {}
            }
        }

        let { resBody } = await IISMethods.socketListData(url, reqBody, useraction, undefined, undefined, pagename)
        
        if (resBody.status === 200) {
            if (resBody.data?.length > 0) {
                if (key === 'licensesdata') { //  smit surani  ~ 2025-05-21 ~ 019:32 PM
                    return resBody
                } else {
                    return resBody.data[0]
                }
            }
            else return {}
        }
        else return {}
    }

    // encrypt
    /**
     * @param {bool} isId when encrypting ids  - uid, openingid
    //  * @param {bool} idWithoutFilter true when copying openings with active/all filter "61fb6ff57e03cfd119505694&stactive"
     */
    encryptData(data, isId = false) {
        const randomiv = this.generateRandomIv()
        const secretKey = CryptoJS.enc.Utf8.parse(this.getCurrentState()['REACT_APP_SECRETKEY'])
        const iv = CryptoJS.enc.Utf8.parse(randomiv)
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey, { iv: iv })
        if (isId) {
            // if(idWithoutFilter){
            //     return encrypted.toString() + randomiv
            // }
            // else{
            return encrypted.toString() + "=" + randomiv
            // }
        }
        else {
            return encrypted.toString() + '.' + randomiv
        }
    }

    handleDecryptUrlId (id) {
        let myencryptedId
        try {
            let encodedId = decodeURIComponent(id);
            let isDecrypted = IISMethods.isEncryptedId(encodedId)
            if (!isDecrypted) {
                myencryptedId = IISMethods.decryptData(encodedId, true)
            } else {
                myencryptedId = ''
            }

        } catch (error) {
            console.log(error)
            myencryptedId = ""

        }
        return myencryptedId.replace(/^"|"$/g, '')?.length ? myencryptedId.replace(/^"|"$/g, '') : id
    }
    //**
    //   * 
    //   * @param {String} str  pass that you want to split from last 
    //   * @param {String} delimiter element or char
    //   */ //Jatin 12-07-24 11:02 AM
    splitStringFromEnd(str, delimiter) {
        const lastIndex = str?.lastIndexOf(delimiter);
        if (lastIndex === -1) {
            return [str];
        }
        return [str.substring(0, lastIndex), str.substring(lastIndex + 1)];
    }


    // decrypt
    /**
     * @param {bool} isId when decrypting ids - uid, openingid 
     */
    decryptData(data, isId = false) {
        let plaintext
        const secretKey = CryptoJS.enc.Utf8.parse(this.getCurrentState()['REACT_APP_SECRETKEY'])
        // const secretKey = CryptoJS.enc.Hex.parse(Config.getSekretkey())
        let ciphertext
        if (isId) {
            ciphertext = this.splitStringFromEnd(data, '=')
            // const splitIndex = data?.indexOf('=');
            // ciphertext = [
            //     data?.slice(0, splitIndex), 
            //     data?.slice(splitIndex + 1)     
            // ];
        }
        else {
            ciphertext = data?.split('.')
        }
        let message = ciphertext[0]
        let iv = CryptoJS.enc.Utf8.parse(ciphertext[1])
        const bytes = CryptoJS.AES.decrypt(message, secretKey, { iv: iv })
        plaintext = bytes.toString(CryptoJS.enc.Utf8)
        return plaintext
    }

    // NR ~ 01-09-2023 ~ 02:26 PM ~ get data Encryted/Descripted
    getEDD(mode = 0, data) {
        let key = Config.encryptSocketData ? mode : 0
        switch (key) {
            case 1:
                return this.encryptData(data)

            case 2:
                return JSON.parse(this.decryptData(data))
            // return this.decryptData(data)

            default:
                return data || null
        }
        // if (Config.encryptdata) return this.encryptData(data)
    }

    // JATIN 29-07-2024  get id with URL Uncoded for series id set as routing  getEncodeID  , getDecodeID
    getEncodeID(id) {
        if (typeof id !== "undefined") {
            return encodeURIComponent(id)
        }
        else return false
    }
    getDecodeID(id) {
        if (typeof id !== "undefined") {
            return decodeURIComponent(id)
        }
        else return false
    }
    // JATIN 8/08/2024  12:15 PM Check encrypted id or not  
    isEncryptedId(id) {
        // Identify Mongo ObjectID or not
        const objectIdPattern = /^[a-fA-F0-9]{24}$/;
        return objectIdPattern.test(id);
    };

    // get random 16-bit iv for encryption/decryption
    generateRandomIv(length = 16) {
        return this.generateRandomString(length)
    }

    /**
     * generate n-length random alpha numeric str
     * @param {Number} length 
     * @returns 
     */
    generateRandomString(length) {
        let result = ''
        const charactersLength = characters?.length
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength))
        }
        return result
    }

    /**
     * set replace Html Variables
     * @param {string} HtmlData Data where to find tags  
     * @param {object} objData which tags have to replace
     * @param {object} isReplaceTag which used to some definded tag will replace  
     * @returns 
     */
    setHtmlVariables(HtmlData, objData) {
        let startIndex = -1
        let result = []

        try {
            for (let strchar = 0; strchar <= HtmlData?.length; strchar++) {
                if (HtmlData.charAt(strchar) === '#') {
                    startIndex = strchar
                }
                else if (HtmlData.charAt(strchar) === '?') {
                    if (startIndex !== -1) {
                        result.push(HtmlData.substring(
                            parseInt(startIndex),
                            parseInt(strchar) + 1
                        ))
                    }
                }
            }
        }
        catch {

        }
        for (let i = -0; i < result?.length; i++) {
            HtmlData = HtmlData.replaceAll(result[i].substring(0, result[i]?.length), objData[result[i].substring(1, result[i]?.length - 1)])
        }

        return HtmlData
    }


    // Set the client IP in cookies
    setIP(data) {
        let loginInfo = this.getCookiesData("loginInfo")

        // Check if data contains IP 
        if (data && data.ip) {
            loginInfo.clientpublicip = data.ip
            this.setCookiesData("loginInfo", loginInfo)
        } else {
            console.error('Invalid IP data')
        }
    }

    // Fetch the client public IP and set it in cookies
    async getClientPublicIP() {
        try {
            let url = 'https://api.ipify.org?format=json'

            // Fetch the public IP using Axios
            const res = await axios.get(url)

            // Set the IP if data is valid
            this.setIP(res.data)

            // Handle session and token expiry
            // this.sessionExpiry(resBody)
            // this.tokenExpiry(resHeaders)

            return res.data;
        } catch (error) {
            console.error('Error fetching client public IP:', error)
            return null
        }
    }

    async socketListData(urlPara, reqBodyPara, useraction, masterlisting, mainDb = {}, pagename = undefined, showMessageOnError = false, cancelToken = null, publicFormHeader = false) {
        const loginInfo = this.getCookiesData("loginInfo")
        //PRIYANSHI --> SOCKET
        let resBody = {}, resHeaders = {}, reqHeaders = {}, reqheader = {}

        if (publicFormHeader) {
            reqheader = IISMethods.getCopy(publicFormHeader || {})
        }
        else {
            reqheader = {
                token: loginInfo.token,
                issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
                unqkey: loginInfo.unqkey,
                uid: loginInfo.uid,
                platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
                useraction: useraction,
                // temperory condition 
                pagename: pagename ? pagename : this.getpagename(),
                subdomainname: loginInfo?.subdomainname,
                username: loginInfo.firstname + ' ' + loginInfo.lastname,
                companyid: loginInfo.companyid,
                branchid: loginInfo.branchid,
                //Priyanshi Userrole  --> need change
                userroleid: loginInfo.userroleid,
                masterlisting: masterlisting ? true : false,
                ...mainDb,
                version: Config.version,
                moduletype: 'web'
                // for public ip
                // publicip : loginInfo.clientpublicip
            }
            reqheader['publicip'] = loginInfo.clientpublicip

        }


        //PRIYANSHI --> SOCKET 
        let userAgent = navigator.userAgent
        if (userAgent && Config.callSocketApi) {
            reqheader['user-agent'] = userAgent

        }

        // encrypt req header
        if (Config.encryptdata) {
            reqHeaders = { reqheader: this.encryptData(reqheader) }
        }
        else {
            reqHeaders = { ...reqheader }
        }

        // to check double encryption 
        let index = -1
        try {
            if (reqBodyPara) {
                index = reqBodyPara?.indexOf('.')
            }

        } catch { index = -1 }

        if (Config.encryptdata && index == -1) {
            if (!reqBodyPara.reqbody) {
                reqBodyPara = { reqbody: this.encryptData(reqBodyPara) }
            }
        }

        // if(url == undefined){
        // }


        let showCommonNotify = true

        // const tempurl = urlPara
        // const includesUrl = Config.reqUrlArr?.some(path => tempurl?.includes(path))
        // console.log(tempurl, 'tempurltempurl')
        // //for replace weburl with pmsweburl in some api
        // if (includesUrl) {
        //     url = tempurl.replace(Config.weburl, Config.pmsweburl)
        // }
        // else {
        //     url = urlPara
        // }
        // console.log(url, 'tempurltempurlurl')
        //PRIYANSHI --> SOCKET
        if (publicFormHeader) {
            await this.callApiFrom(IISMethods.getCurrentState()['REACT_APP_METHOD_POST'], urlPara, reqBodyPara, reqHeaders, listDataSuccessCallback.bind(this), listDataErrorCallback.bind(this), cancelToken)
        }
        else {
            await this.callApiFrom(IISMethods.getCurrentState()['REACT_APP_METHOD_POST'], urlPara, reqBodyPara, reqHeaders, listDataSuccessCallback.bind(this), listDataErrorCallback.bind(this), cancelToken)

        }


        function listDataSuccessCallback(res) {
            if (Config.encryptdata) {
                try {

                    resBody = JSON.parse(JSON.parse(this.decryptData(res.data)))
                }
                catch (e) {
                    resBody = res.data
                }

                // decrypt res header
                if (res.headers.reqheader) {
                    resHeaders = JSON.parse(JSON.parse(this.decryptData(res.headers)))
                }
                else {
                    resHeaders = res.headers
                }
            }
            else {
                resBody = res.data
                resHeaders = res.headers
            }
        }

        async function listDataErrorCallback(error, errorWithRes) {
            //if request failed and res than go in this condition
            if (error?.response) {
                if (Config.encryptdata) {
                    // decrypt res body
                    try {

                        resBody = JSON.parse(JSON.parse(this.decryptData(error.response.data)))

                    }
                    catch (e) {
                        resBody = error.response.data
                    }
                    //PRIYANSHI --> SOCKET
                    if (!publicFormHeader) {
                        if (resBody.data?.autologout) {
                            await this.logout();
                            return;
                        }

                    }
                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }

                    // decrypt res header
                    if (error.response.headers.reqheader) {
                        resHeaders = JSON.parse(JSON.parse(this.decryptData(error.response.headers)))
                    }
                    else {
                        resHeaders = error.response.headers
                    }
                }
                else {

                    resBody = error.response.data
                    //PRIYANSHI --> SOCKET
                    if (!publicFormHeader) {
                        if (resBody.data?.autologout) {
                            await this.logout();
                            return;
                        }
                    }
                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }
                    // resHeaders = !error.message ? error.response.headers : {}
                    resHeaders = error.response.headers
                }
            }
            //if request failed and without res in any case than go in this condition
            else if (!errorWithRes) {
                resBody = {}
                showCommonNotify = false
                return
            }

            // add error for version conflict
        }

        this.sessionExpiry(resBody)
        this.tokenExpiry(resHeaders)
        if (showMessageOnError && resBody.status !== 200) {
            if (showCommonNotify) {
                this.notify(resBody.message, 0, resBody)
            }
        }

        return { resBody, resHeaders }
    }

    async socketAddData(urlPara, reqBodyPara, useraction, showResponseMessage = true, pagename = undefined, showMessageOnError = false) {
        const loginInfo = this.getCookiesData("loginInfo")
        //PRIYANSHI --> SOCKET
        let resBody = {}, resHeaders = {}, reqHeaders = {}
        let reqheader = {
            token: loginInfo.token,
            issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
            unqkey: loginInfo.unqkey,
            uid: loginInfo.uid,
            platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
            useraction: useraction,
            pagename: pagename ? pagename : this.getpagename(),
            subdomainname: loginInfo?.subdomainname,
            username: loginInfo.firstname + ' ' + loginInfo.lastname,
            companyid: loginInfo.companyid,
            branchid: loginInfo.branchid,
            //Priyanshi Userrole  --> need change
            userroleid: loginInfo.userroleid,
            version: Config.version,
            moduletype: 'web'
            // for public ip
            // publicip : loginInfo.clientpublicip
        }

        //PRIYANSHI --> SOCKET 
        let userAgent = navigator.userAgent
        if (userAgent && Config.callSocketApi) {
            reqheader['user-agent'] = userAgent

        }
        reqheader['publicip'] = loginInfo.clientpublicip

        // encrypt req header
        if (Config.encryptdata) {
            reqHeaders = { reqheader: this.encryptData(reqheader) }
        }
        else {
            reqHeaders = { ...reqheader }
        }


        // find page json & send checkdata key 
        const pageJson = findAliasJson(this.getCurrentState()?.bizConfigData, reqheader.pagename)
        if (pageJson) {
            reqBodyPara['checkdata'] = (pageJson?.status == 1) ? 0 : 1;
        }

        if (Config.encryptdata) {
            if (reqBodyPara && urlPara) {
                if (!reqBodyPara.reqbody) {
                    reqBodyPara = { reqbody: this.encryptData(reqBodyPara) }
                }
            }
        }

        let showCommonNotify = true

        await this.callApiFrom(IISMethods.getCurrentState()['REACT_APP_METHOD_POST'], urlPara, reqBodyPara, reqHeaders, addDataSuccessCallback.bind(this), addDataErrorCallback.bind(this))

        function addDataSuccessCallback(res) {

            if (Config.encryptdata) {
                try {

                    resBody = JSON.parse(JSON.parse(this.decryptData(res.data)))

                }
                catch (e) {
                    // 
                    resBody = res.data
                }

                // decrypt res header
                if (res.headers.reqheader) {
                    resHeaders = JSON.parse(JSON.parse(this.decryptData(res.headers)))
                }
                else {
                    resHeaders = res.headers
                }
            }
            else {
                resBody = res.data
                resHeaders = res.headers
            }
        }

        async function addDataErrorCallback(error, errorWithRes) {
            //if request failed and res than go in this condition
            if (error?.response) {
                if (Config.encryptdata) {
                    try {
                        resBody = JSON.parse(JSON.parse(this.decryptData(error.response.data)))
                    }
                    catch (e) {
                        resBody = error.response.data
                    }

                    if (resBody.data?.autologout) {
                        await this.logout();
                        return;
                    }

                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }

                    // decrypt res header
                    if (error.response.headers.reqheader) {
                        resHeaders = JSON.parse(JSON.parse(this.decryptData(error.response.headers)))
                    }
                    else {
                        resHeaders = error.response.headers
                    }
                }
                else {
                    resBody = error.response.data

                    if (resBody.data?.autologout) {
                        await this.logout();
                        return;
                    }

                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }
                    resHeaders = error.response.headers
                }

            }
            //if request failed and without res in any case than go in this condition
            else if (!errorWithRes) {
                resBody = {}
                showCommonNotify = false
                return
            }
        }

        this.sessionExpiry(resBody)
        this.tokenExpiry(resHeaders)
        if (showResponseMessage || (showMessageOnError && resBody.status !== 200)) {
            if (showCommonNotify) {
                this.notify(resBody.message, 0, resBody)
            }

        }

        return { resBody, resHeaders }
    }

    async socketUpdateData(urlPara, reqBodyPara, useraction, showResponseMessage = true, pagename = undefined, showMessageOnError = false) {
        const loginInfo = this.getCookiesData("loginInfo")
        //PRIYANSHI --> SOCKET
        let reqHeaders = {}, resBody = {}, resHeaders = {}
        let reqheader = {
            token: loginInfo.token,
            issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
            unqkey: loginInfo.unqkey,
            uid: loginInfo.uid,
            platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
            useraction: useraction,
            pagename: pagename ? pagename : this.getpagename(),
            subdomainname: loginInfo?.subdomainname,
            username: loginInfo.firstname + ' ' + loginInfo.lastname,
            companyid: loginInfo.companyid,
            branchid: loginInfo.branchid,
            //Priyanshi Userrole  --> need change
            userroleid: loginInfo.userroleid,
            version: Config.version,
            moduletype: 'web'
            // for public ip
            // publicip : loginInfo.clientpublicip
        }

        //PRIYANSHI --> SOCKET 
        let userAgent = navigator.userAgent
        if (userAgent && Config.callSocketApi) {
            reqheader['user-agent'] = userAgent

        }

        reqheader['publicip'] = loginInfo.clientpublicip

        // encrypt req header

        if (Config.encryptdata) {
            reqHeaders = { reqheader: this.encryptData(reqheader) }
        }
        else {
            reqHeaders = { ...reqheader }
        }


        if (Config.encryptdata) {
            if (reqBodyPara && urlPara) {
                if (!reqBodyPara.reqbody) {
                    reqBodyPara = { reqbody: this.encryptData(reqBodyPara) }
                }
            }
        }

        let showCommonNotify = true

        await this.callApiFrom(IISMethods.getCurrentState()['REACT_APP_METHOD_POST'], urlPara, reqBodyPara, reqHeaders, upadateDataSuccessCallback.bind(this), upadateDataErrorCallback.bind(this))

        function upadateDataSuccessCallback(res) {
            if (Config.encryptdata) {
                try {
                    resBody = JSON.parse(JSON.parse(this.decryptData(res.data)))

                }
                catch (e) {
                    IISMethods.setLocalData("TaskUpdateInfo", new Date())
                    IISMethods.setLocalData("TaskUpdateInfoUrl", urlPara)
                    resBody = res.data
                }


                // decrypt res header
                if (res.headers.reqheader) {
                    resHeaders = JSON.parse(JSON.parse(this.decryptData(res.headers)))
                }
                else {
                    resHeaders = res.headers
                }
            }
            else {
                resBody = res.data
                resHeaders = res.headers
            }
        }

        async function upadateDataErrorCallback(error, errorWithRes) {

            //if request failed and res than go in this condition
            if (error?.response) {
                if (Config.encryptdata) {
                    try {
                        resBody = JSON.parse(JSON.parse(this.decryptData(error.response.data)))

                    }
                    catch (e) {
                        IISMethods.setLocalData("TaskUpdateInfo", new Date())
                        IISMethods.setLocalData("TaskUpdateInfoUrl", urlPara)
                        resBody = error.response.data
                    }

                    if (resBody.data?.autologout) {
                        await this.logout();
                        return;
                    }

                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }
                    // decrypt res header
                    if (error.response.headers.reqheader) {
                        resHeaders = JSON.parse(JSON.parse(this.decryptData(error.response.headers)))
                    }
                    else {
                        resHeaders = error.response.headers
                    }

                }
                else {
                    resBody = error.response.data

                    if (resBody.data?.autologout) {
                        await this.logout();
                        return;
                    }

                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }
                    resHeaders = error.response.headers
                }

            }
            //if request failed and without res in any case than go in this condition
            else if (!errorWithRes) {
                resBody = {}
                showCommonNotify = false
                return
            }
        }

        this.sessionExpiry(resBody)
        this.tokenExpiry(resHeaders)
        if (showResponseMessage || (showMessageOnError && resBody.status !== 200)) {
            if (showCommonNotify) {
                this.notify(resBody.message, 0, resBody)
            }
        }

        return { resBody, resHeaders }
    }

    async socketDeleteData(urlPara, reqBodyPara, useraction, showResponseMessage = true, pagename = undefined, showMessageOnError = false) {
        const loginInfo = this.getCookiesData("loginInfo")
        //PRIYANSHI --> SOCKET
        let reqHeaders = {}, resBody = {}, resHeaders = {}
        let reqheader = {
            token: loginInfo.token,
            issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
            unqkey: loginInfo.unqkey,
            uid: loginInfo.uid,
            platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
            useraction: useraction,
            pagename: pagename ? pagename : this.getpagename(),
            subdomainname: loginInfo?.subdomainname,
            username: loginInfo.firstname + ' ' + loginInfo.lastname,
            companyid: loginInfo.companyid,
            branchid: loginInfo.branchid,
            //Priyanshi Userrole  --> need change
            userroleid: loginInfo.userroleid,
            version: Config.version,
            moduletype: 'web'
            // for public ip
            // publicip : loginInfo.clientpublicip
        }

        //PRIYANSHI --> SOCKET 
        let userAgent = navigator.userAgent
        if (userAgent && Config.callSocketApi) {
            reqheader['user-agent'] = userAgent

        }

        reqheader['publicip'] = loginInfo.clientpublicip

        // encrypt req header
        if (Config.encryptdata) {
            reqHeaders = { reqheader: this.encryptData(reqheader) }
        }
        else {
            reqHeaders = { ...reqheader }
        }

        // if (Config.encryptdata) {
        //     if (!reqBody.reqbody) {
        //         reqBody = { reqbody: this.encryptData(reqBody) }
        //     }
        // }
        // find page json & send checkdata key 

        if (Config.encryptdata) {
            if (reqBodyPara && urlPara) {
                if (!reqBodyPara.reqbody) {
                    reqBodyPara = { reqbody: this.encryptData(reqBodyPara) }
                }
            }

        }

        let showCommonNotify = true


        await this.callApiFrom(IISMethods.getCurrentState()['REACT_APP_METHOD_DEL'], urlPara, reqBodyPara, reqHeaders, deleteDataSuccessCallback.bind(this), deleteDataErrorCallback.bind(this))

        function deleteDataSuccessCallback(res) {
            if (Config.encryptdata) {
                try {
                    resBody = JSON.parse(JSON.parse(this.decryptData(res.data)))

                }
                catch (e) {
                    resBody = res.data
                }

                // decrypt res header
                if (res.headers.reqheader) {
                    resHeaders = JSON.parse(JSON.parse(this.decryptData(res.headers)))
                }
                else {
                    resHeaders = res.headers
                }
            }
            else {
                resBody = res.data
                resHeaders = res.headers
            }
        }

        async function deleteDataErrorCallback(error, errorWithRes) {

            //if request failed and res than go in this condition
            if (error?.response) {
                if (Config.encryptdata) {
                    try {
                        resBody = JSON.parse(JSON.parse(this.decryptData(error.response.data)))

                    }
                    catch (e) {
                        resBody = error.response.data
                    }

                    if (resBody.data?.autologout) {
                        await this.logout();
                        return;
                    }

                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }

                    // decrypt res header
                    if (error.response.headers.reqheader) {
                        resHeaders = JSON.parse(JSON.parse(this.decryptData(error.response.headers)))
                    }
                    else {
                        resHeaders = error.response.headers
                    }
                }
                else {
                    resBody = error.response.data

                    if (resBody.data?.autologout) {
                        await this.logout();
                        return;
                    }

                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }
                    resHeaders = error.response.headers
                }

            }
            //if request failed and without res in any case than go in this condition
            else if (!errorWithRes) {
                resBody = {}
                showCommonNotify = false
                return
            }
        }

        this.sessionExpiry(resBody)
        this.tokenExpiry(resHeaders)
        if (showResponseMessage || (showMessageOnError && resBody.status !== 200)) {
            if (showCommonNotify) {
                this.notify(resBody.message, 0, resBody)
            }
        }

        return { resBody, resHeaders }
    }

    async socketUpdateFieldOrder(tablename, fieldorder, useraction, showMessageOnError = false, pagename = undefined) {
        const url = Config.weburl + 'fieldorder/add'

        const loginInfo = this.getCookiesData("loginInfo")
        //PRIYANSHI --> SOCKET
        let resBody = {}, resHeaders = {}, reqHeaders = {}
        let reqheader = {
            token: loginInfo.token,
            issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
            unqkey: loginInfo.unqkey,
            uid: loginInfo.uid,
            platform: IISMethods.getCurrentState()['REACT_APP_PLATFORM'],
            useraction: useraction,
            pagename: pagename ? pagename : this.getpagename(),
            subdomainname: loginInfo?.subdomainname,
            username: loginInfo.firstname + ' ' + loginInfo.lastname,
            companyid: loginInfo.companyid,
            branchid: loginInfo.branchid,
            //Priyanshi Userrole  --> need change
            userroleid: loginInfo.userroleid,
            version: Config.version,
            moduletype: 'web'
            // for public ip
            // publicip : loginInfo.clientpublicip
        }



        // encrypt req header
        if (Config.encryptdata) {
            reqHeaders = { reqheader: this.encryptData(reqheader) }
        }
        else {
            reqHeaders = { ...reqheader }
        }

        let reqBody = {}
        if (Config.encryptdata) {
            reqBody = {
                pagename: tablename,
                userid: loginInfo.uid,
                fields: fieldorder
            }
            if (!reqBody.reqbody) {
                reqBody = { reqbody: this.encryptData(reqBody) }
            }
        }
        else {
            reqBody = {
                pagename: tablename,
                userid: loginInfo.uid,
                fields: fieldorder
            }
        }


        let showCommonNotify = true
        await this.callApiFrom(IISMethods.getCurrentState()['REACT_APP_METHOD_POST'], url, reqBody, reqHeaders, updateFieldOrderSuccessCallback.bind(this), updateFieldOrderErrorCallback.bind(this))
        function updateFieldOrderSuccessCallback(res) {

            if (Config.encryptdata) {
                try {

                    resBody = JSON.parse(JSON.parse(this.decryptData(res.data)))

                }
                catch (e) {
                    resBody = res.data
                }

                // decrypt res header
                if (res.headers.reqheader) {
                    resHeaders = JSON.parse(JSON.parse(this.decryptData(res.headers)))
                }
                else {
                    resHeaders = res.headers
                }
            }
            else {
                resBody = res.data
                resHeaders = res.headers
            }
        }

        async function updateFieldOrderErrorCallback(error, errorWithRes) {
            //if request failed and res than go in this condition
            if (error?.response) {
                if (Config.encryptdata) {
                    try {

                        resBody = JSON.parse(JSON.parse(this.decryptData(error.response.data)))

                    }
                    catch (e) {
                        resBody = error.response.data
                    }

                    if (resBody.data?.autologout) {
                        await this.logout();
                        return;
                    }

                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }

                    // decrypt res header
                    if (error.response.headers.reqheader) {
                        resHeaders = JSON.parse(JSON.parse(this.decryptData(error.response.headers)))
                    }
                    else {
                        resHeaders = error.response.headers
                    }
                }
                else {
                    resBody = error.response.data

                    if (resBody.data?.autologout) {
                        await this.logout();
                        return;
                    }

                    if (resBody.updateversion) {
                        IISMethods.HardRefresh()
                    }
                    resHeaders = error.response.headers
                }

            }
            //if request failed and without res in any case than go in this condition
            else if (!errorWithRes) {
                resBody = {}
                showCommonNotify = false
                return
            }
        }

        this.sessionExpiry(resBody)
        this.tokenExpiry(resHeaders)
        if (showMessageOnError && resBody.status !== 200) {
            if (showCommonNotify) {
                this.notify(resBody.message, 0, resBody)
            }
        }

        return { resBody, resHeaders }
    }

    async downloadDocuments(url, fileName) {
        const headers = {
            'Content-Type': 'text/plain'
        };

        await axios({
            url: url,
            method: 'GET',
            responseType: 'blob',
            headers: headers
        }).then((response) => {
            const href = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            const name = fileName || url.split('/').pop() || 'download.xlsx';
            link.href = href;
            link.download = name;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        }).catch(e => console.error(e));
    }

    // HARSH 10-4-2023
    handleCSVDownload(headarr, keyarr, dataarr, filename = "test-csv") {
        const head = ['Sr No.', ...headarr].toString()
        const data = dataarr?.map((item, index) => {
            let fields = ['index', ...keyarr]
            let obj = {}
            for (let field of fields) {
                if (field === 'index') {
                    obj[field] = index + 1
                } else {
                    obj[field] = item[field]
                }
            }
            return Object.values(obj).toString()
        })
        const csv = [head, ...data].join('\n')
        this.startCSVDownload(csv, filename)
    }
    startCSVDownload(input, filename) {
        const blob = new Blob([input], { type: 'application/csv' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a');
        // a.download = 'test-csv.csv';
        a.download = `${filename}.csv`
        a.href = url;
        document.body.appendChild(a);
        a.click();
        a.remove()
    }

    // JATIN 15/04/2025 For Show DefaultBadge In Grid if Fields Freeze and defaultdata value 1 default
    showDefaultBadge(data, fieldord, index) {
        return data.defaultdata && fieldord.freeze === 1 && index === 0
    }

    /**************************************JATIN 18/12/24 5:09 PM Letter generate**************************************/

    // JATIN for 19/11/2024 For API Call or pdf Genrate and Preview modal Open
    async convertToPdfAndOpenPreview(reqData, pagename) {
        let LetterType = IISMethods.getobjectfromarray(Config.lettertype, "value", reqData.type)?.label || ''
        let isexitLetter = Object.keys(reqData)?.includes("exittype")
        try {
            document.getElementById('global-overlay').classList.add('show')
            document.getElementById('global-overlay-message').innerHTML = `Generating ${([Config.aliasname['exitapplicationalias'], Config.aliasname['employeeprofilealias'], Config.aliasname['openingmasteralias'], Config.aliasname['customerdocumentsalias']?.includes(pagename)]) ? 'PDF' : isexitLetter ? "Exit Letter" : LetterType}...`
        } catch (error) {
            console.log(error)
        }

        const url = Config.weburl + "getpdfbase64"
        const useraction = 'list' + "getpdfbase64" + 'data'

        let maincontent = reqData.pdfmaincontent
        let headercontent = reqData.pdfheader
        let footercontent = reqData.pdffooter

        let reqBody = {}
        if (reqData?.editororword === 2) {
            reqBody = {
                'type': reqData.type,
                'name': isexitLetter ? reqData.exitlettername : reqData.name ? reqData.name : reqData.type === 1 ? reqData.agreementname : reqData.type === 2 ? reqData.appointmentlettername : reqData.type === 3 ? reqData.offerlettername : reqData.type === 4 ? reqData.otherlettername : '',
                "editororword": reqData?.editororword,
                "letterwordurl": reqData?.letterwordurl
            }
        }
        else {
            reqBody = {
                "marginright": reqData.marginright,
                "marginleft": reqData.marginleft,
                "marginbottom": reqData.marginbottom,
                "margintop": reqData.margintop,
                "pdfheader": headercontent ? headercontent : '',
                "pdffooter": footercontent ? footercontent : '',
                "footerheight": reqData.footerheight,
                "headerheight": reqData.headerheight,
                "pdfmaincontent": maincontent,
                "setpagetype": reqData.setpagetype,
                'type': reqData.type,
                'name': isexitLetter ? reqData.exitlettername : reqData.name ? reqData.name : reqData.type === 1 ? reqData.agreementname : reqData.type === 2 ? reqData.appointmentlettername : reqData.type === 3 ? reqData.offerlettername : reqData.type === 4 ? reqData.otherlettername : '',
            }
        }

        let { resBody } = await this.socketAddData(url, reqBody, useraction, false, {}, pagename)
        if (resBody.status === 200) {
            try {
                document.getElementById('global-overlay').classList.remove('show')
            } catch (error) {
                console.log("error")
            }
            if (resBody.data) {
                return resBody
            } else {
                return null
            }

        } else {
            try {
                document.getElementById('global-overlay').classList.remove('show')
            } catch (error) {
                console.log("error")
            }
            if (!resBody.data) {
                return null
            }
        }

    }

    // JATIN 20/12/2024  Function to process nodes and add height to images tag For Document genarte 
    async handleImagesTagHeight(selector) {
        try {
            const parentElement = document.querySelector(selector)?.querySelector(".ql-editor");
            if (!parentElement) {
                console.warn(`No .ql-editor found inside the selector: ${selector}`);
                return null;
            }

            const nodeArray = Array.from(parentElement.childNodes);
            const promises = [];

            for (const node of nodeArray) {
                if (node) {
                    const imgElements = node.querySelectorAll('img');
                    for (const img of imgElements) {
                        promises.push(
                            new Promise(resolve => {
                                const setHeight = () => {
                                    if (!img.getAttribute('height')) {
                                        img.setAttribute('height', node.clientHeight || img.offsetHeight || 0);
                                        // img.style.height = `${node.clientHeight || img.offsetHeight || 0}px`; // Use naturalHeight instead of innerHTML
                                        resolve();
                                    }
                                };

                                if (img.complete) {
                                    setHeight();
                                } else {
                                    img.onload = setHeight;
                                    img.onerror = () => {
                                        console.warn("Image failed to load:", img);
                                        resolve();
                                    };
                                }
                            })
                        );
                    }
                }
            }

            await Promise.all(promises); // Wait for all images to load

            return parentElement; // Return the updated parent element
        } catch (error) {
            console.error("Error in handleImagesTagHeight:", error);
            return null;
        }

    }
    // JATIN 23/12/24  removeImageHeight used Remove image tag height attribute for letter generate 
    async removeImageHeight(htmlContent) {
        // Parse the HTML string into a document
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlContent, "text/html");

            doc.querySelectorAll('img')?.forEach(img => img.removeAttribute('height'));

            // Return the modified HTML content
            return doc.body.innerHTML;
        } catch (error) {
            console.log("error", error)
        }
    }
    // JATIN 11/2/25 11:31 PM Convert PDf To PNG for Document genarate for used when Document atteched with pdf and convert to img and replace with document and show in letter => this Was used in agrement Letter for Document atteched Functionallty 
    async convertPdfUrlToPng(pdfUrl) {
        try {
            const response = await axios.get(pdfUrl, {
                responseType: "arraybuffer", // Required for binary data

            });

            const pdfData = new Uint8Array(response.data);
            const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
            const numPages = pdf.numPages;

            const canvasList = [];
            let totalHeight = 0;
            let maxWidth = 0;

            for (let i = 1; i <= numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 2 }); // High resolution
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.width = viewport.width;
                canvas.height = viewport.height;

                await page.render({ canvasContext: context, viewport }).promise;

                canvasList.push(canvas);
                totalHeight += canvas.height;
                maxWidth = Math.max(maxWidth, canvas.width);
            }

            // Create a final canvas to merge all pages
            const finalCanvas = document.createElement("canvas");
            finalCanvas.width = maxWidth;
            finalCanvas.height = totalHeight;
            const finalContext = finalCanvas.getContext("2d");

            let yOffset = 0;
            for (const canvas of canvasList) {
                finalContext.drawImage(canvas, 0, yOffset);
                yOffset += canvas.height;
            }
            // Convert the final canvas to PNG
            return finalCanvas.toDataURL("image/png");
        } catch (error) {
            console.error("Error converting PDF to PNG:", error);
            return '';
        }
    }
    /**************************************JATIN 18/12/24 5:09 PM  Letter generate **************************************/

    /**************************************JATIN 19/5/25 2:12 PM START  Salary Table Chanegs Show montlty And annually Fields in Letter and Preview Modal Set Key for Avg/Monthly and annually For Old Data **************************************/
    // Calculated  Allowances 
    async calculateAverageAllowances(dataArray) {
        const allowanceTotals = {};
        if (dataArray.allowances) {
            const processedAllowanceIds = new Set();
            dataArray.allowances.forEach(allowance => {
                const id = allowance.allowanceid;
                if (!allowanceTotals[id]) {
                    allowanceTotals[id] = {
                        total: 0,
                        count: 0,
                        allowance: allowance.allowance
                    };
                }

                allowanceTotals[id].total += allowance.amount;
                allowanceTotals[id].count += 1;
                processedAllowanceIds.add(id);
            });

            Object.keys(allowanceTotals).forEach(id => {
                if (!processedAllowanceIds.has(id)) {
                    allowanceTotals[id].total += 0;
                    allowanceTotals[id].count += 1;
                }
            });
        }
        const averageAllowances = Object.keys(allowanceTotals).map(id => {
            const { total, count, allowance } = allowanceTotals[id];
            let avgamount = total / count
            let annualavgamount = avgamount * 12
            return {
                allowanceid: id,
                allowance: allowance,
                avgamount: avgamount,
                annualavgamount: annualavgamount
            };
        });

        return averageAllowances;
    }
    // Calculated  Variable CTC bonus Data 
    async calculateAverageVariableCTC(dataArray) {
        const bonusTotals = {};

        if (dataArray.variablectc) {
            const processedBonusNames = new Set();

            dataArray.variablectc.forEach(bonus => {
                const name = bonus.bonusname;

                if (!bonusTotals[name]) {
                    bonusTotals[name] = {
                        total: 0,
                        count: 0,
                        bonusname: name
                    };
                }

                bonusTotals[name].total += bonus.amount;
                bonusTotals[name].count += 1;
                processedBonusNames.add(name);
            });

            // If a particular bonusname is missing in an entry, we still count it with zero
            Object.keys(bonusTotals).forEach(name => {
                if (!processedBonusNames.has(name)) {
                    bonusTotals[name].total += 0;
                    bonusTotals[name].count += 1;
                }
            });
            // });
        }

        const averageBonuses = Object.keys(bonusTotals).map(name => {
            const { total, count, bonusname } = bonusTotals[name];
            let avgamount = total / count
            let annualavgamount = avgamount * 12
            return {
                bonusname,
                avgamount: avgamount,
                annualavgamount: annualavgamount
            };
        });

        return averageBonuses;
    }

    // Below Functions is Used to set avg and anuualy key in old data for salary table Show if there ctc key not Present at that time set avg & annual key set 
    async setSalarayBifurcationData(salarydata) {
        const allKeys = [
            "basicsalary", "incomeemployeeepf", "incomeemployeeeps", "incomeemployeeedli", "incomeemployeeepfadmin", 'incomeemployerepf', "incomeemployereps", "incomeemployeredli", "incomeemployerepfadmin", "incomeemployeeesic", "incomeemployeresic", "incomeemployeresicadmin", "incometds", "incomeprofessionaltax", "deductionemployerepf", "deductionemployereps", "deductionemployeredli", "deductionemployerepfadmin", "deductionemployeresic", "deductionemployeresicadmin",
            "deductionemployeeepf", "deductionemployeeeps", "deductionemployeeedli", "deductionemployeeepfadmin", "deductionemployeeesic", "deductiontds", "deductionprofessionaltax",
            "totaldeductionamount", "netamount", "grosssalary",
            "variablectcamount", "ctc"
        ];

        const result = [];

        for (const entry of salarydata) {
            const newEntry = { ...entry };

            // in old data ct will not come so handle edit case
            if (newEntry.bifurcation && newEntry.bifurcation.avgctc === undefined && !newEntry.bifurcation.avgctc) {
                const bifurcation = { ...newEntry.bifurcation };

                allKeys.forEach((key) => {
                    const avgKey = `avg${key}`;
                    const annualKey = `annualavg${key}`;
                    const baseValue = bifurcation[key] ?? 0;

                    bifurcation[avgKey] = baseValue;
                    bifurcation[annualKey] = baseValue * 12;
                });

                bifurcation['averageallowance'] = await this.calculateAverageAllowances(bifurcation);
                bifurcation['averagevariablectc'] = await this.calculateAverageVariableCTC(bifurcation);

                newEntry.bifurcation = bifurcation;
            }

            result.push(newEntry);
        }

        return result;
    }

    /**************************************JATIN 19/5/25 2:12 PM END  Salary Table Chanegs Show montlty And annually Fields in Letter and Preview Modal   Set Key for Avg/Monthly and annually For Old Data**************************************/

    /****************************************************** Project Methods Methods Start **********************************************************************/

    async getCurrentProjectData() {
        const loginInfo = IISMethods.getCookiesData('loginInfo')
        const sessionData = IISMethods.getSessionData('loginInfo')
        const currentProject = await IISMethods.getLocalData('projectsData')?.find(obj => obj._id === sessionData.projectid)
        return currentProject
    }

    /**
     * checks if user has canassign rights or not
     * @param {Object} projectData required
     * @param {String} userid if given checks for that person otherwise checks for logged in user
     * @returns true or false if user is superadmin or has canassign rights or is project manager returns true
     */
    hasCanAssignRights(projectData, userid) {
        const loginInfo = IISMethods.getCookiesData('loginInfo')
        const personid = userid ? userid : loginInfo.uid
        let canAssign = false

        if (IISMethods.isSuperAdmin()) {
            canAssign = true
        }
        else if (projectData?.persondetails?.find(obj => obj?.personid === personid)?.canassigntask) {
            canAssign = true
        }
        else if (IISMethods.getindexfromarray(projectData?.projectmanager, 'projectmanagerid', personid) !== -1) {
            canAssign = true
        }

        return canAssign
    }

    // // Get Timezone Date/Time Obj from ISO String
    // GetDateTimefromISOString(isostring) {
    //     let offset = this.getPropertyOffset(isostring) // only date
    //     let decimaloffset = offset[0] + (Number(offset[1] + offset[2]) + (Number(offset[3] + offset[4])) / 60).toString()

    //     console.log(decimaloffset,'decimaloffset')

    //     let date = new Date(isostring)
    //     let utc = date.getTime() + date.getTimezoneOffset() * 60000;
    //     let additionaldiff = ((60 * decimaloffset) + date.getTimezoneOffset())
    //     let nd = new Date(utc - (date.getTimezoneOffset() * 60000) + (additionaldiff * 60000))
    //     console.log(nd,'ndndnd')
    //     return nd
    // }

    // getPropertyOffset(date) {
    //     // let propertydata = this.getCurrentState().propertylocation || {}
    //     // let propertydata = this.getCurrentState().propertylocation || {}
    //     let offset = '+0530'
    //     // let offsetdata = propertydata['offsetdata'] || []
    //     // let offsetindex = offsetdata?.findIndex(poffset => {
    //     //     let getdate = date
    //     //     if ((new Date(poffset.fromdate) <= new Date(getdate)) && (new Date(poffset.todate) >= new Date(getdate))) return true
    //     //     else return false
    //     // })
    //     // if (offsetindex !== -1) {
    //     //     offset = offsetdata[offsetindex]['offsets']
    //     // }

    //     return offset || '+0000'
    // }

    /**
     * check person is qa or not
     * @param {Object} projectData required
     * @param {Boolean} includeProjectManager if true considers project manager as qa 
     * @param {String} statusid if statusid given checks for that particular status revirerequiredroles otherwise checks for whole project revirerequiredroles
     * @param {Object} personObj if personObj given checks for that person is qa or not otherwise checks for current login user is qa or not
     * @returns true or false if any userrole is in reviewroles or user is projectmanager returns true
     */
    isReviewer(projectData, includeProjectManager = false, statusid, personObj) {

        let Person = {}
        let personid
        if (personObj) {
            Person = personObj
            Person.userroles = personObj.userrole

            personid = personObj._id
        }
        else {
            Person = IISMethods.getCookiesData('loginInfo')

            personid = Person.uid
        }

        const currentProject = projectData

        let reviewerroles = []
        if (statusid) {
            const statusObj = IISMethods.getobjectfromarray(currentProject.projecttaskflow, 'projecttaskstatusid', statusid)
            reviewerroles = statusObj.reviewerroles
        }
        else {
            currentProject?.projecttaskflow?.map((flow) => {
                if (flow.reviewerroles && flow.reviewerroles?.length) {
                    reviewerroles = reviewerroles.concat(flow.reviewerroles)
                }
            })
        }

        let temp = false
        Person.userroles?.map((role) => {
            if (IISMethods.getindexfromarray(reviewerroles, 'reviewerroleid', role.userroleid) !== -1) {
                temp = true
            }
        })

        if (includeProjectManager) {
            if (IISMethods.getindexfromarray(currentProject?.projectmanager, 'projectmanagerid', personid) !== -1) {
                temp = true
            }
        }
        return temp
    }

    async isOwner(taskObj) {
        if (taskObj.ownerid == IISMethods.getCookiesData('loginInfo').uid) {
            return true
        }
        return false
    }

    /**
     * @param {Object} projectData required 
     * @param {String} personid if personid given checks for that person otherwise checks for logged in user
     * @returns true or false
     */
    isProjectManager(projectData, personid = null) {
        let id = personid ? personid : IISMethods.getCookiesData('loginInfo').uid
        if (projectData?.projectmanager && IISMethods.getindexfromarray(projectData?.projectmanager, 'projectmanagerid', id) !== -1) {
            return true
        }
        return false
    }


    /**
     * 
     * @param {Object} taskData data of task
     * @param {Object} pageRights object of contain which rights
     * @param {Object} loginInfo information object use login
     * @param {Boolean} isProjectManager person is projectmanager or not 
     * @param {Array} userheirarchy array of the hirechey
     * @returns has rights or not
     */
    hasTaskDeleteRights(taskData, pageRights, loginInfo, isProjectManager, userheirarchy) {

        let rights = ((IISMethods.isSuperAdmin() || (pageRights.alldelright && (userheirarchy?.findIndex(id => id == taskData?.ownerid) >= 0 || isProjectManager)))) || (pageRights.selfdelright && (taskData?.ownerid === loginInfo.uid))
        let canChange = false

        if (rights) {
            canChange = true
        }
        else {
            canChange = false
        }

        return canChange
    }

    /**
     * 
     * @param {Object} taskData data of task
     * @param {Object} loginInfo information object use login
     * @param {Boolean} isProjectManager person is projectmanager or not 
     * @param {Array} userheirarchy array of the hirechey
     * @param {Object} pageRights object of contain which rights
     * @returns 
     */
    hasChangeDueDateRights(taskData, loginInfo, isProjectManager, userheirarchy, pageRights, canassign = false) {

        let rights = (IISMethods.isCustomer() && taskData?.taskstatusid == Config.getUnAssignedColumnId())
            || (taskData?.ownerid == loginInfo?.uid && !IISMethods.isCustomer())
            || IISMethods.isSuperAdmin() || isProjectManager
            || userheirarchy?.findIndex(id => id == taskData?.ownerid) >= 0 && (pageRights.alleditright) || canassign
        let canChange = false

        if (rights) {
            canChange = true
        }
        else {
            canChange = false
        }

        return canChange
    }

    /**
     * 
     * @param {Object} taskData data of task
     * @param {Object} loginInfo information object use login
     * @param {Boolean} isProjectManager person is projectmanager or not 
     * @param {Array} userheirarchy array of the hirechey
     * @param {Object} pageRights object of contain which rights
     * @returns 
     */
    hasChangeStartDateRights(taskData, loginInfo, isProjectManager, userheirarchy, pageRights, canassign = false) {

        try {
            let rights = (IISMethods.isCustomer() && taskData?.taskstatusid == Config.getUnAssignedColumnId())
                || (taskData?.ownerid == loginInfo?.uid && !IISMethods.isCustomer())
                || IISMethods.isSuperAdmin() || isProjectManager
                || userheirarchy?.findIndex(id => id == taskData?.ownerid) >= 0 && (pageRights.alleditright) || canassign
            let canChangeStartDate = false

            if (rights) {
                canChangeStartDate = true
            }
            else {
                canChangeStartDate = false
            }

            return canChangeStartDate
        }
        catch (e) {
            console.error(e)
            return false
        }
    }


    /**
    * 
    * @param {Object} taskData data of task
    * @param {Object} loginInfo information object use login
    * @param {Boolean} isProjectManager person is projectmanager or not 
    * @param {Array} userheirarchy array of the hirechey
    * @param {Object} pageRights object of contain which rights
    * @returns 
    */
    hasChangePriorityRights(taskData, loginInfo, isProjectManager, userheirarchy, pageRights, canassign) {

        let rights = (IISMethods.isCustomer() && taskData?.taskstatusid == Config.getUnAssignedColumnId())
            || (taskData?.ownerid == loginInfo?.uid && !IISMethods.isCustomer())
            || IISMethods.isSuperAdmin() || isProjectManager
            || userheirarchy?.findIndex(id => id == taskData?.ownerid) >= 0 && (pageRights.alleditright) || canassign

        let canChangePriority = false

        if (rights) {
            canChangePriority = true
        }
        else {
            canChangePriority = false
        }

        return canChangePriority
    }

    /**
     * 
     * @param {Object} taskData data of task
     * @param {Object} loginInfo information object use login
     * @param {Boolean} isProjectManager person is projectmanager or not 
     * @param {Array} userheirarchy array of the hirechey
     * @param {Object} pageRights object of contain which rights
     * @param {Boolean} canassign can assign task or not 
     * @returns 
     */
    hasChangeEstimationRights(taskData, loginInfo, isProjectManager, userheirarchy, pageRights, canassign) {

        let rights = canassign || (taskData?.ownerid === loginInfo.uid && !IISMethods.isCustomer()) || IISMethods.isSuperAdmin() || isProjectManager
            || IISMethods.getindexfromarray(taskData?.assignedto, 'assignedtoid', loginInfo.uid) != -1 || (userheirarchy?.findIndex(id => id == taskData?.ownerid) >= 0 && pageRights.alleditright)

        let canChangeEstimation = false

        if (rights) {
            canChangeEstimation = true
        }
        else {
            canChangeEstimation = false
        }

        return canChangeEstimation
    }

    /**
     * 
     * @param {boolean} isqainproject //person is qa in that project or not
     * @param {boolean} isProjectManager //person is project manager or not
     * @param {Object} statusdata object of the information data
     * @returns 
     */
    hasChangeQAEstimationRights(isqainproject, isProjectManager, statusdata) {

        let rights = (IISMethods.isSuperAdmin() || isqainproject || isProjectManager) && statusdata?.reviewrequired

        let canChangeQAEstimation = false

        if (rights) {
            canChangeQAEstimation = true
        }
        else {
            canChangeQAEstimation = false
        }

        return canChangeQAEstimation
    }

    /**
    * 
    * @param {Object} taskData data of task
    * @param {Object} loginInfo information object use login
    * @param {Boolean} isProjectManager person is projectmanager or not 
    * @param {Array} userheirarchy array of the hirechey
    * @param {Object} pageRights object of contain which rights
    * @param {Boolean} canassign can assign task or not 
    * @returns 
    */
    hasAddAssigneeRights(taskData, loginInfo, isProjectManager, userheirarchy, pageRights, canassign) {

        // let rights = (((taskData.ownerid === loginInfo.uid) && canassign) || IISMethods.isSuperAdmin() || isProjectManager
        //     || canassign || (userheirarchy?.findIndex(id => id == taskData.ownerid) >= 0 && pageRights.alleditright && canassign))

        let rights = IISMethods.isSuperAdmin() || isProjectManager || canassign || pageRights.alleditright || (taskData?.ownerid === loginInfo.uid) && pageRights.selfeditright

        let canAddAssignee = false

        if (rights) {
            canAddAssignee = true
        }
        else {
            canAddAssignee = false
        }

        return canAddAssignee
    }

    /**
    * 
    * @param {Object} taskData data of task
    * @param {Object} loginInfo information object use login
    * @param {Boolean} isProjectManager person is projectmanager or not 
    * @returns 
    */
    hasAddWatcherRights(taskData, loginInfo, isProjectManager) {

        let rights = IISMethods.isSuperAdmin() || isProjectManager || taskData?.ownerid === loginInfo.uid

        let canAddWatchers = false

        if (rights) {
            canAddWatchers = true
        }
        else {
            canAddWatchers = false
        }

        return canAddWatchers
    }

    /**
     * 
     * @param {Object} parentTaskObj //data of task for calculate time 
     * @returns 
     */
    calculateEstimatedWorkTime(parentTaskObj) {
        let parentTaskTime = 0
        let subTaskTime = 0

        parentTaskObj.subtasks
            ?.forEach((obj) => {
                let temp = 0
                // if edit subtask don't add current task estimate time
                if (!this.getCurrentState().formData._id || (this.getCurrentState().formData._id && this.getCurrentState().formData._id !== obj._id)) {
                    temp = parseInt(obj?.workhours * 3600 * 1000) + parseInt(obj.workminutes * 60 * 1000)
                }
                subTaskTime += temp
                return true
            })


        parentTaskTime = (parseInt(parentTaskObj?.workhours * 3600 * 1000) + parseInt(parentTaskObj?.workminutes * 60 * 1000) - parseInt(subTaskTime))

        // if estimation time is greater than remaining time of parent task 
        if (parseInt(this.getCurrentState().formData?.workhours * 3600 * 1000) + parseInt(this.getCurrentState().formData.workminutes * 60 * 1000) <= parentTaskTime) {
            return true
        }
        else {
            return false
        }
    }

    /**
    * Converts a raw byte value into a human-readable file size string.
    * 
    * @param {number} bytes - The size in bytes to be formatted.
    *                         Should be a positive number representing the file size.
    * 
    * @returns {string} A formatted string representing the file size with appropriate unit
    *                   (Bytes, KB, MB, GB, or TB) and decimal precision of 2 places.
    *                   Returns '0 Bytes' if the input is 0 or not a number.
    */
    formatBytesSize(bytes) {
        // Return '0 Bytes' if input is not a number or is zero
        if (isNaN(bytes) || bytes === 0) return '0 Bytes'

        // Define size units in ascending order
        const units = ['Bytes', 'KB', 'MB', 'GB', 'TB']

        // Define the base for conversion (1024 for binary representation)
        const k = 1024

        // Calculate the appropriate unit index based on the size magnitude
        const i = Math.floor(Math.log(bytes) / Math.log(k))

        // Calculate the size in the determined unit
        const value = bytes / Math.pow(k, i)

        // Format the result with 2 decimal places and append the unit
        return `${value.toFixed(2)} ${units[i]}`
    }


    isTaskStatusComplete(taskstatus, column) {
        try {
            return IISMethods.getobjectfromarray(taskstatus[0].projecttaskflow, 'id', Object.keys(column)[0]).iscomplete
        }
        catch (e) {
            console.log(e)
            return 0
        }
    }

    // check if any required stages exist between source and destination columns - aman
    /**
     * @param {number} sourceColumnIndex source column index
     * @param {number} destColumnIndex destination column index
     * @param {arr} taskflow arr of project's flow
     * @param {arr} columns arr of column objs
    */
    hasRequiredStageBetween = (sourceColumnIndex, destColumnIndex, taskflow, columns) => {

        // get the range between source and destination
        const start = Math.min(sourceColumnIndex, destColumnIndex)
        const end = Math.max(sourceColumnIndex, destColumnIndex)

        // skip adjacent columns (no stages to check between them)
        if (end - start <= 1) return false

        // check columns between source and destination
        for (let i = start + 1; i < end; i++) {
            const statusId = Object.keys(columns[i])[0]
            const statusObj = IISMethods.getobjectfromarray(taskflow, 'id', statusId)

            if (statusObj?.requiredstage === 1) {
                return true // found a required stage
            }
        }

        return false; // no required stages found
    }

    // returns all stages from current stage to next required stage
    /**
     * @param {number} flow project's flow array
     * @param {number} TaskObj task's object
    */
    getPathToNextRequiredNode(flow, TaskObj) {
        const nodes = flow?.filter(item => item?.projecttaskstatusid && !(item?.source && item?.target))

        const currentIndex = nodes?.findIndex(node => node?.projecttaskstatusid === TaskObj?.taskstatusid)

        if (currentIndex === -1 || currentIndex === nodes?.length - 1) {
            return []
        }

        const result = []

        // Start from the next node after current
        for (let i = currentIndex + 1; i < nodes?.length; i++) {
            const node = nodes[i]

            if (!TaskObj?.reviewrequired && (node?.reviewrequired && !node?.requiredstage)) {

            }
            else {
                result.push({
                    label: node?.projecttaskstatus,
                    value: node?.projecttaskstatusid
                })
            }

            // Stop if we hit a required node
            if (node?.requiredstage) {
                break
            }
            else if (TaskObj?.reviewrequired && node?.reviewrequired) {
                break
            }
            // if (TaskObj?.reviewrequired && node?.requiredstage) {
            //     break
            // }
        }

        return result
    }

    // returns next required stage - aman
    /**
     * @param {number} flow project's flow array
     * @param {number} currentTask task's object
    */
    getNextRequiredStage(flow, currentTask) {
        // Filter out connection nodes (ones with source and target)
        const stages = flow?.filter(item => item?.projecttaskstatusid && !(item.source && item.target))

        // Find current stage index
        const currentIndex = stages?.findIndex(stage => stage?.projecttaskstatusid === currentTask?.taskstatusid)

        // If current stage not found or it's the last stage, return null
        if (currentIndex === -1 || currentIndex === stages.length - 1) {
            return null
        }

        // Start checking from the next stage after current
        let nextStages = stages?.slice(currentIndex + 1)

        // First priority: Find first required stage
        const nextRequiredStage = nextStages?.find(stage => stage?.requiredstage === 1)
        if (nextRequiredStage) {
            return nextRequiredStage
        }

        // Second priority: If task has reviewrequired, find first review stage
        if (currentTask?.reviewrequired) {
            const nextReviewStage = nextStages?.find(stage => stage?.reviewrequired == 1)
            if (nextReviewStage) {
                return nextReviewStage
            }
        }

        // Third priority: Find first completion stage
        const completionStage = nextStages?.find(stage => stage?.iscomplete == 1)
        if (completionStage) {
            return completionStage
        }

        // If no special stages found, return the immediate next stage
        return nextStages?.length > 0 ? nextStages[0] : null
    }

    // returns an obj of rights - aman - 9/6/2024
    /**
     * @param {number} personId id
     * @param {obj} project task's project
     * @param {obj} task task's object
     * @returns {Array} - Merged rights object.
    */
    getTaskRestrictedRights = (personId, project, task, groupedrights) => {
        let ids = [7]

        // checking user's roles in task and project
        if (IISMethods.isProjectManager(project)) {
            ids.push(1)
        }
        if (task && task?.assignedto?.some(assignee => assignee?.assignedtoid == personId)) {
            ids.push(2)
        }
        if (task && task?.watchers?.some(assignee => assignee?.watcherid == personId)) {
            ids.push(3)
        }
        if (task && task?.ownerid == personId) {
            ids.push(4)
        }
        if (project?.persondetails?.find(obj => obj?.personid == personId)) {
            ids.push(5)
        }
        if (IISMethods.isReviewer(project)) {
            ids.push(6)
        }

        const uniqueIds = [...new Set(ids)]

        const filteredRights = project?.projectmodetemplaterights?.filter(gr => uniqueIds.includes(gr.id))

        const mergedRights = {}

        filteredRights?.forEach(gr => {
            Object.entries(gr.rights).forEach(([key, value]) => {
                if (value === true && mergedRights[key] !== true) {
                    mergedRights[key] = true
                }
            })
        })

        return mergedRights
    }

    // returns an obj of rights - aman - 9/6/2024
    /**
     * @param {number} id id
     * @param {obj} projectdata task's project
     * @returns {bool} - returns 0 or 1.
    */
    getTemplateWiseLength = (id, projectdata) => {
        let right = 0
        const projectmodetemplatemetadata = projectdata?.projectmodetemplatemetadata

        if(id == 1){
            right = projectmodetemplatemetadata?.hasmanagecrudoperation || 0
        }
        else if(id == 2){
            right = projectmodetemplatemetadata?.hasmanagefields || 0
        }
        else if(id == 3){
            right = projectmodetemplatemetadata?.hasmanagetaskassignment || 0
        }
        else if(id == 4){
            right = projectmodetemplatemetadata?.hasmanagetaskassignment || 0
        }

        return right
    }

    // returns task create rights - aman - 10/6/2025
    /**
     * @param {string} personId id
     * @param {obj} project task's project
     * @param {string} pageRightsAlias page alias
     * @returns {Array} - returns true or false based on if user has rights or not.
    */
    hasTaskCreateRights = (personId, projects, pageRightsAlias) => {
        // Get page rights for tasks
        const pageRights = IISMethods.getPageRights(pageRightsAlias)
        const isAddVisible = pageRights.alladdright || pageRights.selfaddright

        // Check if any project grants add rights
        const hasProjectWithAddRights = projects?.some(project => {
            const isProjectManager = IISMethods.isProjectManager(project)
            const canAssign = IISMethods.hasCanAssignRights(project)

            if (project?.projectmode === 2) {
                return IISMethods.getTaskRestrictedRights(personId, project)?.can_add_any
            }
            else if (isProjectManager || canAssign || IISMethods.isSuperAdmin(pageRightsAlias)) {
                return true
            }
            return false
        });

        // Return true if either project or page rights allow task creation
        return hasProjectWithAddRights || isAddVisible;
    }

    //for getting assignees for tasks - aman
    /**
     * Filters assignable employees based on task type and rights.
     * @param {Object} rights - Merged rights object returned by getTaskRestrictedRights.
     * @param {Object} project - Project object containing projectmanagers and persondetails.
     * @param {string} tasktype - Type of task ('task', 'issue', 'suggestion').
     * @param {Array} employees - Array of employee objects with { label, value }.
     * @param {Array} assignedto - Fallback array to return if `can_assign_<type>_to_any` is true.
     * @param {Array} taskorissueid - taskorissueid flag to check if it's a tak or subtask.
     * @returns {Array} - Filtered list of employees allowed to be assigned.
    */
    getAssignableEmployees(rights, project, tasktype, employees, assignedto = [], taskorissueid, employeemasterlist) {
        // debugger
        const assignable = []

        const getEmployeesByIds = (ids) => {
            return employees.filter(emp => ids.includes(emp.value))
        };

        // get project manager IDs
        const projectManagerIds = project?.projectmanager?.map(pm => pm.projectmanagerid) || []

        // get project assignee IDs
        const assigneeIds = project?.persondetails?.map(p => p.personid) || []

        // get reviewer IDs (using project.persondetails to find actual personObjs)
        // const reviewerIds = project?.persondetails
        //     ?.filter(p => IISMethods.isReviewer(project, false, null, p))
        //     ?.map(p => p.personid) || []

        // get reviewer IDs based on QA reviewer roles (from projecttaskflow)
        let reviewerIds = [];

        const projectReviewroles = [...new Set(project?.projecttaskflow
            ?.flatMap(flow => flow.reviewerroles || [])
            ?.map(role => role.reviewerroleid))]

        employeemasterlist?.forEach(person => {
            const hasQAReviewerRole = person?.userrole?.some(role =>
                projectReviewroles?.includes(role?.userroleid)
            );
            if (hasQAReviewerRole) {
                reviewerIds.push(person?._id);
            }
        });

        // Utility to push only unique employees
        const pushUnique = (list) => {
            list.forEach(emp => {
                if (!assignable.find(a => a.value === emp.value)) {
                    assignable.push(emp)
                }
            });
        };

        const isSubtask = tasktype === 'task' && !!taskorissueid

        let prefix = '';
        if (tasktype === 'Task' && !isSubtask) prefix = 'can_assign_task_to_'
        else if (tasktype === 'Issue') prefix = 'can_assign_issue_to_'
        else if (tasktype === 'Suggestion') prefix = 'can_assign_suggestions_to_'
        else if (isSubtask) prefix = 'can_assign_subtask_to_'
        else return [];

        if (rights?.[`${prefix}to_any`]) {
            return assignedto; // unrestricted: return all provided
        }

        if (rights?.[`${prefix}manager`]) {
            pushUnique(getEmployeesByIds(projectManagerIds))
        }
        if (rights?.[`${prefix}projectassignee`]) {
            pushUnique(getEmployeesByIds(assigneeIds))
        }
        if (rights?.[`${prefix}reviewer`]) {
            pushUnique(getEmployeesByIds(reviewerIds))
        }

        return assignable;
    }



    /****************************************************** Project Methods Methods End **********************************************************************/

    /******************************************************************** Sprint start ******************************************************************** */

    /**
    * 
    * @param {Object} taskData data of task
    * @param {Object} loginInfo information object use login
    * @param {Boolean} isProjectManager person is projectmanager or not 
    * @param {Array} userheirarchy array of the hirechey
    * @param {Object} pageRights object of contain which rights
    * @returns 
    */
    hasChangeSprintDragCheckboxRights(taskData, loginInfo, isProjectManager, userheirarchy, pageRights, canassign = false) {

        let rights = (IISMethods.isCustomer() && taskData?.taskstatusid == Config.getUnAssignedColumnId())
            || (taskData?.ownerid == loginInfo?.uid && !IISMethods.isCustomer())
            || IISMethods.isSuperAdmin() || isProjectManager
            || userheirarchy?.findIndex(id => id == taskData?.ownerid) >= 0 && (pageRights.alleditright) || canassign
        let canChange = false

        if (rights) {
            canChange = true
        }
        else {
            canChange = false
        }

        return canChange
    }

    /******************************************************************** Sprint end ******************************************************************** */

    // harsh 28-6-2023
    convertNumbersToWords(num) {
        let a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];

        let b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        if ((num = num.toString())?.length > 9) return 'overflow';

        let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

        if (!n) return; var str = '';

        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';

        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';

        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';

        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';

        str += (n[5] != 0) ? ((str != '') ? '' : '') + (a[Number(n[5])] || b[n[5][0]] + '' + a[n[5][1]]) : '';

        return str
    }

    /**
    * 
    * @param {Number} number any value
    * @returns true or false
    */
    isInteger(number) {
        // Convert the input to a number
        const parsedNumber = Number(number)

        // Check if the parsedNumber is a valid number
        if (isNaN(parsedNumber)) {
            return false
        }

        // Check if the parsedNumber is an integer (no fractional part)
        return parsedNumber === Math.floor(parsedNumber)
    }

    capitalizeFirstLetter(string = '') {
        return string.charAt(0).toUpperCase() + string?.slice(1);
    }

    // ********************************************************************** Redirection Functions Start *******************************************************************

    redirectToAssignedTraining(trainingid) {

        let pagename = `/${Config.aliasname['personassigntrainingalias']}`
        const assignedTrainingPageRights = IISMethods.getPageRights(Config.aliasname['personassigntrainingalias'])
        const subdomainname = IISMethods.getCookiesData("loginInfo")?.subdomainname

        let tab = 'self'

        if (assignedTrainingPageRights.allviewright) {
            tab = 'all'
        }
        else {
            tab = 'self'
        }

        // pagename = pagename + `${Config.getServermode() == 'prod' ? '?' : `?q=${IISMethods.getCookiesData("loginInfo")?.subdomainname}&`}tab=${tab}${"&id=" + trainingid}`
        // | React 18 Changes Nirzar Gabani 💀 ~ 
        // pagename = pagename + `${Config.getServermode() == 'prod' ? `/${tab}/${trainingid}` : `/${tab}/${trainingid}?q=${IISMethods.getCookiesData("loginInfo")?.subdomainname}`}`

        const url = `${pagename}/${tab}/${trainingid}${Config.getServermode() == 'prod' ? '' : `?q=${subdomainname}`}`
        window.open(url)
    }


    // ********************************************************************** Redirection Functions End *******************************************************************


    // ********************************************************************** Support Ticket End *******************************************************************

    //for finding assignees from ticket's category id in supportticketflow
    /**
    * @param {string} categoryid id of category
    * @returns array of objects (contains assignee information)
    */
    handleFindAssignee = (categoryid) => {
        const supportticketflowdata = IISMethods.getobjectfromarray(IISMethods.getCurrentState().masterDataList?.supportticketflow, 'supportcategoryid', categoryid)
        const allAssignedPersons = supportticketflowdata?.supportticketflow?.flatMap(item => item?.assignedpersons);
        return allAssignedPersons
    }

    // ********************************************************************** Support Ticket End *******************************************************************

    //check media storage space available or not when file upload
    /**
   * @param {Number} fileSize in bytes
   * @returns true or false
   */
    checkMediaStorage = async (fileSize) => {
        // try{
        //     const url = Config.weburl + 'storagecheck'
        //     const useraction = 'list' + 'storagecheck' + 'data'

        //     const reqBody = {
        //         filesize: fileSize,
        //         userid: IISMethods.getCookiesData('loginInfo').uid
        //     }

        //     await IISMethods.socketListData(url, reqBody,useraction)

        //     const tempResponse = resBody
        //     if (tempResponse.status === 200) {
        //         return tempResponse.data
        //     }
        //     else{
        //         return false
        //     }
        // }
        // catch (e) {
        //     return false
        // }
        return true
    }

    //check database storage space available or not 
    checkDBStorage = () => {
        let loginInfo = IISMethods.getCookiesData("loginInfo")

        // let AvailableSpace = IISMethods.formatBytes(loginInfo?.availabledatabasespace, 2, 2)

        // if (AvailableSpace < 10) {
        //     return false
        // }
        // else {
        //     return true

        // }
        return true
    }
    //check media storage space available or not from logininfo 
    checkMediaStorageAvailabilty = () => {
        // let loginInfo = IISMethods.getCookiesData("loginInfo")

        // let AvailableSpace = IISMethods.formatBytes(loginInfo?.availableS3space, 2, 2)

        // if (AvailableSpace < 10) {
        //     return false
        // }
        // else {
        //     return true
        // }
        return true
    }

    // crm lead and followup update rights start

    /**
    * 
    * @param {Object} leadData data of lead 
     * @param {Object} loginInfo information object use login
     * @param {Array} userheirarchy array of the hirechey
     * @param {Object} pageRights object of contain which rights
    */

    // added pagealias key | Pravin ~ 27-05-2025 ~ 1:00 PM
    canEditLead = (leadData, loginInfo, userheirarchy, pageRights, pagealias = '') => {
        let rights = IISMethods.isSuperAdmin(pagealias)
            || ((leadData?.leadownerid === loginInfo.uid) && (pageRights.alleditright || pageRights.selfeditright))
            || ((leadData?.recordinfo?.entryuid === loginInfo.uid) && (pageRights.alleditright || pageRights.selfeditright))
            || (userheirarchy?.findIndex(id => id == leadData?.leadownerid) >= 0 && pageRights.alleditright)
            || ((IISMethods.getindexfromarray(leadData?.leadassignee, 'leadassigneeid', loginInfo.uid) !== -1 && (pageRights.alleditright || pageRights.selfeditright)) ? true : false)
        let canChange = false

        if (rights) {
            canChange = true
        }
        else {
            canChange = false
        }

        return canChange
    }

    convertToHoursAndMinutes(decimalHours) {
        // Get the whole number part as hours
        const hours = Math.floor(parseFloat(decimalHours));

        // Get the decimal part and convert it to minutes
        const minutes = Math.round((parseFloat(decimalHours) - hours) * 60);

        return `${hours ? hours : 0} hour${hours !== 1 ? 's' : ''} ${minutes ? minutes : 0} minute${minutes !== 1 ? 's' : ''}`;
    }


    //ex --> 123.4563 --> 123.45 , cut = 3 than 123.456
    /**
     * 
     * @param {Number} value //any number value 
     * @param {Number} cut //number of point value you need after dot
     * @returns 
     */
    /**
 * Rounds a number to a specified number of decimal places without returning NaN or undefined.
 * @param {Number} value // any numeric value
 * @param {Number} cut   // number of decimal places needed after the dot
 * @returns {Number}     // parsed float with specified decimal places
 */
    toFixedFloat(value, cut = 2) {
        try {
            // Safely parse the input value to a number using safeParseFloat to handle undefined, null, and empty strings
            let numValue = this.safeParseFloat(value)

            // Check if the parsed number is still valid and finite (not NaN or Infinity)
            if (Number.isFinite(numValue)) {
                // Use toFixed for setting the decimal places and parse it back to a float
                return this.safeParseFloat(numValue.toFixed(cut))
            } else {
                // Return 0 as fallback if the value is not finite (like NaN, Infinity)
                return 0
            }
        } catch (err) {
            console.log('Error in toFixedFloat:', value, err)
            // Return 0 in case of an unexpected error
            return 0
        }
    }

    /**
 * Formats any numeric value into a comma-separated amount.
 *
 * Behavior:
 *  - If `fractionDigits` is passed → trims decimals to that many digits (without rounding issues from caller)
 *  - If `fractionDigits` is NOT passed → keeps all original decimals as-is
 *  - Always returns numbers in comma format: 10000 → "10,000"
 *
 * Examples:
 *    formatAmount(12345) → "12,345"
 *    formatAmount(12345.678, 2) → "12,345.68"
 *    formatAmount("2500000") → "2,500,000"
 *
 * @param {Number|String} value - The numeric value to format
 * @param {Number} [fractionDigits] - Optional decimal precision (max digits after decimal)
 * @param {Boolean} [isCurrency=true] - show currency symbol or not
 * @returns {String} Formatted amount with commas
 */
    formatAmount = (value, fractionDigits,isCurrency = true) => {
        // Ignore null/undefined
        if (value === null || value === undefined) return "";

        // Convert to string and remove whitespace
        const raw = String(value).trim();

        // Validate number-like input (supports integers + decimal numbers)
        if (!/^[-+]?\d+(\.\d+)?$/.test(raw)) {
            // If not numeric, return original value
            return raw;
        }

        // Convert to number safely
        const num = Number(raw);
        // Apply decimal formatting only if fractionDigits is passed
        const formatted =
            typeof fractionDigits === "number"
                ? num.toLocaleString("en-US", { maximumFractionDigits: fractionDigits })
                : num.toLocaleString("en-US");
        // If isCurrency = false → return number only
        if (!isCurrency) return formatted;

        return `${this.showCurrency(true)} ${formatted}`;
    };

    /**
 * Returns a rounded integer value from the given input.
 * @param {any} value - The input value to round. Can be a number or a string containing a number.
 * @returns {number} The rounded integer result, or 0 if the input is invalid.
 */
    getRoundedValue(value) {
        // Convert the input to a floating-point number (preserves decimals)
        // parseFloat is used instead of parseInt to avoid truncating decimal values
        const num = parseFloat(value);

        // check if input is validate
        if (value == null || value === '' || isNaN(num) || !isFinite(num)) {
            return 0;
        }
        // Round the valid numeric value to the nearest integer
        return Math.round(num);
    }

    //example --> '  123.456  ' --> 122.456
    //it will handle all case of undefined and null 
    /**
     * 
     * @param {Number} value //any number value 
     * @returns 
     */
    safeParseFloat(value) {
        const num = parseFloat(value)
        return value == null || value === '' || isNaN(num) || !isFinite(num) ? 0 : num
    }


    //example --> '123' --> 123 , undefined -> 0
    //it will handle all case of undefined and null 
    /**
     * 
     * @param {Number} value //any number value 
     * @returns 
     */
    safeParseInt(value) {
        const num = parseInt(value)
        return value == null || value === '' || isNaN(num) || !isFinite(num) ? 0 : num
    }

    salaryVerifier(data) {
        try {


            let verifyRows = []

            // let hour = data.addhour ? parseInt(data.addhour) : 0
            // let minute = data.addminutes ? parseInt(data.addminutes) : 0
            // let decimalHours = hour + (minute / 60)

            // const addminutes = data?.addminutes
            // const addhour = parseFloat(data?.addhour)
            // const addminutesintohour = parseFloat(addminutes) / 60
            // const totaladdhour = addhour + addminutesintohour
            // const payforaddhour = IISMethods.toFixedFloat(parseFloat(totaladdhour * parseFloat(data?.ctchourrate)))

            // const sumLatemin = data.latedetails?.filter(item => item.selected === 1)?.reduce((sum, item) => sum + item.latemin, 0)

            // console.log(sumLatemin,'sumLateminsumLatemin')
            // let totalHours = decimalHours + data.regularhours + (sumLatemin / 60)
            let totalHours = data.regularhours
            let temphourrate = data.basicsalary / data.companyworkinghours


            // let checkBasicTotal = temphourrate * (totalHours + parseFloat(data.othour) + data.paidleavehours)
            let checkBasicTotal = temphourrate * (parseFloat(data.othour) + data.paidleavehours)
            const payrollTypeIds = Config.getPayrollTypeids()
            const payFor = data.payfor ? data.payfor?.map(function (element) { return element.payforid }) : []

            let totalVerAmount = 0


            if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {


                //BASIC DATA VERIFICATIONS
                let basicHeaderVerificationData = {
                    header: data.basicheaderlabel ? data.basicheaderlabel : 'Basic',
                    amount: data.basicsalary,
                    hourrate: temphourrate,
                    // hourratedesc : `(Basic Salary / Company Working Hours) \n (${data.basicsalary} / ${data.companyworkinghours})`,
                    hourratedesc: `Basic Salary / Company Working Hours`,
                    regularamount: totalHours * temphourrate,
                    // regularamountdesc : `(Regular Hours x Basic Hour Rate) \n (${totalHours} x ${temphourrate})`,
                    regularamountdesc: `Regular Hours x Basic Hour Rate`,
                    othoursamount: parseFloat(data.othour) * temphourrate,
                    // othoursamountdesc : `(Over Time Hours x Basic Hour Rate) \n (${data.othour} x ${temphourrate})`,
                    othoursamountdesc: `Over Time Hours x Basic Hour Rate`,
                    paidleaveamount: data.paidleavehours * temphourrate,
                    // paidleaveamountdesc : `(Paid Leave Hours x Basic Hour Rate) \n (${paidleavehours} x ${temphourrate})`,
                    paidleaveamountdesc: `Paid Leave Hours x Basic Hour Rate`,
                    total: ((totalHours * temphourrate) + (parseFloat(data.othour) * temphourrate) + (data.paidleavehours * temphourrate)),
                    // totaldesc : `Basic Regular Amount + Basic Overtime Amount + Basic Paid Leave Hours Amount \n (${(totalHours*temphourrate)} + ${(data.othour*temphourrate)}) + ${(paidleavehours*temphourrate)})`
                    totaldesc: `Basic Regular Amount + Basic Overtime Amount + Basic Paid Leave Amount`
                }

                let total = IISMethods.toFixedFloat(basicHeaderVerificationData.total)
                let basicsalary = IISMethods.toFixedFloat(checkBasicTotal)
                let checkVal

                if (total == basicsalary) {
                    checkVal = true
                }
                else {
                    checkVal = false
                }

                basicHeaderVerificationData.totalverification = checkVal
                verifyRows.push(basicHeaderVerificationData)

            } else {

                //BASIC DATA VERIFICATIONS
                let basicHeaderVerificationData = {
                    header: 'Basic',
                    amount: data.basicsalary,
                    hourrate: 0,
                    regularamount: 0,
                    othoursamount: 0,
                    paidleaveamount: 0,
                    total: data.basicsalary,
                }

                let total = IISMethods.toFixedFloat(basicHeaderVerificationData.total)
                let basicsalary = IISMethods.toFixedFloat(data.basicsalary)

                let checkVal

                if (total == basicsalary) {
                    checkVal = true
                }
                else {
                    checkVal = false
                }
                basicHeaderVerificationData.totalverification = checkVal
                verifyRows.push(basicHeaderVerificationData)

            }




            if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {


                //ALLOWANCES VERIFICATIONS
                for (let index = 0; index < data.allowances?.length; index++) {


                    let element = data.allowances[index];
                    let allowanceHeaderVerificationData = {}
                    let ctcAllowance = (data.grosssalary * element.value) / 100
                    let allowanceHourRate = ctcAllowance / data.companyworkinghours
                    let checkAllowanceTotal = allowanceHourRate * (totalHours + data.paidleavehours)
                    //getting actual % for this allowance

                    allowanceHeaderVerificationData.header = element.allowance
                    allowanceHeaderVerificationData.amount = ctcAllowance
                    allowanceHeaderVerificationData.hourrate = allowanceHourRate
                    allowanceHeaderVerificationData.hourratedesc = `(Allowance / Company Working Hours)`
                    allowanceHeaderVerificationData.regularamount = totalHours * allowanceHourRate
                    allowanceHeaderVerificationData.regularamountdesc = `(Regular Hours x Allowance Hour Rate)`
                    allowanceHeaderVerificationData.othoursamount = 0
                    allowanceHeaderVerificationData.othoursamountdesc = `(Over Time Hours x Allowance Hour Rate)`
                    allowanceHeaderVerificationData.paidleaveamount = data.paidleavehours * allowanceHourRate
                    allowanceHeaderVerificationData.paidleaveamountdesc = `(Paid Leave Hours x Allowance Hour Rate)`
                    allowanceHeaderVerificationData.total = ((totalHours * allowanceHourRate) + (data.paidleavehours * allowanceHourRate))
                    allowanceHeaderVerificationData.totaldesc = `Allowance Regular Amount + Allowance Overtime Amount + Allowance Paid Leave Hours Amount`


                    let total = IISMethods.toFixedFloat(allowanceHeaderVerificationData.total)
                    let basicsalary = IISMethods.toFixedFloat(checkAllowanceTotal)
                    let checkVal

                    if (total == basicsalary) {
                        checkVal = true
                    }
                    else {
                        checkVal = false
                    }
                    allowanceHeaderVerificationData.totalverification = checkVal

                    verifyRows.push(allowanceHeaderVerificationData)

                }

            } else {

                for (let index = 0; index < data.allowances?.length; index++) {

                    let element = data.allowances[index];
                    let allowanceHeaderVerificationData = {}
                    let ctcAllowance = (data.grosssalary * element.value) / 100

                    allowanceHeaderVerificationData.header = element.allowance
                    allowanceHeaderVerificationData.amount = ctcAllowance
                    allowanceHeaderVerificationData.hourrate = 0
                    allowanceHeaderVerificationData.regularamount = 0
                    allowanceHeaderVerificationData.othoursamount = 0
                    allowanceHeaderVerificationData.paidleaveamount = 0
                    allowanceHeaderVerificationData.total = ctcAllowance


                    let total = IISMethods.toFixedFloat(allowanceHeaderVerificationData.total)
                    let basicsalary = IISMethods.toFixedFloat(ctcAllowance)
                    let checkVal

                    if (total == basicsalary) {
                        checkVal = true
                    }
                    else {
                        checkVal = false
                    }


                    allowanceHeaderVerificationData.totalverification = checkVal

                    verifyRows.push(allowanceHeaderVerificationData)

                }

            }

            //ALLOWANCES DATA VERIFICATIONS=================================================================//

            //CONTRIBUTIONS
            //HEADER BONUS DATA VERIFICATIONS=================================================================//
            if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {


                for (let index = 0; index < data.headerbonus?.length; index++) {


                    let regularHoursForHeaderBonus = data.regularhours
                    let element = data.headerbonus[index]
                    let headerBonusHeaderVerificationData = {}
                    let ctcHeaderBonus = (data.grosssalary * element.value) / 100
                    let bonusHourRate = ctcHeaderBonus / data.companyworkinghours
                    let checkHeaderBonusTotal = bonusHourRate * (regularHoursForHeaderBonus + data.paidleavehours)

                    headerBonusHeaderVerificationData.header = element.headerbonus
                    headerBonusHeaderVerificationData.amount = ctcHeaderBonus
                    headerBonusHeaderVerificationData.hourrate = 0
                    headerBonusHeaderVerificationData.hourratedesc = ``
                    headerBonusHeaderVerificationData.regularamount = element.paidonsame ? element.headerbonusamount : 0
                    headerBonusHeaderVerificationData.regularamountdesc = ``
                    headerBonusHeaderVerificationData.othoursamount = 0
                    headerBonusHeaderVerificationData.othoursamountdesc = ``
                    headerBonusHeaderVerificationData.paidleaveamount = 0
                    headerBonusHeaderVerificationData.paidleaveamountdesc = ``
                    headerBonusHeaderVerificationData.total = element.paidonsame ? element.headerbonusamount : 0
                    headerBonusHeaderVerificationData.totaldesc = ``
                    headerBonusHeaderVerificationData.totalverification = true

                    verifyRows.push(headerBonusHeaderVerificationData)

                }

            } else {

                for (let index = 0; index < data.headerbonus?.length; index++) {

                    let element = data.headerbonus[index];
                    let headerBonusHeaderVerificationData = {}
                    let ctcHeaderBonus = (data.grosssalary * element.value) / 100

                    headerBonusHeaderVerificationData.header = element.headerbonus
                    headerBonusHeaderVerificationData.amount = ctcHeaderBonus
                    headerBonusHeaderVerificationData.hourrate = 0
                    headerBonusHeaderVerificationData.regularamount = element.paidonsame ? element.headerbonusamount : 0
                    headerBonusHeaderVerificationData.othoursamount = 0
                    headerBonusHeaderVerificationData.paidleaveamount = 0
                    headerBonusHeaderVerificationData.total = element.paidonsame ? element.headerbonusamount : 0
                    headerBonusHeaderVerificationData.totalverification = true

                    verifyRows.push(headerBonusHeaderVerificationData)

                }

            }


            //Variable CTC
            if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {


                for (let index = 0; index < data.variablectc?.length; index++) {

                    let element = data.variablectc[index]
                    //  if (!element.paidonsame) {
                    let ctcVariableData = {}
                    let ctcVariable = (data.grosssalary * element.value) / 100

                    ctcVariableData.header = element.bonusname
                    ctcVariableData.amount = ctcVariable
                    ctcVariableData.hourrate = 0
                    ctcVariableData.hourratedesc = ``
                    ctcVariableData.regularamount = 0
                    ctcVariableData.regularamountdesc = ``
                    ctcVariableData.othoursamount = 0
                    ctcVariableData.othoursamountdesc = ``
                    ctcVariableData.paidleaveamount = 0
                    ctcVariableData.paidleaveamountdesc = ``
                    ctcVariableData.total = 0
                    ctcVariableData.totaldesc = ``
                    ctcVariableData.totalverification = true

                    verifyRows.push(ctcVariableData)
                    //  }

                }

            } else {

                for (let index = 0; index < data.variablectc?.length; index++) {

                    let element = data.variablectc[index]
                    // if (!element.paidonsame) {
                    let ctcVariableData = {}
                    let ctcVariable = (data.grosssalary * element.value) / 100

                    ctcVariableData.header = element.bonusname
                    ctcVariableData.amount = ctcVariable
                    ctcVariableData.hourrate = 0
                    ctcVariableData.regularamount = 0
                    ctcVariableData.othoursamount = 0
                    ctcVariableData.paidleaveamount = 0
                    ctcVariableData.total = 0
                    ctcVariableData.totalverification = true

                    verifyRows.push(ctcVariableData)
                    // }

                }

            }

            // BONUS DATA VERIFICATIONS=================================================================//
            //BONUS RELEASE

            for (let index = 0; index < data.bonusdata?.length; index++) {

                let element = data.bonusdata[index];
                let bonusDataObj = {}

                bonusDataObj.header = `${element.bonusname} Release`
                bonusDataObj.amount = element.paidonsame ? 0 : element.amount
                bonusDataObj.hourrate = 0
                bonusDataObj.hourratedesc = ``
                bonusDataObj.regularamount = element.amount
                bonusDataObj.regularamountdesc = ``
                bonusDataObj.othoursamount = 0
                bonusDataObj.othoursamountdesc = ``
                bonusDataObj.paidleaveamount = 0
                bonusDataObj.paidleaveamountdesc = ``
                bonusDataObj.total = element.amount
                bonusDataObj.totaldesc = ``
                bonusDataObj.totalverification = true

                verifyRows.push(bonusDataObj)

            }
            // BONUS DATA VERIFICATIONS=================================================================//

            if (data.arrearsamount > 0) {
                verifyRows.push({
                    header: 'Arrears Management',
                    amount: 0,
                    hourrate: 0,
                    regularamount: 0,
                    othoursamount: 0,
                    paidleaveamount: 0,
                    total: this.safeParseFloat(data.arrearsamount),
                })

                totalVerAmount = totalVerAmount + this.safeParseFloat(data.arrearsamount)

            }
            if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {

                //PAYFOR
                if (payFor?.includes('Week-off') && data.paidweekoffday) {

                    let WeekoffVerificationData = {
                        header: 'Weekoff Pay',
                        amount: 0,
                        hourrate: 0,
                        regularamount: 0,
                        othoursamount: 0,
                        paidleaveamount: 0,
                        total: (data.ctcdayrate * data.paidweekoffday) + (data.ctcdayrate * (data.handleweekoff / 2)),
                    }
                    totalVerAmount = totalVerAmount + (data.ctcdayrate * data.paidweekoffday) + (data.ctcdayrate * (data.handleweekoff / 2))
                    verifyRows.push(WeekoffVerificationData)
                }

                if (payFor?.includes('Holiday') && data.holidays) {

                    let holidayTemp = data.ctcdayrate * data.holidays

                    if (data.multipleoff && payFor?.includes('Holiday') && payFor?.includes('Week-off')) {
                        holidayTemp = holidayTemp - (data.ctcdayrate * data.multipleoff)
                    }

                    let holidayVerificationData = {
                        header: 'Holiday Pay',
                        amount: 0,
                        hourrate: 0,
                        regularamount: 0,
                        othoursamount: 0,
                        paidleaveamount: 0,
                        total: holidayTemp
                    }
                    totalVerAmount = totalVerAmount + holidayTemp

                    // holidayVerificationData.totalverification = IISMethods.toFixedFloat(holidayVerificationData.total) == IISMethods.toFixedFloat(data.dayrate * data.holidays)
                    verifyRows.push(holidayVerificationData)

                }

            }


            // //BONUS
            // if (data.bonusdata && data.bonusdata?.length) {

            //     let bonusVerificationData = {
            //         header: 'Final Bonus Amount',
            //         amount: 0,
            //         hourrate: 0,
            //         regularamount: 0,
            //         othoursamount: 0,
            //         paidleaveamount: 0,
            //         total: data.finalbonusamount
            //     }

            //     verifyRows.push(bonusVerificationData)

            // }

            if (data.incentivesamount > 0) {
                verifyRows.push({
                    header: 'Incentives',
                    amount: 0,
                    hourrate: 0,
                    regularamount: 0,
                    othoursamount: 0,
                    paidleaveamount: 0,
                    total: parseFloat(data.incentivesamount),
                })

                totalVerAmount = totalVerAmount + parseFloat(data.incentivesamount)

            }
            if (data.reimbursementamount > 0) {
                verifyRows.push({
                    header: 'Reimbursement Amount',
                    amount: 0,
                    hourrate: 0,
                    regularamount: 0,
                    othoursamount: 0,
                    paidleaveamount: 0,
                    total: parseFloat(data.reimbursementamount),
                })

                totalVerAmount = totalVerAmount + parseFloat(data.reimbursementamount)

            }

            //REFERENCE BONUS
            if (data.emprefbonus > 0) {
                verifyRows.push({
                    header: 'Bonuses',
                    amount: 0,
                    hourrate: 0,
                    regularamount: 0,
                    othoursamount: 0,
                    paidleaveamount: 0,
                    total: parseFloat(data.emprefbonus),
                })

                totalVerAmount = totalVerAmount + parseFloat(data.emprefbonus)

            }

            let deductionRow = {
                header: 'Deductions',
                amount: 0,
                hourrate: 0,
                regularamount: 0,
                othoursamount: 0,
                paidleaveamount: 0,
                total: 0,
            }



            if (data.extrapayamount > 0) {
                verifyRows.push({
                    header: 'Extra Earning(s)',
                    amount: 0,
                    hourrate: 0,
                    regularamount: 0,
                    othoursamount: 0,
                    paidleaveamount: 0,
                    total: parseFloat(data.extrapayamount),
                })

                totalVerAmount = totalVerAmount + Math.abs(parseFloat(data.extrapayamount))

            }
            //Fnf leave encashment
            if (data.settledleaveamount > 0) {
                verifyRows.push({
                    header: 'Leave Encash Amount',
                    amount: data.settledleaveamount,
                    hourrate: 0,
                    regularamount: 0,
                    othoursamount: 0,
                    paidleaveamount: 0,
                    total: data.settledleaveamount,
                    totalverification: true,
                })
                totalVerAmount = totalVerAmount + Math.abs(parseFloat(data.settledleaveamount))
            }

            //Fnf Gratuity
            if (data.fnfsetteledgratuity > 0) {
                verifyRows.push({
                    header: 'Gratuity Amount',
                    amount: data.fnfsetteledgratuity,
                    hourrate: 0,
                    regularamount: 0,
                    othoursamount: 0,
                    paidleaveamount: 0,
                    total: data.fnfsetteledgratuity,
                    totalverification: true,
                })
                totalVerAmount = totalVerAmount + Math.abs(parseFloat(data.fnfsetteledgratuity))
            }

            //Fnf Expence Amount
            if (data.fnfexpenceamount > 0) {
                verifyRows.push({
                    header: 'Expence Amount',
                    amount: data.fnfexpenceamount,
                    hourrate: 0,
                    regularamount: 0,
                    othoursamount: 0,
                    paidleaveamount: 0,
                    total: data.fnfexpenceamount,
                    totalverification: true,
                })
                totalVerAmount = totalVerAmount + Math.abs(parseFloat(data.fnfexpenceamount))
            }

            // if (payforaddhour > 0 && data.payrolltypeid != payrollTypeIds['MonthyFixed']) {
            //     verifyRows.push({
            //         header: 'Extra Added Hours Pay',
            //         amount: 0,
            //         hourrate: 0,
            //         regularamount: 0,
            //         othoursamount: 0,
            //         paidleaveamount: 0,
            //         total: parseFloat(payforaddhour),
            //     })

            //     totalVerAmount = totalVerAmount + Math.abs(parseFloat(payforaddhour))

            // }
            // if (payforaddhour < 0 && data.payrolltypeid != payrollTypeIds['MonthyFixed']) {
            //     verifyRows.push({
            //         header: 'Removed Hours Pay',
            //         amount: 0,
            //         hourrate: 0,
            //         regularamount: 0,
            //         othoursamount: 0,
            //         paidleaveamount: 0,
            //         total: parseFloat(payforaddhour),
            //     })

            //     totalVerAmount = totalVerAmount - Math.abs(parseFloat(payforaddhour))

            // }


            //DEDUCTIONS
            if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {



                if (data.monthlypolicydeductions > 0) {
                    deductionRow.total = deductionRow.total - data.monthlypolicydeductions
                }

                if (data.specialpenaltyamount > 0) {
                    deductionRow.total = deductionRow.total - data.specialpenaltyamount
                }

                if (data.advancesalary > 0) {
                    deductionRow.total = deductionRow.total - data.advancesalary
                }

                if (data.deductionemployeeepf > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeepf
                }

                if (data.deductiontds > 0) {
                    deductionRow.total = deductionRow.total - data.deductiontds
                }

                if (data.deductionemployeeesic > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeesic
                }

                if (data.deductionprofessionaltax > 0) {
                    deductionRow.total = deductionRow.total - data.deductionprofessionaltax
                }

                if (data.lopamount > 0) {
                    deductionRow.total = deductionRow.total - data.lopamount
                }

                if (data.deductionemployeeeps > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeeps
                }
                if (data.deductionemployeeedli > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeedli
                }
                if (data.deductionemployeeepfadmin > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeepfadmin
                }
                if (data.dedelwf > 0) {
                    deductionRow.total = deductionRow.total - data.dedelwf
                }
                if (data.dederlwf > 0) {
                    deductionRow.total = deductionRow.total - data.dederlwf
                }
                // if (data.deductionemployerepf > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployerepf
                // }
                // if (data.deductionemployereps > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployereps
                // }
                // if (data.deductionemployeredli > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployeredli
                // }
                // if (data.deductionemployerepfadmin > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployerepfadmin
                // }
                // if (data.deductionemployeresic > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployeresic
                // }
                // if (data.deductionemployeresicadmin > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployeresicadmin
                // }
                if (data.deductinsurance > 0) {
                    deductionRow.total = deductionRow.total - data.deductinsurance
                }

                if (data.loandetails && data.loandetails?.length) {
                    let loandeductionAmount = 0
                    data.loandetails?.filter((data) => data.selected)?.map(la => loandeductionAmount = loandeductionAmount + la.installmentamount)
                    deductionRow.total = deductionRow.total - (loandeductionAmount)
                }

                if (data.extrapayamount && data.extrapayamount < 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.extrapayamount))
                }
                //Fnf section 
                if (data.fnfadvancereceivableamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfadvancereceivableamount))
                }
                if (data.fnfassetdamageamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfassetdamageamount))
                }
                if (data.fnfothersettelementamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfothersettelementamount))
                }
                if (data.fnfnoticerecoveyamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfnoticerecoveyamount))
                }
                if (data.fnfloanamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfloanamount))
                }

            } else {


                if (data.advancesalary > 0) {
                    deductionRow.total = deductionRow.total - data.advancesalary
                }

                if (data.deductionemployeeepf > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeepf
                }

                if (data.deductiontds > 0) {
                    deductionRow.total = deductionRow.total - data.deductiontds
                }

                if (data.deductionemployeeesic > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeesic
                }

                if (data.deductionprofessionaltax > 0) {
                    deductionRow.total = deductionRow.total - data.deductionprofessionaltax
                }

                if (data.deductionemployeeeps > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeeps
                }
                if (data.deductionemployeeedli > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeedli
                }
                if (data.deductionemployeeepfadmin > 0) {
                    deductionRow.total = deductionRow.total - data.deductionemployeeepfadmin
                }
                if (data.dedelwf > 0) {
                    deductionRow.total = deductionRow.total - data.dedelwf
                }
                if (data.dederlwf > 0) {
                    deductionRow.total = deductionRow.total - data.dederlwf
                }
                // if (data.deductionemployerepf > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployerepf
                // }
                // if (data.deductionemployereps > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployereps
                // }
                // if (data.deductionemployeredli > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployeredli
                // }
                // if (data.deductionemployerepfadmin > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployerepfadmin
                // }
                // if (data.deductionemployeresic > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployeresic
                // }
                // if (data.deductionemployeresicadmin > 0) {
                //     deductionRow.total = deductionRow.total - data.deductionemployeresicadmin
                // }
                if (data.deductinsurance > 0) {
                    deductionRow.total = deductionRow.total - data.deductinsurance
                }

                if (data.loandetails && data.loandetails?.length) {
                    let loandeductionAmount = 0
                    data.loandetails?.filter((data) => data.selected)?.map(la => loandeductionAmount = loandeductionAmount + la.installmentamount)

                    deductionRow.total = deductionRow.total - (loandeductionAmount)
                }

                if (data.extrapayamount && data.extrapayamount < 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.extrapayamount))
                }
                //Fnf section 
                if (data.fnfadvancereceivableamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfadvancereceivableamount))
                }
                if (data.fnfassetdamageamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfassetdamageamount))
                }
                if (data.fnfothersettelementamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfothersettelementamount))
                }
                if (data.fnfnoticerecoveyamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfnoticerecoveyamount))
                }
                if (data.fnfloanamount > 0) {
                    deductionRow.total = deductionRow.total - Math.abs(parseFloat(data.fnfloanamount))
                }

            }

            // PF CONTRIBUTIONS
            let pfContri = {
                header: 'PF Contribution',
                amount: 0,
                hourrate: 0,
                regularamount: 0,
                othoursamount: 0,
                paidleaveamount: 0,
                total: 0,
            }

            if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {

                if (data.deductionemployerepf > 0) {
                    pfContri.amount = pfContri.amount + data.deductionemployerepf
                }
                if (data.deductionemployereps > 0) {
                    pfContri.amount = pfContri.amount + data.deductionemployereps
                }
                if (data.deductionemployeredli > 0) {
                    pfContri.amount = pfContri.amount + data.deductionemployeredli
                }
                if (data.deductionemployerepfadmin > 0) {
                    pfContri.amount = pfContri.amount + data.deductionemployerepfadmin
                }

            } else {

                if (data.deductionemployerepf > 0) {
                    pfContri.amount = pfContri.amount + data.deductionemployerepf
                }
                if (data.deductionemployereps > 0) {
                    pfContri.amount = pfContri.amount + data.deductionemployereps
                }
                if (data.deductionemployeredli > 0) {
                    pfContri.amount = pfContri.amount + data.deductionemployeredli
                }
                if (data.deductionemployerepfadmin > 0) {
                    pfContri.amount = pfContri.amount + data.deductionemployerepfadmin
                }

            }

            verifyRows.push(pfContri)

            // ESI CONTRIBUTIONS
            let esiContri = {
                header: 'ESI Contribution',
                amount: 0,
                hourrate: 0,
                regularamount: 0,
                othoursamount: 0,
                paidleaveamount: 0,
                total: 0,
            }

            if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {
                if (data.deductionemployeresic > 0) {
                    esiContri.amount = esiContri.amount + data.deductionemployeresic
                }
                if (data.deductionemployeresicadmin > 0) {
                    esiContri.amount = esiContri.amount + data.deductionemployeresicadmin
                }
            } else {
                if (data.deductionemployeresic > 0) {
                    esiContri.amount = esiContri.amount + data.deductionemployeresic
                }
                if (data.deductionemployeresicadmin > 0) {
                    esiContri.amount = esiContri.amount + data.deductionemployeresicadmin
                }

            }

            verifyRows.push(esiContri)

            if (data.finaldeductbonusamount > 0) {
                deductionRow.total = deductionRow.total - data.finaldeductbonusamount
            }

            //   // BONUS DATA VERIFICATIONS=================================================================// show with var
            //   if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {


            //     for (let index = 0; index < data.deductionbonusdata?.length; index++) {


            //         let element = data.deductionbonusdata[index]
            //         let headerBonusHeaderVerificationData = {}

            //         headerBonusHeaderVerificationData.header = element.bonusname
            //         headerBonusHeaderVerificationData.amount = 0
            //         headerBonusHeaderVerificationData.hourrate = 0
            //         headerBonusHeaderVerificationData.hourratedesc = ``
            //         headerBonusHeaderVerificationData.regularamount = 0
            //         headerBonusHeaderVerificationData.regularamountdesc = ``
            //         headerBonusHeaderVerificationData.othoursamount = 0
            //         headerBonusHeaderVerificationData.othoursamountdesc = ``
            //         headerBonusHeaderVerificationData.paidleaveamount = 0
            //         headerBonusHeaderVerificationData.paidleaveamountdesc = ``
            //         headerBonusHeaderVerificationData.total = - data.finaldeductbonusamount
            //         headerBonusHeaderVerificationData.totaldesc = ``
            //         headerBonusHeaderVerificationData.totalverification = true

            //         verifyRows.push(headerBonusHeaderVerificationData)
            //         totalVerAmount = totalVerAmount - data.finaldeductbonusamount

            //     }

            // } else {

            //     for (let index = 0; index < data.deductionbonusdata?.length; index++) {

            //         let element = data.deductionbonusdata[index]
            //         console.log(element,'elementelement')
            //         let headerBonusHeaderVerificationData = {}

            //         headerBonusHeaderVerificationData.header = element.bonusname
            //         headerBonusHeaderVerificationData.amount = 0
            //         headerBonusHeaderVerificationData.hourrate = 0
            //         headerBonusHeaderVerificationData.regularamount = 0
            //         headerBonusHeaderVerificationData.othoursamount = 0
            //         headerBonusHeaderVerificationData.paidleaveamount = 0
            //         headerBonusHeaderVerificationData.total = - data.finaldeductbonusamount
            //         headerBonusHeaderVerificationData.totalverification = true



            //         verifyRows.push(headerBonusHeaderVerificationData)

            //         totalVerAmount = totalVerAmount - data.finaldeductbonusamount
            //     }

            // }
            // BONUS DATA VERIFICATIONS=================================================================//

            verifyRows.push(deductionRow)

            let verifyRowsTotal = {
                amount: 0,
                hourrate: 0,
                regularamount: 0,
                othoursamount: 0,
                paidleaveamount: 0,
                total: 0,
            }

            for (let index = 0; index < verifyRows?.length; index++) {

                let element = verifyRows[index];


                verifyRowsTotal.header = 'Total'
                verifyRowsTotal.amount = verifyRowsTotal.amount + element.amount
                verifyRowsTotal.hourrate = verifyRowsTotal.hourrate + element.hourrate
                verifyRowsTotal.regularamount = verifyRowsTotal.regularamount + element.regularamount
                verifyRowsTotal.othoursamount = verifyRowsTotal.othoursamount + element.othoursamount
                verifyRowsTotal.paidleaveamount = verifyRowsTotal.paidleaveamount + element.paidleaveamount
                verifyRowsTotal.total = verifyRowsTotal.total + element.total
            }


            if (data.payrolltypeid != payrollTypeIds['MonthyFixed']) {



                totalVerAmount = totalVerAmount + verifyRowsTotal.regularamount + verifyRowsTotal.othoursamount + verifyRowsTotal.paidleaveamount + deductionRow.total

                verifyRowsTotal.hourrateverification = IISMethods.toFixedFloat(verifyRowsTotal.hourrate) == IISMethods.toFixedFloat((data.grosssalary / data.companyworkinghours))
                verifyRowsTotal.regularamountverification = IISMethods.toFixedFloat(verifyRowsTotal.regularamount) == IISMethods.toFixedFloat((((data.grosssalary / data.companyworkinghours) * totalHours) + data.headerbonusamounttobepaid + data.finalbonusamount))
                verifyRowsTotal.othoursamountverification = IISMethods.toFixedFloat(verifyRowsTotal.othoursamount) == IISMethods.toFixedFloat(((data.basicsalary / data.companyworkinghours) * parseFloat(data.othour)))
                verifyRowsTotal.paidleaveamountverification = IISMethods.toFixedFloat(verifyRowsTotal.paidleaveamount) == IISMethods.toFixedFloat(((data.grosssalary / data.companyworkinghours) * data.paidleavehours))
                verifyRowsTotal.totalverification = IISMethods.toFixedFloat(verifyRowsTotal.total) == IISMethods.toFixedFloat(totalVerAmount)


            } else {

                verifyRowsTotal.hourrateverification = true
                verifyRowsTotal.regularamountverification = true
                verifyRowsTotal.othoursamountverification = true
                verifyRowsTotal.paidleaveamountverification = true
                verifyRowsTotal.totalverification = true

            }


            verifyRows.push(verifyRowsTotal)
            return verifyRows
            //SALARY VERIFICATION========================================================================================================================

        } catch (err) {
            console.log(err)
        }
    }

    //use to convert a sentence into uppercase, lowercase & camelcase
    /**
     * 
     * @param {string} sentence any sentence
     * @param {string} caseType 1 - uppercase | 2 - lowercase | 3 - camelcase
     * @returns converted string
     */
    convertStringCase(sentence, caseType = 1) {
        if (typeof sentence != "string") return ""

        const cases = {
            1: () => sentence.toUpperCase(),
            2: () => sentence.toLowerCase(),
            3: () => sentence.replace(/\w\S*/g, word => word.charAt(0).toUpperCase() + word?.slice(1).toLowerCase())
        }

        return cases[caseType]()
    }

    async requestNotificationPermission() {
        const permission = await Notification.requestPermission()
        if (permission === 'granted') {
            console.log('Notification permission granted.')
        } else {
            console.log('Notification permission denied.')
        }
    }

    sendNotification(title, options) {
        if (Notification.permission === 'granted') {
            new Notification(title, options)
        } else {
            console.log('User has not granted permission.')
        }
    }

    // hemang jani
    // get theme selected by user from login info
    getUserTheme() {
        return IISMethods.getCookiesData("loginInfo")?.theme == 0 ?
            'light-colors' : IISMethods.getCookiesData("loginInfo")?.theme == 1 ?
                'dark-color' : IISMethods.getCookiesData("loginInfo")?.theme == 2 ?
                    'semi-dark-color' : undefined
    }

    //  redirect to task function | Priyanshi Sarvan ~  2024-12-30 ~ 12:05 PM 
    redirectToTask(task, data = null, type = null) {
        const currentPagename = IISMethods.getpagename()
        let pagename = Config.aliasname['tasksalias']

        const loginInfo = IISMethods.getCookiesData("loginInfo")?.subdomainname
        const projectObj = IISMethods.getobjectfromarray(IISMethods.getLocalData("projectsData"), "_id", task?.projectid || data?.project?._id)?.projectname
        const projectname = (data?.project?.projectname || task.project || projectObj)?.replace(/ /g, '')

        let taskseriesid = IISMethods.getEncodeID(task.taskseriesid ? task.taskseriesid : task.taskid)
        const decodedProjectname = IISMethods.getEncodeID(projectname)

        if (currentPagename == Config.aliasname['taskskanbanalias'] || currentPagename == Config.aliasname['tasksplainviewalias'] || currentPagename == Config.aliasname['tasksclassicviewalias']) {
            pagename = pagename + '/' + currentPagename
        }

        const search = `${decodedProjectname}/${taskseriesid}/${task?.tasktype === 'Task' && task?.taskorissueid?.trim()?.length
            ? (task._id ? task._id : task.taskid) : (!task._id && task.taskid) ? task.taskid : task?._id}/${task.projectid || data?.project?._id}${(task?.tasktype === 'Task' && task?.taskorissueid)
                ? `/${task?.taskorissueid}` : ""}${Config.getServermode() === 'prod' ? '' : `?q=${loginInfo}`}`;
        window.open(`/${pagename}/${search}`)
    }

    //  redirect to Letter Series Master function | Deep Dungarani ~  2025-07-16 ~ 12:05 PM 
    redirectToLetter(data, isdynamickey, keys) {
        let letterid
        let personid
        let letterseries

        if (isdynamickey && Array.isArray(keys)) {
            // Use dynamic keys from the keys array
            letterid = IISMethods.getEncodeID(data[keys[0]])
            personid = IISMethods.getEncodeID(data[keys[1]])
            if (data[keys[2]]) {
                const encryptedLetterSeriesId = IISMethods.encryptData(data[keys[2]], true)
                letterseries = encodeURIComponent(encryptedLetterSeriesId)
            }
        } else {
            // Fallback to static keys
            if (data.letterid) {
                letterid = IISMethods.getEncodeID(data.letterid)
            }
            if (data.personid) {
                personid = IISMethods.getEncodeID(data.personid)
            }
            if (data.letterseries) {
                const encryptedLetterSeriesId = IISMethods.encryptData(data.letterseries, true)
                letterseries = encodeURIComponent(encryptedLetterSeriesId)
            }
        }
        const subdomainname = IISMethods.getCookiesData("loginInfo")?.subdomainname
        const pagename = `/${Config.aliasname['allletterslogalias']}`

        if (letterseries) {
            const url = `${pagename}/${letterid}/${personid}/${letterseries}${Config.getServermode() == 'prod' ? '' : `?q=${subdomainname}`}`
            window.open(url)
        }
        else {
            const url = `${pagename}/${letterid}/${personid}${Config.getServermode() == 'prod' ? '' : `?q=${subdomainname}`}`
            window.open(url)
        }
    }

    /**
    *  @param {bool} tododata //todo data for redirection
    * @returns 
    */
    redirectToTodo(tododata) {

        const todoCategory = tododata.categoryname.replace(/ /g, '')
        const decodedtodoCategory = IISMethods.getEncodeID(todoCategory)
        const todoseriesid = IISMethods.getEncodeID(tododata.todoseriesid)
        const subdomainname = IISMethods.getCookiesData("loginInfo")?.subdomainname
        const pagename = `/${Config.aliasname['todoalias']}`

        const url = `${pagename}/${decodedtodoCategory}/${todoseriesid}/${tododata.todoid}/${tododata.todocategoryid}${Config.getServermode() == 'prod' ? '' : `?q=${subdomainname}`}`
        window.open(url)
    }

    /**
     *  @param {bool} supportdata //supportdata for redirection
     * @returns 
     */
    // this is used for redirection of support ticket and bizcompass supportticket 
    redirectToSupportTicket(supportdata) {

        const supportCategory = supportdata.supportcategoryname.replace(/ /g, '')
        const decodedsupportCategory = IISMethods.getEncodeID(supportCategory)
        const supportseriesid = IISMethods.getEncodeID(supportdata.supportseriesid)
        const supportcategoryId = supportdata.supportcategoryid
        const subdomainname = IISMethods.getCookiesData("loginInfo")?.subdomainname
        const pagename = `/${supportdata.pagename}`

        const url = `${pagename}/${decodedsupportCategory}/${supportseriesid}/${supportcategoryId}${Config.getServermode() == 'prod' ? '' : `?q=${subdomainname}`}`
        window.open(url)
    }

    /**
    *  @param {bool}  type //send employee type as number 
    * @returns 
    */
    showEmployeeTypeLabel(type) {

        if (type == 0) {
            return "Employee"
        }
        else if (type == 1) {
            return "Intern"
        }
        else if (type == 3) {
            return "Apprentice"
        }
        // New Trainee Type Change | Shubham ➡ ~  2025-05-15 ~ 03:49 PM
        else if (type == 4) {
            return "Trainee"
        }
        else if (type == 2) {
            return "Consultant"
        }
        else {
            return "-"
        }
    }

    isSubDomainMatch = () => {
        return IISMethods.getCookiesData("loginInfo")?.subdomainname === Config.bizsupportticketsubdomain
    }

    //PRIYANSHI --> for get address from latitude and longitude
    /**
     * 
     * @param {Number} latitude //map parameter
     * @param {Number} longitude //map parameter
     * @returns 
     */
    getAddressFromCoordinates = async (latitude, longitude) => {
        const geocodeURL = `${Config.getGeocodeUrl}=${latitude},${longitude}&key=${this.getCurrentState().GOOGLE_MAP_API_KEY}`

        try {
            const response = await axios.get(geocodeURL)
            const results = response.data.results

            if (results?.length > 0) {
                const fullAddress = results[0].formatted_address // Complete address
                const addressParts = fullAddress.split(",");
                const shortAddress = addressParts?.slice(0, -2).join(',') // Removing country part

                return {
                    latitude,
                    longitude,
                    fullAddress,
                    shortAddress,
                }
            } else {
                throw new Error("No address found")
            }
        } catch (error) {
            console.error("Error fetching address:", error)
            return null; // Return null if error occurs
        }
    }

    // getting address from latitude, longitude
    async getAddress(lat, lng) {
        try {
            const geocodeURL = `${Config.getGeocodeUrl}=${lat},${lng}&key=${this.getCurrentState().GOOGLE_MAP_API_KEY}`

            const response = await axios.get(geocodeURL)
            const data = response.data.results

            if (!data || data.length === 0) return "Address not found"

            const addressComponents = data[0].address_components

            let city = ""
            let state = ""
            let country = ""

            for (let component of addressComponents) {
                const types = component.types;
                if (types.includes("locality")) {
                    city = component.long_name
                }

                if (types.includes("administrative_area_level_1")) {
                    state = component.long_name
                }

                if (types.includes("country")) {
                    country = component.long_name
                }
            }
            let locationData = `${city || ''}${state ? ',' : ''} ${state || ''}${country ? ',' : ''} ${country || ''}`
            return locationData // Fallback to state if city not found
        } catch (error) {
            console.error("Error:", error)
            return "Location not found"
        }
    }

    // to check local file path is valid or not | Shubham ➡ ~  2025-03-10 ~ 03:09 PM
    /**
     * 
     * @param {String} path //path of a file
     * @returns 
     */
    isLocalFilePath(path) {
        const windowsRegex = /^[a-zA-Z]:(\\[a-zA-Z0-9._-]+)+\\?$/;
        const unixRegex = /^\/([a-zA-Z0-9._-]+\/?)+$/;

        return windowsRegex.test(path) || unixRegex.test(path);
    }

    // To give mordern format for time eg: 3.5 -> 3 hr 30 min  ----> Utsav
    /**
     * 
     * @param {float} hours 
     * @returns Mordern representation format of time
     */
    formatTime(decimalTime) {
        // Calculate hours and minutes
        const hrs = Math.floor(decimalTime) // Get the whole hours part
        const mins = Math.round((decimalTime - hrs) * 60); // Calculate the remaining minutes

        // Format the time as "hh hr mm min"
        return `${hrs.toString().padStart(2, '0')} hr ${mins.toString().padStart(2, '0')} min`
    }

    // common rights check functions start

    // to check edit rights with canmanage
    /**
       * 
       * @param {Object} data grid data data 
        * @param {Object} pagealias pass page alias to check rights of that page
        * @param {Array} forapprovals pass true if want to ignore recordinfo - entry by for edit rights
       */
    isEditVisible(data, pagealias, forapprovals = false) {
        const loginInfo = IISMethods.getCookiesData("loginInfo")
        const pageRights = IISMethods.getPageRights(pagealias)
        // if data do not have recordinfo || for approvals dont check entryuid in edit check
        if (!data?.hasOwnProperty('recordinfo') || forapprovals) {
            return pageRights.alleditright || pageRights.selfeditright || pageRights.requestright
        }
        else {
            return pageRights.alleditright || (pageRights.selfeditright && (data.recordinfo?.entryuid === loginInfo.uid)) || pageRights.requestright
        }
    }

    // to check delete rights with canmanage
    /**
       * 
       * @param {Object} data grid data data 
        * @param {Object} pagealias pass page alias to check rights of that page
        * @param {Array} forapprovals pass true if want to ignore recordinfo - entry by for delete rights
       */
    isDeleteVisible(data, pagealias, forapprovals = false) {
        const loginInfo = IISMethods.getCookiesData("loginInfo")
        const pageRights = IISMethods.getPageRights(pagealias)
        // if data do not have recordinfo || for approvals dont check entryuid in delete check
        if (!data?.hasOwnProperty('recordinfo') || forapprovals) {
            return pageRights.alldelright || pageRights.selfdelright || pageRights.requestright
        }
        else {
            return pageRights.alldelright || (pageRights.selfdelright && (data.recordinfo?.entryuid === loginInfo.uid)) || pageRights.requestright
        }
    }

    // to return filter for employee rights wise
    /**
       * 
        * @param {Object} pagealias pass page alias to check rights of that page
        * @param {Array} staticfilter staticfilter
        * @param {Boolean} withrights send true to call userrole wise emp
       */
    setEmployeeFilterByRights(pagealias, staticfilter, withrights = false) {
        const loginInfo = IISMethods.getCookiesData("loginInfo");
        const pageRights = IISMethods.getPageRights(pagealias);

        // for superadmin
        if (pageRights?.requestright) {
            return { 'isactive': true, ...staticfilter };
        }

        if (pageRights?.allviewright) {
            // to call userrole wise 
            if (withrights) {
                return { 'withrights': 1, 'isactive': true, ...staticfilter };
            }
            // reportto/ approve to wise
            else {
                return { 'reportingtoperson': true, 'approvetoperson': true, 'isactive': true, ...staticfilter };
            }
        }

        return { '_id': loginInfo?.uid, 'isactive': true, ...staticfilter };
    }

    /**
       * 
        * @param {String} id pass id for rotate icon and show/hide the accordian
    **/
    // common rights check functions end
    handleTableAccordian(id) {
        try {
            document.getElementById(`${id}collapseicon`).classList.toggle('rotate--180')

            // Select all child rows with matching class
            const childRows = document.querySelectorAll(`.child-row-${id}`);
            childRows.forEach(row => row.classList.toggle('show'));
        }
        catch (e) {
            console.log(e)
        }
    }

    /**
       * 
        * @param {Object} data pass the data which you want to check hierarchy
    **/
    // approval hierarchy - check rights for person for approve/reject | Nirzar Gabani 💀 ~  2025-06-17 ~ 11:46 AM


    getActionValue(item = {}, key) {
        if (key) return item[key];
        return item.status;
    }
    checkApproveRejectRights(data, viewonly = false,key) {
        
       try {
         const loginData = IISMethods.getCookiesData("loginInfo");
        let { admindata = [], approvalnode = [], approvednode = [] } = data;
        // if (viewonly) {
        //     approvalnode = approvalnode?.filter(node => node.viewonly !== 1)
        // }
        // Helper function to find user's position in hierarchy
        const findUserPosition = (hierarchy, userId) => {
            for (let i = 0; i < hierarchy.length; i++) {
                if (hierarchy[i]?.persons?.includes(userId)) {
                    return { found: true, index: i, data: hierarchy[i] };
                }
            }
            return { found: false, index: -1, data: null };
        };

        // Helper function to get last approved person data
        const getLastApprovedData = (approvalnode) => {
            // Find the last person who approved (status = 1)
            for (let i = approvalnode.length - 1; i >= 0; i--) {
                if (this.getActionValue(approvalnode[i],key) === 1) {
                    return approvalnode[i];
                }
            }
            return null;
        };

        // Helper function to check if request is finalized
        const isRequestFinalized = (data) => {
            if (admindata.length > 0) {
                return admindata.some(admin => {
                    const val = this.getActionValue(admin,key);
                    return val === 1 || val === 2 || val === 3;
                }) || [1, 2, 3].includes(this.getActionValue(data,key));
            } else {
                const lastPerson = approvalnode[approvalnode.length - 1];
                const val = this.getActionValue(lastPerson,key);
                return (val === 1 || val === 2 || val === 3) || [1, 2, 3].includes(this.getActionValue(data,key));
            }
        };


        // Check if user is admin
        const isAdmin = admindata.length > 0 && admindata.some(admin =>
            admin.persons?.includes(loginData?.uid)
        )

        // Find user position in approvalnode
        const userPosition = findUserPosition(approvalnode, loginData?.uid)

        // Get last approved data
        // const lastApprovedData = getLastApprovedData(admindata?.length ? admindata : approvalnode)
        const lastApprovedData = getLastApprovedData(approvednode)

        // Check if request is finalized
        const finalApprove = isRequestFinalized(data)

        const findApprovalUserPosition = (hierarchy, userId) => {
            for (let i = 0; i < hierarchy.length; i++) {
                if (hierarchy[i]?.id === userId) {
                    return { found: true, index: i, data: hierarchy[i] };
                }
            }
            return { found: false, index: -1, data: null };
        }

        // Identify the next pending approval user after the last approved person and display it accordingly | Deep Dungarani  ~ 2025-11-10
        let nextpendingapproval = {}
        const approvalNodeData = this.getCopy(approvalnode)
        if (lastApprovedData?.id) {
            const approvalUserPosition = findApprovalUserPosition(approvalNodeData, lastApprovedData?.id)

            // Start checking from the next position after the last approved one
            for (let i = approvalUserPosition.index + 1; i < approvalNodeData.length; i++) {
                if (!approvalNodeData[i]?.viewonly) {
                    nextpendingapproval = approvalNodeData[i]
                    break
                }
            }
        }
        else {
            nextpendingapproval = approvalNodeData?.find(data => !data.viewonly) || {}
        }



        // If user is admin
        if (isAdmin) {
            const adminUser = admindata.find(admin => admin.persons?.includes(loginData?.uid))
            const adminUserIndex = admindata.findIndex(admin => admin.persons?.includes(loginData?.uid))
            return {
                canApprove: true,
                personData: adminUser,
                latestApproveData: lastApprovedData || {},
                canNextApprove: true,
                finalApprove: adminUser?.[key ?? 'status'] === 1 || adminUser?.[key ?? 'status'] === 2 || adminUser?.[key ?? 'status'] === 3 || data?.[key ?? 'status'] === 1 || data?.[key ?? 'status'] === 2 || data?.[key ?? 'status'] === 3,
                actionIndex: adminUserIndex, // Admin is not in approvalnode
                isAdmin: true,
                userLevel: 'admin',
                nextpendingapproval: nextpendingapproval ? nextpendingapproval : {}
            }
        }

        // If user is not found in approvalnode
        if (!userPosition.found) {
            return {
                canApprove: false,
                personData: {},
                latestApproveData: lastApprovedData || {},
                canNextApprove: false,
                finalApprove: finalApprove,
                actionIndex: -1,
                isAdmin: false,
                userLevel: 'none',
                nextpendingapproval: nextpendingapproval ? nextpendingapproval : {}
            }
        }

        // User is found in approvalnode
        const userIndex = userPosition.index
        const userData = userPosition.data
        const isTopLevel = userIndex === approvalnode.length - 1 // Last person in hierarchy

        // Check if user can approve based on hierarchy rules
        let canApprove = false
        let canNextApprove = false

        if (finalApprove) {
            // If request is finalized, only top-level or admin can reject/close
            canApprove = isTopLevel && userData?.[key ?? 'status'] !== 1 && userData?.[key ?? 'status'] !== 2 && userData?.[key ?? 'status'] !== 3
            canNextApprove = userIndex === approvalnode.length - 1 ? true : false
        } else {
            // Check if any person after current user has already approved
            const hasLaterApprovals = approvalnode.slice(userIndex + 1).some(person =>
                this.getActionValue(person,key) === 1 || this.getActionValue(person,key) === 2 || this.getActionValue(person,key) === 3
            )

            if (hasLaterApprovals) {
                // Someone later in hierarchy has already acted - user cannot approve
                canApprove = false
                canNextApprove = false
            } else {
                // Check if user hasn't already taken action
                const hasUserActed = userData?.[key ?? 'status'] === 1 || userData?.[key ?? 'status'] === 2 || userData?.[key ?? 'status'] === 3
                canApprove = !hasUserActed
                canNextApprove = !isTopLevel // Only non-top-level users can have next approvals
            }
        }

        return {
            canApprove,
            personData: userData,
            latestApproveData: lastApprovedData || {},
            canNextApprove,
            finalApprove,
            actionIndex: userIndex,
            isAdmin: false,
            userLevel: isTopLevel ? 'top' : 'middle',
            hasLaterApprovals: approvalnode.slice(userIndex + 1).some(person =>
                person?.[key ?? 'status'] === 1 || person?.[key ?? 'status'] === 2 || person?.[key ?? 'status'] === 3
            ),
            nextpendingapproval: nextpendingapproval ? nextpendingapproval : {}
        }
       }
       catch (error) {
        console.error("Error in checkApproveRejectRights:", error);
    }
}

    // // Function to generate approval history in hierarchical order - Deep Dungarani ~ 2025-08-29 ~ 11:20 AM
    processApprovalHistory(data,statuskey) {
        const { admindata = [], approvalnode = [], approvednode = [] } = data
        
        const approvedNodes = approvednode ? approvednode.map(v => ({ ...v })) : []
        const approvalNodesData = approvalnode ? approvalnode.map(v => ({ ...v })) : []
        const approvalNodes = approvalNodesData?.filter(data => !data.viewonly) || []
        const adminData = admindata ? admindata.map(v => ({ ...v })) : []

        let finalList = []
        let skippedApproval = []

        const adminPersonIds = new Set()
        adminData.forEach(admin => {
            const persons = admin.persons || []
            persons.forEach(personId => adminPersonIds.add(personId))
        });

        for (const approvalNode of approvalNodes) {
            const personList = approvalNode.persons || []
            // filter all matches for this node
            const matches = approvedNodes.filter(a => personList.includes(a.approvedpersonid))
            if (matches.length > 0) {
                // take the last match (latest approval)
                const approved = matches[matches.length - 1]

                finalList.push({
                    ...approvalNode,
                    approvedperson: approved.approvedperson,
                    approvedpersonid: approved.approvedpersonid,
                    status: statuskey ? approved[statuskey] : approved.status,
                    time: approved.time,
                    rejectreason: approved.rejectreason,
                    _id: approved._id,
                })
            } else {
                // no approvals yet → keep original
                finalList.push({
                    ...approvalNode
                })
            }
        }

        // Step 2: Add approvedNode if it's only in adminData
        for (const approved of approvedNodes) {
            const approvedId = approved.approvedpersonid
            const isInApprovalNode = finalList.some(node => {
                const persons = node.persons || []
                return persons.includes(approvedId)
            })

            const isInAdmin = adminPersonIds.has(approvedId)

            if (!isInApprovalNode && isInAdmin) {
                const matchedAdmin = adminData.find(admin => {
                    const persons = admin.persons || []
                    return persons.includes(approvedId)
                }) || {}

                const newNode = {
                    ...approved,
                    status: statuskey ? approved[statuskey] : approved.status,
                    persons: [approvedId],
                    viewonly: 0,
                    title: matchedAdmin.title,
                    type: matchedAdmin.type,
                    id: matchedAdmin.id,
                }

                finalList.push(newNode)
            }

            if (!isInApprovalNode && !isInAdmin  ) {
                const missingApprovedNodes = approvedNodes.filter(approved => {
                    return !approvalNodes.some(approval => approval.persons && approval.persons.includes(approved.approvedpersonid));
                });

                if (missingApprovedNodes.length > 0) {
                    skippedApproval = missingApprovedNodes
                }
            }
        }

        // Step 3: Add admin-approved nodes (type == 9) if adminData is empty
        if (adminData.length === 0) {
            for (const approved of approvedNodes) {
                if (approved.type === 9) {
                    const alreadyExists = finalList.some(node => node._id === approved._id)
                    const generateUniqueId = () => {
                        return `admin_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
                    };

                    if (!alreadyExists) {
                        const adminNode = {
                            ...approved,
                            status: statuskey ? approved[statuskey] : approved.status,
                            persons: [approved.approvedpersonid],
                            viewonly: 0,
                            title: 'Admin',
                            type: 9,
                            id: generateUniqueId(),
                        };

                        finalList.push(adminNode)
                    }
                }
            }
        }

        if (finalList.length > 0) {
            let finalApprover = null;
            // 🔹 Step 1: Admin check in approvedNodes
            const adminNode = approvedNodes.find(node => node.type === 9);

            if (adminNode) {
                const lastApprovedNode = approvedNodes[approvedNodes.length - 1]
                const isLastAdmin = lastApprovedNode && (lastApprovedNode.id === adminNode.id)
                if (isLastAdmin) {
                    // replace Admin entry inside finalList with lastApprovedNode
                    finalList = finalList?.filter(data => !data.viewonly || ((data.viewonly === 1 || !data.viewonly) && data.approvedpersonid))?.map(node =>
                        node.id === adminNode.id ? { ...node, ...lastApprovedNode } : node
                    )

                    finalApprover = lastApprovedNode

                    // return finalList
                }
            }

            // 🔹 Step 2: If no Admin found OR Admin is not last approver → iterate approvalNodes in reverse
            if (!finalApprover) {
                const filteredHierarchyData = approvalNodes?.filter(data => !data.viewonly || ((data.viewonly === 1 || !data.viewonly) && data.approvedpersonid))

                const finalApproverNode = filteredHierarchyData.length > 0 ? filteredHierarchyData[filteredHierarchyData.length - 1] : []
                if (finalApproverNode) {
                    // 🔹 Step 3: Reorder list
                    // find its index in original finalList
                    const approverIndex = finalList.findIndex(d => d.id === finalApproverNode.id)
                    if (approverIndex > -1) {
                        const [approver] = finalList.splice(approverIndex, 1);

                        // keep Admin separately if exists
                        const adminIndex = finalList.findIndex(d => d.type === 9);
                        let adminNode = null;
                        if (adminIndex > -1) {
                            [adminNode] = finalList.splice(adminIndex, 1);
                        }

                        if (approvalNodes?.length === 2 && approvalNodes?.some(node => node.type === 11) && approvalNodes?.some(node => node.type === 12)) {
                            finalList = [approver, ...(adminNode ? [adminNode] : []), ...finalList.reverse()] // keep recent first
                        }
                        else {
                            // build new order → FinalApprover → Admin → rest
                            finalList = [approver, ...(adminNode ? [adminNode] : []), ...finalList.reverse()].reverse(); // keep recent first
                        }
                        // return finalList;
                    }
                }

            }
        }

        // check for missing person which person data is not in approvalnode
        if (skippedApproval?.length) {

            let reverseSkippedApproval = skippedApproval?.reverse()
            reverseSkippedApproval?.forEach(data => {
                data.ispastapproval = true
                finalList.unshift(data)
            })
        }

        return finalList
    }

    //priyanshi for recalculate payroll -> formData -> salarydata
    createOverridePayload(formData) {
        const payload = {};

        // All regular keys

        const allKeys = [...Config.pfkeys, ...Config.tdskeys, ...Config.esickeys, ...Config.lwfkeys, ...Config.ptkeys]

        allKeys?.forEach(key => {
            const overrideKey = 'override' + key
            const isOverrideFlag = 'isoverride' + key

            // Use override value if flag is true and override value exists, otherwise use regular value
            if (formData[isOverrideFlag]) {
                payload[key] = formData[key]
            }
        })

        const arrayConfig = [
            { arrayName: 'headerbonustobepaid', overrideKey: 'overrideheaderbonusamount', flagKey: 'isoverrideheaderbonusamount' },
            { arrayName: 'bonusdata', overrideKey: 'overrideamount', flagKey: 'isoverrideamount' }
        ]

        // Process arrays with override logic
        arrayConfig.forEach(config => {
            if (formData[config.arrayName] && Array.isArray(formData[config.arrayName])) {
                // Check if any item in array has override flag true
                const hasOverride = formData[config.arrayName].some(item => item[config.flagKey])

                // Only add array to payload if it has at least one override flag true
                if (hasOverride) {
                    payload[config.arrayName] = formData[config.arrayName]
                }
            }
        })

        return payload
    }

    /**
     * Renders message template display with verification status
     * @param {Object} data - The message template data object
     * @param {Object} fieldobj - The field object
     * @param {string} key - The key to display (e.g., 'status')
     */
    renderMessageTemplateDisplay(data, fieldobj, key, badge = false, badgeText) {   //  | Deep Dungarani  ~ 2025-07-17
        if (data[key] === 0) {
            return (
                <div className='d-flex align-items-center gap-10'>
                    <span>{data[fieldobj.masterdatafield]}</span>
                    {badge && <span className="badge badge-warning">{badgeText}</span>}
                </div>
            );
        }
        else {
            return <span>{data[fieldobj.masterdatafield]}</span>;
        }
    }

    // for placement drive, Resource Request -> interviewprocessdata | Deep Dungarani ~ 2025-07-18
    getinterviewprocess(interviewprocessdata) {
        return IISMethods.getobjectfromarray(interviewprocessdata, 'positionid', IISMethods.getobjectfromarray(interviewprocessdata, 'isdefault', 1)?.positionid)
    }

    // isnavigate = 1 for redirect to employee 360 profile
    // isnavigate = 0 for redirect to application history modal
    // isnavigate = 2 for redirect to employee 360 profile in new tab
    // Common function for handling redirect from employee code | Deep Dungarani ~ 2025-07-28
    async handleRedirectFromEmployeeCode(data, fromApplicationhistoryModal = false, props, navigate, isnavigate) {
        if (isnavigate === 1) {
            this.getCurrentState().redirectItem = { ...data }
            navigate(`/${Config.aliasname['employeeprofileoverviewalias']}`)
        }
        else if (isnavigate === 2) {
            const id = data?._id
            const basePath = `/${Config.aliasname['employeeprofileoverviewalias']}`
            const url = `${basePath}?id=${encodeURIComponent(id)}`
            window.open(url, '_blank')
        }
        else {
            // Redirect from application history modal
            if (fromApplicationhistoryModal) {
                const tempItem = {
                    body: {
                        appliedforid: data.appliedforid,
                        candidatename: data.name,
                        candidateid: data._id,
                    }
                }

                this.getCurrentState().redirectPagename = Config.aliasname['openingmasteralias']
                this.getCurrentState().redirectItem = tempItem
                this.getCurrentState().redirectFromNotification = 1

                await props.setProps({
                    redirectPagename: this.getCurrentState().redirectPagename,
                    redirectItem: this.getCurrentState().redirectItem,
                    redirectFromNotification: this.getCurrentState().redirectFromNotification
                });

                return navigate(`/${this.getCurrentState().redirectPagename}`)
            }

            // Redirect to employee profile
            if (data.isemployee == 1) {
                const employeeData = { ...data, alias: Config.aliasname['candidatelistalias'] };
                this.getCurrentState().redirectItem = employeeData;
                return navigate(`/${Config.aliasname['employeeprofileoverviewalias']}`);
            }

            // Default redirect to opening master
            const tempItem = {
                body: {
                    appliedforid: data.appliedforid,
                    candidatename: data.name,
                    candidateid: data._id,
                }
            };

            this.getCurrentState().redirectPagename = Config.aliasname['openingmasteralias']
            this.getCurrentState().redirectItem = tempItem
            this.getCurrentState().redirectFromNotification = 1

            await props.setProps({
                redirectPagename: this.getCurrentState().redirectPagename,
                redirectItem: this.getCurrentState().redirectItem,
                redirectFromNotification: this.getCurrentState().redirectFromNotification
            });

            navigate(`/${this.getCurrentState().redirectPagename}`)
        }
    }

    // function to check in document url wheather there is "temp" include or not | Nirzar Gabani 💀 ~  2025-07-29 ~ 02:58 PM
    /**
     * function to check in document url wheather there is "temp" include or not
     * @param {string} url - url for check "temp" include or not
     */
    containsTempInURL(url) {
        return url?.includes("/temp/");
    }

    // Helper function to generate pre-signed URL if needed | Nirzar Gabani 💀 ~  2025-07-29 ~ 05:11 PM
    /**
     * function to generate pre-signed URL if needed
     * @param {string} url - url for generate pre-signed url
     */
    async getPresignedUrlIfNeeded (url) {
        if (!url) return ''
        
        // Only generate pre-signed URL if "temp" is not in the URL
        if (!IISMethods.containsTempInURL(url)) {
            const presignedURL = await IISMethods.getPresignedS3URL(url)
            return presignedURL
        }
        return url
    }

    // function for redirect to letters in new page | Nirzar Gabani 💀 ~  2025-07-30 ~ 06:27 PM
    /**
     * function to generate pre-signed URL if needed
     * @param {string} url - url for generate pre-signed url
     */
    async generateShareLink (url) {
        const loginInfo = IISMethods.getCookiesData("loginInfo")
        // get file name from url
        let tempfilename = IISMethods.getFileName(url)
        let fileName = tempfilename?.slice(1, tempfilename?.length)
        // generate pre-signed url
        const finalpresignedURL = await IISMethods.getPresignedUrlIfNeeded(url)
        // encode finalpresignedURL
        const encryptletterUrl = IISMethods.encryptData(finalpresignedURL, true)
        const encodedletterUrl = encodeURIComponent(encryptletterUrl)
        // encode filename
        const encryptfilename = IISMethods.encryptData(fileName, true)
        const encodedfilename = encodeURIComponent(encryptfilename)

        const redirectURL = `${window.location.origin}/${Config.pagenamelist['shareroute']}/${loginInfo.uid}/${encodedletterUrl}/${encodedfilename}/${true}`
        window.open(redirectURL, '_blank')
    }
    /**
     * check view only rights From Approval Hierarchy Tree
     * @param {Object} data - data object
     * @returns {Boolean}
     */
    checkViewOnlyRights(data, viewonly = false) { //  | Deep Dungarani  ~ 2025-08-28
        const loginInfo = IISMethods.getCookiesData("loginInfo")
        let currentviewonlystatus = false
        if (viewonly) {
            data.approvalnode = data.approvalnode?.filter(node => node.viewonly !== 1)
        }
        const checkapprovalnode = this.getobjectfromarray(data.approvalnode, 'id', loginInfo.uid)
        if (checkapprovalnode && checkapprovalnode.viewonly) {
            currentviewonlystatus = true
        }

        return currentviewonlystatus
    }

    getLetterType(type) {
        let lettertypename = ''
        if (type === 1) {
            lettertypename = Config.aggrementLetterLabel
        }
        else if (type === 2) {
            lettertypename = Config.appoinmentLetterLabel
        }
        else if (type === 3) {
            lettertypename = Config.offerLetterLabel
        }
        else if (type === 4) {
            lettertypename = Config.otherLetterLabel
        }
        return lettertypename
    }

    getCurrencySymbol(currencyCode, name = false) { //  | Deep Dungarani  ~ 2025-09-12 ~ 02:56 PM
        const formatter = new Intl.NumberFormat('en', {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: name ? 'name' : 'symbol',
        })

        // Extract the currency symbol from formatted output
        const currencySymbol = formatter.formatToParts(100)?.find(part => part.type === 'currency')?.value

        return currencySymbol || ''
    }

    createConvertedRightSidebarFormData(rightSidebarFormData, field, removeistablefield = true) {
        // Create a converted RightSidebar to handle validation for table fields 
        // | Deep Dungarani  ~ 2025-09-09 ~ 12:37 PM
        let convertedRightSidebarFormData = [{
            rightsidebarsize: Config.getModalsizeclasses()['md'],
            formfields: []
        }]

        // get table field definition
        const rightSidebarfield = JsCall.getobjectfromformdata(
            rightSidebarFormData,
            field
        )

        if (rightSidebarfield?.tablefield?.length) {
            // collect all formfields that match tablefield list
            const allFormFields = rightSidebarFormData
                .flatMap(section => section.formfields) // flatten all formfields from all sections
                .filter(f => rightSidebarfield.tablefield.includes(f.field)) // only pick fields mentioned in tablefield
                .map(f => {
                    if (removeistablefield) {
                        const { istablefield, ...rest } = f
                        return rest
                    }
                    return f
                })

            convertedRightSidebarFormData[0].formfields.push(...allFormFields)
        }

        return convertedRightSidebarFormData
    }

    /**
     * Sorts formfields inside each tab by rightsidebardisplayorder. | Deep Dungarani  ~ 2025-10-03
     * Fields without rightsidebardisplayorder are placed last (preserves relative order).
     * rightsidebardisplayorder : Controls the order of field rendering in the right sidebar (ascending order).
     * @param {Array} rightsidebar - array of tab objects
     * @returns {Array} newRightSidebar - a new array where each tab.formfields is sorted
     */
    orderRightSidebar(rightsidebar) {
        if (!Array.isArray(rightsidebar)) return []

        return rightsidebar?.map(tab => {
            const fields = Array.isArray(tab.formfields) ? [...tab.formfields] : []

            fields.sort((a, b) => {
                const oa = a.rightsidebardisplayorder ?? Number.MAX_SAFE_INTEGER
                const ob = b.rightsidebardisplayorder ?? Number.MAX_SAFE_INTEGER
                return oa - ob
            })

            // return a shallow copy of tab with sorted fields (non-mutating)
            return { ...tab, formfields: fields }
        })
    }

    /**
     * Retrieves the index of a specific field from the RightSidebarFormData based on the provided field name.
    * Useful for locating a field's position inside the right sidebar tab configuration.
    *
    * @param {string} value - The field name to search for.
    * @param {number} tab - The index of the tab to search within (default: 0).
    * @returns {number} The index of the field within the specified tab's formfields array, or -1 if not found.
    *
    * | Deep Dungarani  ~ 2025-10-03
    */
    getIndexFromRightsidebar(RightSidebarFormData, field, tab = 0) { // use to find index from rightsidebarformdata | Deep Dungarani  ~ 2025-10-03
        if (!RightSidebarFormData?.[tab]?.formfields) {
            return -1
        }

        return IISMethods.getindexfromarray(RightSidebarFormData[tab].formfields, 'field', field)
    }

    /**
     * Retrieves the master data name (or field reference) for a given field within a specific right sidebar tab.
     * If the field is configured with 'storemasterdatabyfield', it returns the field name itself.
     * Otherwise, it returns the associated masterdata key.
     *
     * @param {string} value - The field name whose master data reference is required.
     * @param {number} tab - The index of the tab to look into (default: 0).
     * @returns {string|undefined} The masterdata key or field name based on configuration, or undefined if not found.
     *
     * | Deep Dungarani  ~ 2025-10-03
     */
    getMasterDataName(candidateRightSidebarFormData, value, tab = 0) {
        return candidateRightSidebarFormData?.[tab]?.formfields[IISMethods.getIndexFromRightsidebar(candidateRightSidebarFormData, value)]?.storemasterdatabyfield ? candidateRightSidebarFormData?.[tab]?.formfields[IISMethods.getIndexFromRightsidebar(candidateRightSidebarFormData, value)]?.field : candidateRightSidebarFormData?.[tab]?.formfields[IISMethods.getIndexFromRightsidebar(candidateRightSidebarFormData, value)]?.masterdata
    }

    // Create right sidebar form data structure for validation and rendering || Deep Dungarani
    createRightsidebarFormDataStructure(field, size) {
        // Get modal size class (default to 'md' if not provided)
        const sidebarSizeClass = Config.getModalsizeclasses()[size ? size : 'md'];

        // Prepare right sidebar form structure with single field
        const convertedRightSidebarFormData = [
            {
                rightsidebarsize: sidebarSizeClass, // modal width
                formfields: [field] // form fields with validation config
            }
        ];

        // Return formatted data for sidebar form
        return convertedRightSidebarFormData;
    }

    /**
     * Downloads one or multiple document files (images, PDFs, etc.)
     * from S3 or another source, either as individual downloads or in a ZIP.
     *
     * @param {string | object | array} documentUrls 
     *   → The document(s) to download.
     *   Supported formats:
     *     1️⃣ Single URL (string)
     *        Example: "https://.../file.jpg"
     *     2️⃣ Array of URLs (string[])
     *        Example: ["https://.../file1.jpg", "https://.../file2.jpg"]
     *     3️⃣ Object with front/back URLs
     *        Example: { fronturl: "https://.../front.jpg", backurl: "https://.../back.jpg" }
     *     4️⃣ Array of objects (for multiple documents)
     *        Example: [
     *           { fronturl: "https://.../pan_front.jpg", backurl: "https://.../pan_back.jpg" },
     *           { fronturl: "https://.../aadhar_front.jpg" }
     *        ]
     *
     * @param {string} documentname 
     *   → The base name of the document (used in downloaded file name).
     *   Example: "PanCard" → output "PanCard_FrontFile.jpg"
     *   Default = "Document"
     *
     * @param {string} documentside 
     *   → Optional fixed label for file side ("FrontFile" or "BackFile").
     *   If not provided, it is auto-detected from URL keywords ("front"/"back").
     *   Example: documentside = "FrontFile"
     *
     * @param {boolean} createzip 
     *   → Whether to combine multiple files into a single ZIP.
     *   true  → creates ZIP (Documents.zip)
     *   false → downloads files one by one directly.
     */
    async handleDocumentDownload(documentUrls, documentname = "", documentside = "", createzip = false) {
        try {
            // Show loading overlay and update status message
            document.getElementById("global-overlay")?.classList.add("show")
            document.getElementById("global-overlay-message").innerHTML = createzip
                ? "Downloading Document(s)..."
                : "Downloading Document..."

            // Normalize to array (ensures consistent handling whether single or multiple URLs)
            const urlsArray = Array.isArray(documentUrls) ? documentUrls : [documentUrls]
            const zip = new JSZip() // For bundling multiple files together in a ZIP
            let docIndex = 1
            let successCount = 0 // Tracks how many files successfully downloaded

            for (const doc of urlsArray) {
                // If the document object has both front and back URLs, include both
                // filter(Boolean) removes falsy values (null, undefined, empty string)
                // → avoids errors when one side (front/back) is missing
                const urlList =
                    typeof doc === "object"
                        ? [doc.fronturl, doc.backurl].filter(Boolean)
                        : [doc]

                for (const rawUrl of urlList) {
                    try {
                        // Skip empty or invalid URLs
                        // continue = immediately jump to next iteration instead of throwing an error
                        if (!rawUrl) continue

                        // Get pre-signed S3 URL if needed
                        // const presignedUrl = await this.getPresignedUrlIfNeeded(rawUrl)
                        const presignedUrl = rawUrl

                        // If pre-signed URL generation fails or returns empty, skip this file
                        // continue ensures the loop keeps going without breaking the entire process
                        if (!presignedUrl) continue

                        // Fetch the actual file blob
                        const response = await fetch(presignedUrl, { mode: "cors" })

                        // If file fetch fails (e.g., 403 or 404), skip to the next URL instead of throwing
                        if (!response.ok) continue

                        const blob = await response.blob()

                        // Detect and normalize file extension
                        const decodedName = presignedUrl.split("/").pop() || ""
                        let extFromUrl = decodedName.split(".").pop()?.toLowerCase()
                        if (!extFromUrl || extFromUrl.length > 5) {
                            extFromUrl = blob.type.split("/")[1] || "file"
                        }

                        // Identify whether it's a front or back image automatically
                        let sideLabel = documentside
                        const lowerUrl = rawUrl.toLowerCase()
                        if (!sideLabel) {
                            if (lowerUrl.includes("front")) sideLabel = "FrontFile"
                            else if (lowerUrl.includes("back")) sideLabel = "BackFile"
                        }

                        // Clean document name (remove spaces)
                        const cleanDocName = (documentname || "Document").replace(/\s+/g, "")
                        const prefix = createzip ? `${cleanDocName}${docIndex}` : cleanDocName
                        const fileName = `${prefix}_${sideLabel || "File"}.${extFromUrl}`.trim()

                        // Either add file to ZIP or download immediately
                        if (createzip) {
                            zip.file(fileName, blob) // Add to ZIP archive
                            successCount++
                        } else {
                            const blobUrl = window.URL.createObjectURL(blob)
                            const link = document.createElement("a")
                            link.href = blobUrl
                            link.download = fileName
                            document.body.appendChild(link)
                            link.click()
                            document.body.removeChild(link)
                            window.URL.revokeObjectURL(blobUrl)

                            successCount++
                            this.localnotify(Config.errmsg.documentdownloadsuccessfully, 1)
                        }
                        docIndex++
                    } catch (innerErr) {
                        // Log file-specific errors but continue downloading others
                        console.error("Failed to add file:", innerErr)
                    }
                }

                // Increment index per document in ZIP mode
            }

            // Final ZIP creation and success/error notifications
            if (createzip) {
                if (successCount > 0) {
                    const zipBlob = await zip.generateAsync({ type: "blob" })
                    saveAs(zipBlob, `${(documentname || "Documents").replace(/\s+/g, "")}.zip`)
                    this.localnotify(Config.errmsg.documentsdownloadsuccessfully, 1)
                } else {
                    this.localnotify(Config.errmsg.failedtodownloaddocuments, 2)
                }
            } else if (successCount === 0) {
                this.localnotify(Config.errmsg.failedtodownloaddocument, 2)
            }

        } catch (err) {
            // Handles unexpected failures in outer try block
            this.localnotify(createzip ? Config.errmsg.failedtodownloaddocuments : Config.errmsg.failedtodownloaddocument, 2)
            console.error("File download failed:", err)
        } finally {
            // Always remove loading overlay
            document.getElementById("global-overlay")?.classList.remove("show")
        }
    }

    getChangeableData(approvaldata) {
        let eligibleRecords = []
        const approvalData = JSON.parse(JSON.stringify(approvaldata))

        approvalData?.map(data => {
            const approvalRights = IISMethods.checkApproveRejectRights(data, true)

            const person = approvalRights?.personData
            const canChange = approvalRights?.canApprove && !approvalRights?.finalApprove && (!person?.status || person?.status === 0) && (!person?.viewonly || person?.viewonly === 0)

            if (canChange) {
                eligibleRecords.push(data)
            }
        })

        return eligibleRecords
    }

    /**
     * Get the position (tab index and field index) of a form field
     * from RightSidebarFormData.
     *
     * @param {Array} RightSidebarFormData - Array of tab objects with formfields
     * @param {String} field - The 'field' name to search for
     *
     * @returns {Object} - Example:
     * {
     *   tabIndex: 0,              // Index of tab where the field is found
     *   fieldIndex: 1,            // Index of field within that tab
     *   tabName: "Overview",      // Tab's name
     *   fieldData: {...}          // Actual field object
     * }
     *
     * Returns { tabIndex: -1, fieldIndex: -1, tabName: null, fieldData: null } if not found
     */
    getFieldPositionFromRightSidebar(rightSidebarFormData, field) { //  | Deep Dungarani  ~ 2025-11-13
        for (let tabIndex = 0; tabIndex < rightSidebarFormData.length; tabIndex++) {
            const tabData = rightSidebarFormData[tabIndex]
            const fieldIndex = IISMethods.getindexfromarray(tabData.formfields, 'field', field)

            if (fieldIndex !== -1) {
                return {
                    tabIndex,
                    fieldIndex,
                    tabName: tabData.tabname || null,
                    fieldData: tabData.formfields[fieldIndex]
                }
            }
        }

        return {
            tabIndex: -1,
            fieldIndex: -1,
            tabName: null,
            fieldData: null
        }
    }


}

export var IISMethods = new _IISMethods()